{
  "meta": {
    "title": "BuddyPro Launchpad"
  },
  "common": {
    "brandAlt": "BuddyPro",
    "loading": "Načítám...",
    "error": "Něco se zaseklo. Zkus to prosím znovu.",
    "actionError": {
      "questionnaire_locked": "Tenhle krok se zatím neotevřel. Dokonči krok před ním a dotazník se odemkne sám.",
      "profile_confirmation_required": "Nejdřív si projdi svůj profil a potvrď ho. Dotazník se pak otevře.",
      "too_many_accounts": "Víc účtů už přidat nejde, šest je strop. Napiš parťákovi, který účet vyměnit.",
      "capacity_reached": "Volná místa pro kolegy jsou vyčerpaná. Zruš čekající pozvánku, nebo napiš parťákovi.",
      "state_conflict": "Tenhle krok se mezitím posunul. Načti stránku znovu a uvidíš, kde teď je.",
      "salespage_approval_required": "Nejdřív je potřeba schválit prodejní stránku. Otevři krok Prodejní stránka a projdi ji.",
      "trial_not_ready": "Zkušební Buddy zatím není připravený. Připravujeme ho a dáme ti vědět.",
      "tester_before_transfer": "Za testera to půjde poslat, až bude bot tvůj. Zatím to pošli za sebe.",
      "duns_required": "Nejdřív potvrď číslo D-U-N-S. Bez něj Apple registraci nepustí.",
      "invalid_request": "Něco ve formuláři nesedí. Zkontroluj vyplněná pole a odešli to znovu.",
      "forbidden": "Tuhle akci nemůžeš udělat ty. Napiš parťákovi, ať ji udělá za tebe.",
      "not_found": "Tohle už tu není. Načti stránku znovu.",
      "rate_limited": "Přišlo moc pokusů za sebou. Počkej chvíli a zkus to znovu.",
      "server": "Server teď odpověď nevrátil. Zkus to prosím za chvíli znovu.",
      "offline": "Vypadá to na výpadek připojení. Zkontroluj internet a zkus to znovu.",
      "generic": "Něco se zaseklo. Zkus to prosím znovu.",
      "owner_role_pending": "Roli majitele ti ještě nastavujeme. Jakmile bude hotová, dáme ti vědět a krok 3 dokončíš.",
      "ownership_transferred": "Správcovství instance je předané. Instanci už nastavovat nemůžeme, spravuješ si ji {{g:sám|sama}}."
    },
    "retry": "Zkusit znovu",
    "logout": "Odhlásit se",
    "backHome": "Zpět na přehled",
    "languageLabel": "Jazyk rozhraní",
    "languageCs": "Čeština",
    "languageEn": "English",
    "close": "Zavřít",
    "cancel": "Zrušit"
  },
  "login": {
    "eyebrow": "Buddy na klíč",
    "title": "Tady začíná tvůj vlastní Buddy",
    "description": "Zadej svůj e-mail a pošleme ti přihlašovací odkaz.",
    "emailLabel": "E-mail",
    "emailPlaceholder": "tvuj@email.cz",
    "submit": "Poslat přihlašovací odkaz",
    "submitting": "Posílám odkaz...",
    "accepted": "Do minuty ti přijde e-mail: buď s přihlašovacím odkazem, nebo se zprávou, že k téhle adrese účet nemáš. Nic nepřišlo? Zkontroluj, jestli je adresa napsaná správně.",
    "privacy": "Kvůli bezpečnosti neprozradíme, jestli je e-mail v systému.",
    "tryAnother": "Zadat jiný e-mail"
  },
  "landing": {
    "loginEyebrow": "Tvůj Launchpad",
    "loginTitle": "Pokračuj k vlastnímu Buddymu",
    "loginDescription": "Otevři Launchpad a podívej se, co tě čeká.",
    "loginSubmit": "Otevřít Launchpad",
    "inviteEyebrow": "Pozvánka do týmu",
    "inviteTitle": "Přidej se do Launchpadu",
    "inviteDescription": "Po přijetí můžeš klienta zastupovat při stavbě Buddyho. Pozvánky, cenu a převzetí dál spravuje vlastník.",
    "inviteSubmit": "Přijmout pozvánku",
    "clientLabel": "Vyber klienta",
    "signingIn": "Přihlašujeme tě...",
    "invalid": "Tento odkaz není platný.",
    "unavailable": "Odkaz už nejde použít. Vyžádej si nový.",
    "clientUnavailable": "Odkaz už neplatí. Mohl vypršet, být použitý nebo zrušený. Napiš svému parťákovi, pošle ti nový.",
    "clientLinkExpiredStep": "Odkaz z e-mailu už neplatí. Přihlas se svým e-mailem a otevřeme ti přesně to místo, kam odkaz vedl.",
    "errorEyebrow": "Přihlášení se nepovedlo",
    "supersededEyebrow": "Přihlášení",
    "supersededTitle": "Tenhle odkaz nahradila novější zpráva",
    "supersededCopy": "Poslali jsme ti novější přihlašovací odkaz a ten starší tím přestal platit. Otevři ve schránce nejnovější zprávu od nás a přihlas se odkazem z ní.",
    "errorTitle": "Tento odkaz se nepodařilo otevřít",
    "errorSecurity": "Formulář jsme nemohli ověřit. Otevři původní odkaz a zkus to znovu.",
    "errorRateLimited": "Proběhlo příliš mnoho pokusů. Zkus to znovu za chvíli.",
    "errorGeneric": "Přihlášení se nepovedlo. Otevři původní odkaz a zkus to znovu.",
    "errorBack": "Zpět na přihlášení"
  },
  "unlock": {
    "eyebrow": "Odemčení dalšího kroku",
    "title": "Kód je připravený",
    "description": "Nejdřív se přihlas do Launchpadu. Po přihlášení tě sem vrátíme a kód potvrdíš jedním kliknutím.",
    "open": "Otevřít Launchpad",
    "confirmTitle": "Potvrď kód z hovoru",
    "confirmDescription": "Kód odemkne další krok pro tento účet:",
    "confirmSubmit": "Odemknout další krok",
    "backHome": "Zpět do Launchpadu",
    "staffTitle": "Máš přihlášení člena týmu",
    "staffDescription": "Kód z hovoru může potvrdit jen klient. Otevři konzoli a použij Otevřít jako klient, nebo se přihlas klientským účtem.",
    "unavailableTitle": "Tento kód už neplatí",
    "unavailableDescription": "Kód byl zneplatněný nebo mu vypršela platnost. Řekni si týmu o nový.",
    "errorTitle": "Kód se nepodařilo použít",
    "errorUnauthorized": "Tvé přihlášení mezitím vypršelo. Otevři Launchpad, přihlas se a zadej kód znovu.",
    "errorConflict": "Tento kód teď nejde použít. Aktuální krok najdeš v Launchpadu.",
    "errorImpersonation": "V náhledu za klienta nejde kód potvrdit. Vrať se do konzole a přihlas se klientským účtem.",
    "openingTitle": "Otevíráme ti další krok",
    "openingDescription": "Za chvíli uvidíš, co tě čeká a co bude potřeba udělat.",
    "kind": {
      "onboarding": "Úvodní video",
      "marketing": "Marketingové video"
    },
    "globalStaffTitle": "Tohle býval odemykací odkaz z hovoru",
    "globalStaffDescription": "Klientům už krok neotevírá: úvodní i marketingový krok se odemykají zhlédnutím videa přímo v Launchpadu.",
    "globalAdminHint": "Heslo v odkazu měníš v Servisu, v sekci Odkaz na krok hovoru.",
    "globalAheadTitle": "Tenhle hovor už máš za sebou",
    "globalAheadDescription": "Krok, který se tímhle odkazem otevírá, už máš otevřený. V Launchpadu najdeš, co je teď na tahu.",
    "globalEarlyTitle": "Tenhle odkaz patří k pozdějšímu hovoru",
    "globalEarlyDescription": "Odkaz otevírá krok, na který zatím nejsi. Otevři Launchpad a uvidíš, co je na řadě teď.",
    "videoGateTitle": "Tenhle krok se otevírá videem",
    "videoGateDescription": "Skupinové hovory jsme zrušili. Krok se ti otevře přímo v Launchpadu, jakmile dokoukáš video k místu, kde se otevírá další krok.",
    "videoGateOpen": "Otevřít video v Launchpadu"
  },
  "dashboard": {
    "eyebrow": "BuddyPro Launchpad",
    "title": "Tvůj proces je připravený",
    "description": "V dalších krocích tu uvidíš, co je na řadě a na čem pracuje tým.",
    "signedInAs": "Přihlášený účet",
    "processLabel": "Průběh",
    "accessStep": "Přístup",
    "accessDone": "Hotovo",
    "processStep": "Proces",
    "processNext": "Připraveno",
    "deliveryStep": "Předání",
    "deliveryLocked": "Později",
    "mainLabel": "Aktuální stav",
    "mainTitle": "Máš přístup. Můžeme začít.",
    "mainCopy": "Další obsah se odemkne podle společného procesu. Teď po tobě nic dalšího nepotřebujeme.",
    "workingTitle": "Tým připravuje další krok",
    "workingCopy": "Jakmile bude připravený, uvidíš ho tady a dostaneš e-mail.",
    "contextLabel": "Kontext",
    "switchLabel": "Přepnout klienta",
    "switchSubmit": "Přepnout",
    "switching": "Přepínám...",
    "sessionLabel": "Bezpečnost",
    "skipLabel": "Rychlé přeskočení",
    "skipToContent": "Přeskočit na obsah",
    "skipToAccount": "Přeskočit na upozornění a účet"
  },
  "closedStep": {
    "continue": "Otevřít další krok",
    "nextLead": "Další na řadě:",
    "journeyComplete": "Všechny kroky máš za sebou.",
    "steps": {
      "onboarding_call": {
        "title": "Úvod máš za sebou.",
        "benefit": "Máme společný kontext a víme, co má tvůj Buddy splnit."
      },
      "profile": {
        "title": "Tvůj profil je hotový.",
        "benefit": "Buddy teď vychází z ověřeného popisu tebe a tvé práce."
      },
      "apple": {
        "title": "První kroky k aplikaci máš hotové.",
        "benefit": "Aplikaci můžeme připravovat pro účet, který patří tobě."
      },
      "q1": {
        "title": "Dotazník k přípravě Buddyho máš vyplněný.",
        "benefit": "Tvoje odpovědi máme uložené a můžeme z nich stavět Buddyho."
      },
      "knowhow": {
        "title": "Know-how máš kompletní.",
        "benefit": "Podklady jsou připravené pro první trénink."
      },
      "training": {
        "title": "Trénink Buddyho je hotový.",
        "benefit": "První verze Buddyho je připravená k vyzkoušení."
      },
      "beta": {
        "title": "Testery máš pozvané.",
        "benefit": "Odkaz pro testery i chat s Buddym zůstávají otevřené, pozvat můžeš další."
      },
      "feedback": {
        "title": "První kolo zpětné vazby máš za sebou.",
        "benefit": "Podněty z testování máme zapracované.",
        "ownershipBenefit": "Správcovství instance je předané, spravuješ si ji {{g:sám|sama}}."
      },
      "marketing_call": {
        "title": "Marketingovou přípravu máš za sebou.",
        "benefit": "Máme jasno v nabídce i v cestě k prvním zákazníkům."
      },
      "q2": {
        "title": "Dotazník k prodeji máš vyplněný.",
        "benefit": "Podklady pro prodejní materiály máme uložené."
      },
      "strategy": {
        "title": "Prodejní strategie je schválená.",
        "benefit": "Další materiály teď vznikají podle potvrzeného směru."
      },
      "salespage": {
        "title": "Prodejní stránka je hotová.",
        "benefit": "Schválená, s odkazy na objednávku a publikovaná. Vracet se k ní můžeš dál."
      },
      "payments": {
        "title": "Platby jsou nastavené.",
        "benefit": "Předplatné od zákazníků chodí přímo na tvůj Stripe."
      },
      "emails": {
        "title": "E-mail marketing je připravený.",
        "benefit": "Kampaň má hotové zprávy pro tvoje publikum."
      },
      "webinar": {
        "title": "Struktura webináře je připravená.",
        "benefit": "Máš jasnou osnovu, podle které můžeš webinář odvysílat."
      },
      "stripe": {
        "title": "Stripe je propojený.",
        "benefit": "Platby za Buddyho mohou chodit přímo tobě."
      },
      "app_questionnaire": {
        "title": "Dotazník k aplikaci máš vyplněný.",
        "benefit": "Máme všechny údaje potřebné pro přípravu aplikace."
      },
      "salespage_publish": {
        "title": "Prodejní stránka je venku.",
        "benefit": "Zákazníci už mohou tvoji nabídku otevřít."
      },
      "handover": {
        "title": "Buddy je oficiálně tvůj.",
        "benefit": "Přístupy a podklady máš pod svou kontrolou."
      },
      "app_release": {
        "title": "Tvoje aplikace je venku.",
        "benefit": "Odkazy do obou obchodů jsou připravené ke sdílení."
      }
    }
  },
  "home": {
    "eyebrow": "Tvůj postup",
    "title": "Připravíme Buddyho, který prodává",
    "overviewLabel": "Přehled procesu",
    "primaryEyebrow": "Teď je na řadě",
    "currentStep": "Aktuální krok",
    "waiting": "Teď pracuje tým",
    "waitingCopy": "Jakmile budeme něco potřebovat, objeví se tu jeden jasný další krok.",
    "openHome": "Otevřít přehled",
    "unlockedTitle": "A jedeš dál!",
    "unlockedQ1": "Kód platí. Dotazník o tobě a tvém byznysu je odemčený, můžeš rovnou začít.",
    "unlockedQ2": "Kód platí. Marketingový dotazník je odemčený, můžeš rovnou začít.",
    "unlockedAlready": "Tento kód už odemkl další krok. Aktuální krok vidíš níže.",
    "welcomeTitle": "Tady začíná náš společný postup",
    "welcomeIntro": "Čeká nás cesta ve dvou kapitolách: nejdřív společně připravíme tvého Buddyho, pak jeho prodej. Další krok se ti otevře vždy, když dokončíme ten předchozí.",
    "welcomeIntroCollaborator": "Čeká nás cesta ve dvou kapitolách: příprava Buddyho a příprava prodeje. Další krok se otevře vždy, když se dokončí ten předchozí. Pomáháš s přípravou a na konci bude Buddy připravený k prodeji.",
    "welcomeCta": "Jdeme na to",
    "returningTitle": "Vítej zpátky",
    "returningIntro": "Tvoje dosavadní práce je uložená. Teď můžeš pokračovat tam, kde skončila: {step}.",
    "returningIntroCollaborator": "Dosavadní práce je uložená. Pokračuj tam, kde skončila: {step}.",
    "returningCta": "Pokračovat",
    "workingEyebrow": "Pracujeme na tom",
    "working": {
      "q1": {
        "title": "Stavíme základy Buddyho",
        "copy": "Procházíme tvé odpovědi a převádíme je do zadání, podle kterého připravíme Buddyho."
      },
      "training": {
        "title": "Trénujeme Buddyho",
        "copy": "Učíme Buddyho tvé know-how, ladíme jeho hlas a chování a potom ho připravíme k prvnímu testování."
      },
      "beta": {
        "title": "Zapracováváme tvé podněty",
        "copy": "Procházíme výsledky testování, upravujeme Buddyho podle tvých podnětů a potom ověříme, že vše funguje správně."
      },
      "q2": {
        "title": "Zpracováváme prodejní zadání",
        "copy": "Procházíme tvé prodejní zadání, hledáme nejsilnější argumenty a připravujeme podklady pro celý prodejní balíček."
      },
      "sales": {
        "title": "Tvoříme prodejní balíček",
        "copy": "Připravujeme audit, prodejní strategii, stránku, e-maily i avatara a potom vše spojíme do jednoho funkčního celku."
      },
      "handover": {
        "title": "Dokončujeme předání",
        "copy": "Nastavujeme ti roli majitele, připravujeme přístupy a kontrolujeme poslední detaily pro bezpečné převzetí."
      },
      "knowhow": {
        "title": "Teď pracuje tým",
        "copy": "Jakmile budeme něco potřebovat, objeví se tu jeden jasný další krok."
      },
      "onboarding_call": {
        "title": "Teď pracuje tým",
        "copy": "Jakmile budeme něco potřebovat, objeví se tu jeden jasný další krok."
      },
      "marketing_call": {
        "title": "Teď pracuje tým",
        "copy": "Jakmile budeme něco potřebovat, objeví se tu jeden jasný další krok."
      },
      "stripe": {
        "title": "Propojujeme platby",
        "copy": "Nastavujeme Stripe tak, aby předplatná od zákazníků chodila přímo na tvůj účet."
      }
    },
    "guide": {
      "step2Title": "Tvůj postup krok za krokem",
      "step2Copy": "Vlevo vidíš celý svůj postup. Další kroky se odemknou, jakmile společně dokončíme ty předchozí.",
      "step3Title": "Tvůj parťák je vždycky nablízku",
      "step3Copy": "Vpravo najdeš svého parťáka. Ozvi se mu, kdykoliv si nebudeš vědět rady, co udělat dál.",
      "step4Title": "Začni ještě dnes",
      "step4Copy": "Dole najdeš první úkoly, do kterých se můžeš pustit hned. Každý z nich posune Buddyho blíž ke spuštění.",
      "next": "Další",
      "back": "Zpět",
      "skip": "Přeskočit",
      "step2CopyMobile": "Celý svůj postup najdeš v rozbalovacím menu nahoře. Další kroky se odemknou, jakmile společně dokončíme ty předchozí.",
      "step3CopyMobile": "Kartu svého parťáka najdeš pod obsahem stránky. Ozvi se mu, kdykoliv si nebudeš vědět rady, co udělat dál.",
      "step4CopyMobile": "Aktuální úkol máš přímo v hlavní ploše. Každý splněný posune Buddyho blíž ke spuštění."
    },
    "phaseTitles": {
      "onboarding_call": "Nejdřív poznáme tebe i tvůj byznys",
      "q1": "Dej Buddymu jasné zadání",
      "knowhow": "Nahraj vše, co má Buddy znát",
      "training": "Teď učíme Buddyho mluvit za tebe",
      "beta": "Otestuj Buddyho v ostrém chatu",
      "marketing_call": "Vymyslíme, jak Buddy přivede zákazníky",
      "q2": "Ukaž nám, jak dnes prodáváš",
      "sales": "Tvoříme vše, s čím bude Buddy prodávat",
      "handover": "Buddy je připravený jít do světa",
      "stripe": "Napoj platby na svůj účet"
    },
    "finished": {
      "eyebrow": "Hotovo",
      "title": "Máš to! Buddy je tvůj a prodává",
      "copy": "Celý balík je předaný: bot patří tobě, prodejní materiály jsou živé a platby chodí přímo tobě. Kdykoliv se chceš k něčemu vrátit, všechno tu zůstává.",
      "action": "Otevřít prodejní podklady",
      "returnsTitle": "Kam se můžeš vrátit",
      "returnsLabel": "Hotové kroky",
      "pageTitle": "Buddy prodává za tebe",
      "titleSalesOnly": "Hotovo. Prodejní balíček je tvůj",
      "copySalesOnly": "Strategie, prodejní stránka, e-maily i webinář jsou hotové a máš je u sebe. Všechno tu zůstává, kdykoli se k tomu budeš chtít vrátit.",
      "pageTitleSalesOnly": "Prodejní balíček je hotový"
    },
    "review": {
      "eyebrow": "Ke kontrole",
      "action": "Otevřít ke kontrole",
      "strategy": {
        "title": "Návrh prodejní strategie čeká na tvou kontrolu",
        "copy": "Návrh včetně cen a tarifů je připravený. Projdi si ho, přidej připomínky, nebo ho rovnou schval."
      },
      "salespage": {
        "title": "Prodejní stránka čeká na tvou kontrolu",
        "copy": "Stránka je připravená. Projdi si obsah i vzhled, přidej připomínky, nebo ji rovnou schval."
      },
      "emails": {
        "title": "Prodejní e-maily čekají na tvou kontrolu",
        "copy": "Série e-mailů je připravená. Projdi si ji, přidej připomínky, nebo ji rovnou schval."
      },
      "webinar": {
        "title": "Struktura webináře čeká na tvou kontrolu",
        "copy": "Struktura je připravená. Projdi si ji, přidej připomínky, nebo ji rovnou schval."
      }
    }
  },
  "states": {
    "locked": "Zamčeno",
    "next": "Na řadě",
    "working": "Pracujeme",
    "workingBeta": "Testuješ",
    "workingKnowhow": "Na tobě",
    "done": "Hotovo"
  },
  "sections": {
    "home": {
      "title": "Domů",
      "unlockCondition": "Domovská stránka je vždy dostupná.",
      "action": "Otevřít přehled",
      "actionCopy": "Podívej se na aktuální stav."
    },
    "onboarding_call": {
      "title": "Úvodní video",
      "unlockCondition": "Dostupné od začátku.",
      "action": "Přehrát video",
      "actionCopy": "Přehraj si úvodní video. Ukážeme ti celý postup a vysvětlíme, co od tebe budeme potřebovat.",
      "unlocksNote": "Ve videu se ti v pravou chvíli otevře další krok: dotazník k přípravě Buddyho.",
      "videoActionCopy": "Přehraj si úvodní video. Ukážeme ti celý postup a vysvětlíme, co od tebe budeme potřebovat.",
      "existingVideoActionCopy": "Tvůj Buddy už žije. Přehraj si úvodní video, ukážeme ti, jak ho spolu vyladíme a co od tebe budeme potřebovat.",
      "existingUnlocksNote": "Ve videu se ti v pravou chvíli otevře další krok: dotazník, díky kterému tvůj Buddy dostane tvůj hlas, hranice a know-how."
    },
    "q1": {
      "title": "Dotazník k přípravě tvého Buddyho",
      "unlockCondition": "Otevře se, až si pustíš úvodní video a potvrdíš svůj profil.",
      "action": "Zodpovědět otázky",
      "actionCopy": "Díky tvým odpovědím pochopíme, jak má Buddy mluvit, pomáhat a pracovat s tvým know-how."
    },
    "knowhow": {
      "title": "Know-how",
      "unlockCondition": "Odemkne se po dokončení zadání.",
      "action": "Otevřít podklady",
      "actionCopy": "Nahraj zdroje do připravené složky."
    },
    "training": {
      "title": "Trénink",
      "unlockCondition": "Začne po potvrzení know-how.",
      "action": "Zobrazit stav",
      "actionCopy": "Sleduj, jak tým zpracovává tvoje zdroje."
    },
    "beta": {
      "title": "Beta testování",
      "unlockCondition": "Odemkne se po dokončení tréninku.",
      "action": "Vyzkoušet Buddyho",
      "actionCopy": "Otestuj hotového Buddyho na skutečných situacích."
    },
    "marketing_call": {
      "title": "Marketingové video",
      "unlockCondition": "Odemkne se po dokončení tréninku.",
      "action": "Přehrát video",
      "actionCopy": "Přehraj si video o prodeji tvého Buddyho. Ukážeme ti, jak o prodeji přemýšlet, a v pravou chvíli se ti otevře prodejní dotazník.",
      "unlocksNote": "Ve videu se ti v pravou chvíli otevře další krok: dotazník k prodeji tvého Buddyho.",
      "videoActionCopy": "Přehraj si video o prodeji tvého Buddyho. Ukážeme ti, jak o prodeji přemýšlet, a na konci se ti otevře dotazník k prodeji."
    },
    "q2": {
      "title": "Dotazník k prodeji tvého Buddyho",
      "unlockCondition": "Otevře se, až si pustíš marketingové video.",
      "action": "Připrav prodejní zadání",
      "actionCopy": "Popiš svou nabídku, zákazníky a způsob prodeje. Podle odpovědí připravíme prodejní balíček pro Buddyho."
    },
    "sales": {
      "title": "Prodejní materiály",
      "unlockCondition": "Tým začne po odeslání prodejního zadání.",
      "action": "Zkontrolovat výstupy",
      "actionCopy": "Projdi připravený prodejní balíček."
    },
    "handover": {
      "title": "Předání",
      "unlockCondition": "Začne po odeslání prodejního zadání.",
      "action": "Převzít správu",
      "actionCopy": "Dokonči předání a přihlas se do svého Owner Dashboardu."
    },
    "app": {
      "title": "Mobilní aplikace",
      "unlockCondition": "Postup závisí na zvoleném balíčku.",
      "action": "Dokončit Apple účet",
      "actionCopy": "Doplň kroky potřebné pro zveřejnění aplikace."
    },
    "stripe": {
      "title": "Propojení se Stripem",
      "unlockCondition": "Otevře se společně s prodejními materiály.",
      "action": "Propojit platby",
      "actionCopy": "Nastav si přijímání plateb, aby předplatné od zákazníků chodilo rovnou tobě."
    },
    "feedback": {
      "title": "Zpětná vazba"
    }
  },
  "call": {
    "eyebrow": "Nejbližší společný hovor",
    "title": "Příští termín",
    "kind": {
      "onboarding": "Úvodní hovor",
      "marketing": "Marketingový hovor"
    },
    "status": {
      "enrolled": "Přihlášeno",
      "attended": "Účast potvrzena",
      "watched_recording": "Záznam zhlédnut"
    },
    "enroll": "Rezervovat místo",
    "enrolling": "Rezervuji místo...",
    "openZoom": "Otevřít Zoom",
    "zoomLater": "Odkaz sem doplníme a dáme ti vědět.",
    "cannotAttend": "Zvolit jinou možnost",
    "moveNextTerm": "Přesunout se na příští termín",
    "watchRecording": "Pustit záznam",
    "bookPartner": "Domluv si mimořádný hovor s parťákem",
    "codeTitle": "Máš kód z hovoru?",
    "codePlaceholder": "Zadej kód a pokračuj",
    "codeSubmit": "Odemknout",
    "codeRequired": "Zadej kód z hovoru.",
    "empty": "Vhodný termín zatím není vypsaný. Domluv si čas přímo s parťákem.",
    "afterLinkNote": "Přes odkaz z hovoru se dostaneš rovnou k dalšímu kroku.",
    "missedLead": "Nevadí. Buď si pusť záznam hovoru, jakmile bude hotový, nebo si domluv hovor jen s parťákem. Dál pokračuješ stejně.",
    "missedAfter": "Zvolit jinou možnost"
  },
  "video": {
    "gateNote": "V pravou chvíli se ti přímo ve videu otevře další krok.",
    "gateNoteDone": "Video máš zhlédnuté. Další krok je otevřený.",
    "firstWatchNote": "Při prvním zhlédnutí nejde přeskakovat dopředu. Vracet se můžeš kdykoliv.",
    "seekLocked": "Přeskakovat dopředu půjde po prvním zhlédnutí.",
    "resumeNote": "Video se spustí tam, kde minule skončilo.",
    "completedBadge": "Zhlédnuto",
    "continue": "Pokračovat na další krok",
    "play": "Přehrát",
    "pause": "Pozastavit",
    "mute": "Ztlumit",
    "unmute": "Zapnout zvuk",
    "volume": "Hlasitost",
    "fullscreen": "Celá obrazovka",
    "exitFullscreen": "Ukončit celou obrazovku",
    "progressLabel": "Průběh videa",
    "unlockOpenedTitle": "Právě se ti otevřel další krok.",
    "unlockOpenedCopy": "Video si můžeš dokoukat, nebo rovnou pokračovat.",
    "freeSeekNote": "Teď se můžeš ve videu posouvat libovolně.",
    "preparingTitle": "Video se připravuje",
    "preparingCopy": "Jakmile ho sem tým nahraje, krok se ti tady otevře. Teď nemusíš dělat nic.",
    "mediaErrorTitle": "Video se nenačetlo",
    "mediaErrorCopy": "Chyba je u nás, ne u tebe. Zkus ho načíst znovu. Když to nepomůže, napiš svému parťákovi, kontakt na něj máš v kartě Tvůj parťák.",
    "mediaErrorRetry": "Načíst video znovu",
    "progressBlockedTitle": "Postup ve videu se neukládá"
  },
  "partner": {
    "eyebrow": "Tvůj parťák",
    "role": "BuddyPro parťák",
    "roleCopy": "Tvůj parťák hlídá celý postup a pomůže ti s každým krokem. Ozvi se mu, kdykoliv si nebudeš {{g:jistý|jistá}}, co udělat dál.",
    "book": "Domluv si mimořádný hovor s parťákem",
    "telegram": "Napsat na Telegramu",
    "contactCopy": "Můžeš mu napsat e-mail nebo si rovnou rezervovat čas na hovor.",
    "bookingCopy": "Když chceš něco probrat, rezervuj si čas na hovor.",
    "assigningTitle": "Parťáka ti právě přiřazujeme",
    "assigningCopy": "Tvůj parťák, který tě provede celým procesem, se právě přiřazuje. Obvykle to zvládneme do jednoho pracovního dne. Jakmile ho budeš mít, můžeš mu napsat nebo si s ním rezervovat hovor, kdykoli budeš potřebovat.",
    "fallbackName": "BuddyPro tým",
    "write": "Napsat parťákovi e-mail",
    "messageLabel": "Zpráva pro parťáka",
    "messagePlaceholder": "Napiš, s čím potřebuješ pomoct. Parťák ti odpoví na tvůj e-mail.",
    "messageSend": "Odeslat parťákovi",
    "messageSending": "Odesílám…",
    "messageSentTitle": "Odesláno",
    "messageSent": "Zpráva je u parťáka. Odpoví ti na {email}.",
    "messageAnother": "Napsat další zprávu",
    "messageFailed": "Zprávu se nepodařilo odeslat. Zkus to prosím znovu, text ti tu držíme.",
    "messageMailApp": "Nebo otevřít poštovní aplikaci",
    "messageAddress": "Adresa parťáka: {email}"
  },
  "profile": {
    "eyebrow": "Tvůj profil",
    "title": "Pomoz nám poznat tě přesněji",
    "updated": "Poslední aktualizace:",
    "previewTitle": "Tohle už o tobě víme",
    "open": "Otevřít celý profil",
    "viewTitle": "Co o tobě víme",
    "viewCopy": "Skrz veřejně dostupné zdroje na internetu jsme o tobě sestavili tenhle profil. Ničemu nevěříme na slovo: potvrď, co sedí, oprav, co ne, a doplň, co chybí. Nejlíp hlasem.",
    "version": "Verze dossieru",
    "loadError": "Obsah se teď nepodařilo načíst. Nic se neztratilo, stačí to zkusit znovu.",
    "original": "Původní znění:",
    "irrelevant": "Nezahrnujeme do výstupů",
    "actionsLabel": "Akce s faktem",
    "confirm": "Sedí",
    "correct": "Opravit",
    "markIrrelevant": "Není podstatné",
    "saveCorrection": "Uložit opravu",
    "saving": "Ukládám...",
    "saveError": "Změnu se nepodařilo uložit.",
    "history": {
      "show": "Zobrazit historii nahrávek",
      "hide": "Skrýt historii nahrávek"
    },
    "playCorrection": "Přehrát hlasovou opravu",
    "action": {
      "confirm": "Potvrzeno",
      "correct": "Opraveno",
      "irrelevant": "Označeno jako nepodstatné"
    },
    "explain": "Tvůj profil jsme sestavili z veřejně dostupných informací na internetu. Pomůže nám, když upřesníš, co sedí, co chybí a co nechceš uvádět.",
    "audioCta": "Nahraj nám hlasovou zprávu. Řekni, co sedí, co máme doplnit a co naopak nemáme uvádět.",
    "audioSoon": "Nahrávání hlasové zprávy pro tebe připravujeme.",
    "fromInternet": "Našli jsme na internetu",
    "verifiedByYou": "Ověřeno tebou",
    "source": "Zdroj",
    "lead2": "Z veřejně dostupných informací jsme si vytvořili tvůj profil.",
    "confirmed": {
      "eyebrow": "Potvrzený profil",
      "title": "Profil, ze kterého vycházíme",
      "copy": "Tuhle mapu používáme při přípravě tvého Buddyho. Pokud se něco změnilo, požádej parťáka o úpravu.",
      "requestEdit": "Požádat o úpravu",
      "requestEditUnavailable": "Úpravu ti pomůže domluvit parťák."
    },
    "voiceInstruction": "Projdi si celý profil a nahraj nám hlasovku. Řekni nám, co platí, co je zastaralé, co chybí, co chceš říct jinak a co se pro Buddyho nehodí. Klidně nám pověz víc o sobě, svém byznysu a značce.",
    "voiceSent": "Díky, tým si tvůj komentář projde a profil podle něj upraví.",
    "voiceSubmit": "Odeslat komentář",
    "voiceError": "Komentář se nepodařilo odeslat. Zkus to prosím znovu.",
    "walk": {
      "title": "Proveď mě svou mapou",
      "explain": "Klikni na mikrofon, projdi svou mapu níže a řekni mi, co v ní chceš upravit.",
      "start": "Zapnout nahrávání",
      "cta": "Zapni nahrávání a okomentuj profil",
      "recording": "Nahráváme",
      "stop": "Dokončit a odeslat",
      "cancel": "Zrušit",
      "sent": "Náš tým si projde nahrávku i stopu kurzoru a podle nich tvůj profil upraví.",
      "error": "Nahrávku se nepodařilo odeslat. Zkus to prosím znovu.",
      "point1": "Fakt odebereš rovnou křížkem.",
      "point2": "Všechno ostatní stačí namluvit.",
      "recTitle": "Poslouchám a nahrávám",
      "recInstruction": "Procházej svou mapu níže a říkej, co chceš přidat nebo odebrat a co je či není relevantní. Klidně popiš i to, jak chceš upravit celý profil. Až budeš mít hotovo, zastav nahrávání.",
      "sendingNote": "Chviličku, převádím tvou nahrávku na text.",
      "sentTitle": "Nahrávka je u nás"
    },
    "recordings": {
      "title": "Tvoje nahrávky",
      "delete": "Smazat",
      "apply": "Zapracovat do mapy",
      "applying": "Zpracováváme nahrávku",
      "applied": "Zapracováno ✓",
      "etaFallback": "Obvykle do 5 minut",
      "completedBanner": "Zapracovali jsme tvé nahrávky do mapy. Zkontroluj ji níž a potvrď profil.",
      "notificationTitle": "Nahrávky jsou zapracované",
      "notificationBody": "Nahrávky jsou zapracované v mapě. Zkontroluj profil a potvrď ho.",
      "another": "Přidat nahrávku",
      "review": "Zkontroluje tým"
    },
    "factRemove": "Odstranit z mapy",
    "map": {
      "navigationLabel": "Kategorie profilové mapy",
      "position": "Kategorie {current} z {total}",
      "previous": "Předchozí kategorie",
      "next": "Další kategorie"
    },
    "confirmation": {
      "button": "Potvrzuji, že takto je profil v pořádku",
      "sending": "Potvrzuji...",
      "done": "Profil je potvrzený.",
      "locked": "Profil zůstává viditelný, ale připomínky jsou uzamčené. Parťák je může znovu otevřít.",
      "error": "Profil se nepodařilo potvrdit. Zkus to prosím znovu."
    },
    "mapReset": {
      "tip": "Smazání dává smysl jen tehdy, když je mapa postavená na informacích o někom jiném nebo je jako celek nepřesná. Novou si pak postavíš od nuly pomocí svých nahrávek.",
      "deleteButton": "Smazat mapu",
      "dialogTitle": "Opravdu chceš smazat celou mapu?",
      "dialogBody": "Je celá mapa podle tebe nepřesná a nechceš z ní vycházet? Po potvrzení ji definitivně smažeme. Tenhle krok nejde vrátit a novou mapu začneš stavět od nuly pomocí svých nahrávek.",
      "confirm": "Ano, smazat natrvalo",
      "cancel": "Ne, ještě si ji projdu",
      "error": "Mapu se teď nepodařilo smazat. Zkus to prosím znovu."
    },
    "research": {
      "runningLead": "Z veřejně dostupných zdrojů právě skládáme tvůj profil.",
      "runningTitle": "První podklady právě vznikají",
      "runningCopy": "Zjišťujeme o tobě první podklady. Konkrétní fakta se tu objeví, jakmile je tým ověří.",
      "runningRecord": "Nemusíš čekat, mikrofon nahoře funguje už teď. Co namluvíš, propíše se do mapy.",
      "delayedLead": "Skládání profilu se nám zdrželo. Víme o tom.",
      "delayedTitle": "Trvá to déle, než mělo",
      "delayedCopy": "Průzkum veřejných zdrojů se zasekl. Bereme si to na starost a ozveme se, jakmile budeme mít první fakta.",
      "delayedRecord": "Nečekej na nás. Zapni nahrávání nahoře a řekni nám základy, tím se posuneme hned.",
      "emptyLead": "Ve veřejných zdrojích jsme o tobě nic nenašli.",
      "emptyTitle": "Představ se nám",
      "emptyCopy": "Zapni nahrávání a řekni nám, kdo jsi, co děláš, čím se zabýváš a co má tvůj Buddy umět. Z toho ti profil postavíme.",
      "emptyRecord": "Mluv normálně, jako při běžném hovoru. Co namluvíš, propíše se rovnou do mapy.",
      "noneLead": "Tvůj profil zatím nemáme. Vznikne z toho, co nám o sobě řekneš.",
      "noneTitle": "Řekni nám o sobě základy",
      "noneCopy": "Zapni nahrávání a pověz nám, kdo jsi, co děláš a čím se zabýváš. Z toho ti profil postavíme.",
      "noneRecord": "Co namluvíš, propíše se rovnou do mapy."
    },
    "questionnaireGate": {
      "eyebrow": "Nejdřív potvrď svůj profil",
      "title": "Otázky připravíme až z profilu, který sedí",
      "copy": "Dotazník se skládá podle tvého profilu. Než otázky vygenerujeme, potřebujeme mít jistotu, že informace o tobě odpovídají skutečnosti.",
      "review": "Otevři svůj profil tlačítkem níže.",
      "correct": "Co nesedí, uprav nebo doplň hlasovou zprávou.",
      "confirm": "Nakonec potvrď, že je profil v pořádku. Pak se otázky zpřístupní.",
      "openProfile": "Zkontrolovat a potvrdit profil"
    },
    "walkBasics": {
      "title": "Namluv nám základy",
      "explain": "Klikni na mikrofon a řekni nám, kdo jsi, co děláš a o čem bude tvůj Buddy."
    }
  },
  "resources": {
    "loadError": "Obsah se teď nepodařilo načíst. Nic se neztratilo, stačí to zkusit znovu."
  },
  "knowhow": {
    "closed": "Nahrávání know-how pro základní trénink bylo ukončeno.",
    "closedRecap": "Podklady máme uložené a tým z nich připravuje tvého Buddyho. Později budeš moct jeho know-how dál aktualizovat.",
    "closedCount": "Evidované podklady:",
    "closedRecapCount": {
      "zero": "Zatím tu nemáš evidovaný žádný podklad. Tým připravuje zdrojové složky, do kterých budeš moct know-how doplnit.",
      "one": "Máme uložený {count} podklad a tým z něj připravuje tvého Buddyho. Později budeš moct jeho know-how dál aktualizovat.",
      "few": "Máme uložené {count} podklady a tým z nich připravuje tvého Buddyho. Později budeš moct jeho know-how dál aktualizovat.",
      "other": "Máme uložených {count} podkladů a tým z nich připravuje tvého Buddyho. Později budeš moct jeho know-how dál aktualizovat."
    },
    "closedNext": "Podívat se na stav tréninku",
    "dialogTitle": "Stačí to pro základní trénink?",
    "dialogCopy": "Potvrď, že má Buddy dost podkladů pro základní trénink. Další know-how můžeš doplnit později.",
    "dialogAgree": "Souhlasím",
    "dialogDisagree": "Nesouhlasím",
    "eyebrow": "Tvoje zdroje",
    "title": "Dej Buddymu své nejlepší know-how",
    "copy": "Nahraj své nejlepší soubory do připravené složky a přidej odkazy na vlastní videa či podcasty. Z těchto podkladů postavíme Buddyho, který zná tvoje metody, zkušenosti i způsob práce.",
    "driveTitle": "Složka s tvým know-how",
    "urlsTitle": "Odkazy na videa a podcasty",
    "preparingDrive": "Tým připravuje tvoji Drive složku.",
    "preparingUrls": "Tým připravuje dokument pro veřejné zdroje.",
    "complete": "Odeslat k tréninku",
    "submitting": "Potvrzuji...",
    "guard": "Tlačítko se zpřístupní, až budou připravené oba odkazy.",
    "guardStep": "Odkazy jsou připravené. Krok ti otevřeme hned, jak je tým zkontroluje, a pak půjde know-how odeslat.",
    "done": "Hotovo. Tým začal tvoje zdroje zpracovávat.",
    "error": "Potvrzení se nepodařilo. Ověř oba zdroje a zkus to znovu.",
    "confirmTitle": "Opravdu už máš všechno?",
    "confirmCopy": "Jakmile potvrdíš, že je ve složce všechno, náš tým může začít trénovat Buddyho.",
    "confirmCheckbox": "Všechno je nahrané",
    "confirmWarning": "Po potvrzení podklady uzamkneme, odešleme je ke zpracování a vytvoříme z nich první verzi tvého Buddyho. Později budeš moct jeho know-how kdykoliv aktualizovat.",
    "confirmYes": "Ano, odeslat ke zpracování",
    "confirmNo": "Ještě ne",
    "googleLabel": "Google účet, na který nasdílíme složku",
    "googleButton": "Zpřístupnit složku",
    "belongsTitle": "Co sem patří",
    "belongs1": "Tvoje nejlepší kurzy a e-booky",
    "belongs2": "Přepisy a nahrávky přednášek či konzultací",
    "belongs3": "Vlastní články, metodiky a postupy",
    "belongs4": "Videa, podcasty a rozhovory, ve kterých mluvíš hlavně ty a předáváš své know-how",
    "belongs5": "Jen obsah, ke kterému máš práva",
    "avoidTitle": "Co sem nepatří",
    "avoid1": "Podcasty, kde jsi hostem, nebo kde jde primárně o know-how tvých hostů",
    "avoid2": "Smlouvy, faktury a interní dokumenty",
    "avoid3": "Osobní údaje tvých klientů",
    "avoid4": "Průměrný obsah, který Buddyho nic nenaučí",
    "googleDone": "Složku i dokument připravíme, nasdílíme je na tento účet a dáme ti vědět.",
    "avoid5": "Nahrávky, kde mluví víc lidí přes sebe",
    "partnerTitle": "Materiály od parťáka",
    "partnerHint": "Tyhle podklady za tebe nahrál tvůj parťák. Počítáme s nimi při tréninku tvého buddyho.",
    "partnerBy": "nahráno parťákem",
    "openFolder": "Otevřít složku",
    "openDoc": "Otevřít dokument",
    "folderHint": "Vlož soubory s tvým know-how přímo do této Google Drive složky, bez podsložek.",
    "docHint": "Vlož celé odkazy na tvoje videa, podcasty a články do tohoto Google dokumentu. Každý odkaz na samostatný řádek.",
    "step1Title": "Přečti si, co do Buddyho patří",
    "step2Title": "Nahraj soubory do složky a odkazy do dokumentu",
    "step3Title": "Potvrď, že je všechno nahrané",
    "accountsIntro": "Složku i dokument sdílíme na tyto Google účty. Otevírej je {{g:přihlášený|přihlášená}} jedním z nich.",
    "accountShared": "Nasdíleno",
    "accountPending": "Zpřístupňujeme",
    "accountDelayed": "Trvá to déle",
    "activeTitle": "Už na tom pracujeme",
    "activeEta": "Přístup obvykle připravíme za 3-5 minut.",
    "activeDelayed": "Trvá to déle než obvykle. Víme o tom, řešíme to a ozveme se ti.",
    "activeNotify": "Pošleme ti upozornění, jakmile bude přístup hotový.",
    "addAccount": "Přidat další účet",
    "addAccountHint": "Hodí se, když ti s nahráváním pomáhá někdo z týmu.",
    "addAccountButton": "Přidat účet",
    "googlePlaceholder": "jmeno@gmail.com",
    "rulesTitle": "Jak nahrávat, aby se nic neztratilo",
    "rulesFolderTitle": "Soubory dávej přímo do složky",
    "rulesFolderBody": "Nezakládej v ní další složky. Co leží v podsložce, se do tréninku Buddyho nedostane.",
    "rulesLinksTitle": "Odkazy patří do dokumentu s odkazy",
    "rulesLinksBody": "Vlož celé odkazy (začínají https://), každý na samostatný řádek. Seznam názvů videí ani PDF s odkazy nestačí, obsah videí se z nich k Buddymu nedostane.",
    "rulesVoiceTitle": "Přidej ukázku svého hlasu",
    "rulesVoiceBody": "Nahraj do složky jednu nahrávku, kde mluvíš jen ty: aspoň 2 minuty, bez hudby, bez dalších lidí a bez ruchů v pozadí. Dej jí do názvu slovo „hlas“. Z ní naklonujeme hlas tvého Buddyho.",
    "precheckTitle": "Než potvrdíš, zkontroluj:",
    "precheck1": "Všechny soubory leží přímo ve složce, žádný není v podsložce.",
    "precheck2": "Odkazy na videa a podcasty jsou v dokumentu, každý na svém řádku.",
    "precheck3": "Ve složce je nahrávka tvého hlasu se slovem „hlas“ v názvu."
  },
  "training": {
    "eyebrow": "Stav tréninku",
    "title": "Tvůj Buddy se učí z ověřených zdrojů",
    "copy": "Tvoje know-how se právě mění v Buddyho: nahráváme zdroje, učíme ho znalosti a ladíme jeho hlas i chování.",
    "revealTitle": "Tvůj Buddy je připravený",
    "revealCopy": "Trénink je hotový, takže si teď můžeš Buddyho pořádně proklepnout a říct nám, co ještě doladit.",
    "openTrial": "Otevřít zkušební verzi",
    "calm": "Nemusíš nic hlídat a nic dalšího od tebe nepotřebujeme.",
    "eta": "Obvykle to trvá 2-3 pracovní dny. Dáme ti vědět e-mailem, jakmile bude Buddy připravený."
  },
  "beta": {
    "eyebrow": "Beta testování",
    "title": "Prověř Buddyho na skutečných otázkách",
    "copy": "Teď je to na tobě: nejdřív si s Buddym začni povídat ty.",
    "copyTransferred": "Bot je tvůj. Teď pozvi testery a nasbírej první reakce zvenčí.",
    "invites": {
      "one": "K dispozici je {count} pozvánka s 200 zprávami pro tvoje testery.",
      "few": "K dispozici jsou {count} pozvánky, každá s 200 zprávami pro tvoje testery.",
      "other": "K dispozici je {count} pozvánek, každá s 200 zprávami pro tvoje testery."
    },
    "feedbackTitle": "Pošli nám konkrétní podnět",
    "feedbackCopy": "Napiš nám, co se stalo, jaká odpověď měla přijít, a přidej konkrétní příklad. My podnět zpracujeme a Buddyho doladíme.",
    "sourceLabel": "Čí postřeh posíláš",
    "sourceSelf": "Můj postřeh",
    "sourceTester": "Od testera",
    "testerNamePlaceholder": "Jméno testera (nepovinné)",
    "fromTester": "Od testera",
    "fromTesterNamed": "Od testera ({name})",
    "screenshot": "Přidej screenshot",
    "selected": "Vybraný soubor:",
    "submit": "Odeslat podnět",
    "submitting": "Odesílám...",
    "upload": {
      "converted_photo": "Screenshot v tomhle formátu (HEIC z iPhonu, TIFF nebo RAW) zatím neumíme zpracovat. Ulož ho jako PNG nebo JPEG a přidej znovu. Soubor zůstává u tebe, nic jsme neodeslali.",
      "unsupported_type": "Tenhle formát souboru nepřijímáme. Přidej screenshot jako PNG, JPG nebo WebP. Soubor zůstává u tebe, nic jsme neodeslali.",
      "too_large": "Screenshot je moc velký. Vejde se do 60 MB, tak ho zmenši a přidej znovu. Soubor zůstává u tebe, nic jsme neodeslali.",
      "quota": "Došlo ti místo pro nahrané soubory. Denní limit se uvolní sám do 24 hodin, jinak napiš svému parťákovi. Text podnětu ti tady zůstane.",
      "storage": "Úložiště teď nereaguje. Zkus podnět odeslat za chvíli, text i nahrávka ti tady zůstanou.",
      "offline": "Vypadá to, že jsi offline. Připoj se a odešli podnět znovu. Nic se neztratilo.",
      "not_an_image": "Tenhle soubor uvnitř není obrázek, i když se tak jmenuje. Otevři ho, ulož jako PNG nebo JPEG a přidej znovu.",
      "generic": "Screenshot se teď nepodařilo nahrát. Zkus to prosím znovu, nebo podnět pošli bez něj. Soubor zůstává u tebe, nic jsme neodeslali."
    },
    "submitIssue": {
      "trial_not_ready": "Zkušební Buddy zatím není připravený, takže není co komentovat. Připravujeme ho a dáme ti vědět. Text i nahrávka ti tady zůstávají.",
      "tester_before_transfer": "Volbu Od testera otevřeme, až bude bot tvůj. Přepni na Za sebe a podnět odejde hned.",
      "ownership_transferred": "Správcovství instance bylo předané, takže my už instanci nastavovat nemůžeme a spravuješ si ji {{g:sám|sama}}. Podněty se už neposílají. Text i nahrávka ti tady zůstávají.",
      "state_conflict": "Beta se mezitím posunula jinam. Zkopíruj si text, načti stránku a uvidíš, kde teď jsme.",
      "forbidden": "Tohle odeslat nemůžeš ty. Napiš parťákovi, ať se na to podívá.",
      "not_found": "Přílohu už na serveru nemáme. Přidej ji znovu, nebo pošli podnět bez ní.",
      "invalid_request": "Něco ve formuláři nesedí. Zkontroluj text i přílohy a odešli podnět znovu.",
      "rate_limited": "Přišlo moc pokusů za sebou. Počkej chvíli a odešli podnět znovu. Text i nahrávka ti tady zůstávají.",
      "server": "Server teď neodpověděl. Je to na nás a díváme se na to. Zkus to za chvíli, text i nahrávka ti tady zůstávají.",
      "offline": "Vypadá to na výpadek připojení. Připoj se a odešli podnět znovu. Text i nahrávka ti tady zůstávají.",
      "generic": "Podnět se teď odeslat nepodařilo. Je to na nás a díváme se na to. Zkus to prosím za chvíli, text i nahrávka ti tady zůstávají."
    },
    "historyTitle": "Tvoje podněty",
    "historyEmpty": "Zatím tu nic není. Začni jedním z testů výše.",
    "historyEmptyClosed": "Žádné podněty tu nejsou.",
    "historyProcessed": "Zpracované ({count})",
    "openScreenshot": "Otevřít screenshot",
    "playAudio": "Přehrát hlasovou poznámku",
    "status": {
      "new": "Nový",
      "processed": "Zpracovaný"
    },
    "readyTitle": "První verze tvého Buddyho je připravená",
    "openChat": "Otevřít zkušební verzi",
    "openChatOwned": "Otevřít svého Buddyho",
    "screenshotHint": "Screenshot je nejlepší způsob, jak nám ukázat, co nebylo v pořádku. Požádej i své testery, ať ti screenshoty posílají, přidej je sem a napiš, co se stalo.",
    "step1Title": "Popovídej si se svým Buddym",
    "step1Copy": "Proklepni Buddyho na otázkách, které slýcháš od klientů, a dolaď s námi základy, dokud to nebude podle tebe.",
    "step2Title": "Předání vlastnictví Telegram bota",
    "step2Copy": "Aby byl Buddy doopravdy tvůj, převedeme bota na tvůj osobní Telegram účet. Telegram převod dovolí až po první zprávě botovi.",
    "step3Title": "Pozvi testery",
    "step3Copy": "Vyber kolegy, kamarády nebo pár zákazníků a pošli jim odkaz pro testery. Čerstvé oči odhalí, co ty už nevidíš.",
    "step4Title": "Zpětná vazba",
    "step4Copy": "Chtěj konkrétní zpětnou vazbu: co testery nadchlo, co chybělo a kde se Buddy ztratil. Dojmy můžeš přidávat i za sebe.",
    "lockTesters": "Nejdřív je potřeba předat Telegram bota. Pak dostaneš pozvánky pro testery.",
    "feedbackBeforeTransfer": "Svůj postřeh můžeš poslat už teď. Volba Od testera se otevře po předání bota.",
    "feedbackClosedLead": "Tenhle krok je uzavřený.",
    "feedbackOwnershipClosed": "Správcovství instance bylo předané. Instance je od téhle chvíle tvoje, my už ji nastavovat nemůžeme a spravuješ si ji {{g:sám|sama}}. Podněty se už neposílají. Tvoje dřívější podněty najdeš níž.",
    "transfer": {
      "accountKicker": "Převod připravíme na účet",
      "accountKickerDone": "Vlastník bota",
      "state": {
        "preparing": "Odesláno",
        "awaiting_client": "Čeká na převzetí",
        "client_confirmed": "Převzetí potvrzeno",
        "transferred": "Převedeno",
        "fix_needed": "Čeká na opravu"
      },
      "responsible": {
        "team": "Odpovídá tým BuddyPro",
        "client": "Odpovídáš ty"
      },
      "autoWorking": "Pracujeme na převodu bota. Dáme ti vědět, až bude hotový.",
      "fix": {
        "recipient_not_started": "Účet @{username} zatím tvému botovi nenapsal žádnou zprávu. Telegram dovolí převod jen na účet, který si s botem píše. Otevři bota, pošli mu zprávu a odešli jméno znovu.",
        "recipient_not_found": "Účet @{username} se na Telegramu nepodařilo najít. Zkontroluj jméno a odešli ho znovu.",
        "recipient_bot_limit": "Účet @{username} už má na Telegramu maximální počet botů a víc jich tam nepustí. Uvolni na něm místo (v @BotFather smaž nebo předej jednoho z nepoužívaných botů) a odešli jméno znovu.",
        "recipient_invalid_target": "Jméno @{username} nepatří osobnímu účtu, ale botovi nebo kanálu. Telegram dovolí převod jen na osobní účet člověka. Zkontroluj jméno a odešli ho znovu.",
        "staff_returned": "Parťák ti převod vrátil k opravě: {note}"
      },
      "accept": "Potvrdit převzetí bota",
      "accepting": "Potvrzuji...",
      "confirmedNote": "Díky za potvrzení. Ještě ověříme, že Telegram převod dokončil.",
      "doneNote": "Bot je převedený. Od teď ho vlastníš jen ty."
    },
    "tipTitle": "Tip: vyměň testování za reference",
    "tipCopy": "Každá pozvánka dává testerovi 200 zpráv zdarma. Řekni si výměnou o zpětnou vazbu a referenci. Reference může být krátké video, pár vět nebo screenshot nadšené zprávy. Pokládej otázky tak, aby ti tu zprávu sami napsali, a vyžádej si svolení ji použít. Každá se ti pak bude hodit na prodejní stránku při launchi.",
    "linkPlaceholder": "Tady bude tvůj odkaz na Buddyho.",
    "inviteLinkPlaceholder": "Tady bude odkaz pro tvoje testery.",
    "inviteLinkLabel": "Odkaz pro testery",
    "copyInvite": "Zkopírovat odkaz",
    "copied": "Zkopírováno"
  },
  "botTransfer": {
    "reason": {
      "recipient_not_started": "příjemce zatím botovi nenapsal",
      "recipient_not_found": "účet s tímto jménem Telegram nenašel",
      "floodwait": "Telegram nás dočasně omezil (FloodWait)",
      "twofa_too_fresh": "dvoufázové ověření účtu je mladší než 7 dní",
      "gate_mismatch": "potvrzovací zpráva BotFathera neodpovídala botovi nebo příjemci",
      "bot_not_found": "bot se nenašel v /mybots",
      "session_unavailable": "Telegram session nebyla dostupná",
      "unknown": "chybu zatím neumíme pojmenovat",
      "staff_returned": "parťák vrátil převod klientovi k opravě",
      "recipient_invalid_target": "zadané jméno nepatří osobnímu účtu, ale botovi nebo kanálu",
      "recipient_bot_limit": "příjemce má na svém účtu plný počet botů a musí si uvolnit místo",
      "verification_unavailable": "potvrzení odešlo, ale nešlo ověřit, jestli bot opravdu změnil majitele. Zkontroluj /mybots našeho účtu ručně, než to pustíš znovu"
    }
  },
  "ownerRole": {
    "reason": {
      "owner_not_member": "účet s tímhle ID zatím není uživatelem instance",
      "invalid_owner_id": "uložené číslo nevypadá jako Telegram ID",
      "not_our_instance": "instance příkaz odmítla: náš účet u ní není vlastník",
      "id_format_rejected": "instance odmítla formát ID, který jsme poslali",
      "platform_error": "instance ohlásila chybu, bližší důvod neuvedla",
      "session_unavailable": "nemáme ověřený účet, ze kterého tuhle instanci ovládáme",
      "verification_unavailable": "odpověď instance nešlo přečíst, takže roli nepovažujeme za nastavenou",
      "unknown": "chybu zatím neumíme pojmenovat"
    }
  },
  "transfer": {
    "warning": "Pozor: překlep by znamenal, že bota předáme cizímu člověku. Převod je nevratný, proto jméno zadáváš dvakrát.",
    "usernameLabel": "Uživatelské jméno na Telegramu",
    "usernameRepeatLabel": "Uživatelské jméno ještě jednou pro kontrolu",
    "usernamePlaceholder": "@uzivatelske_jmeno",
    "usernameMismatch": "Jména se neshodují. Zkontroluj překlepy a oprav je.",
    "usernameIsBot": "{bot} je jméno tvého bota, ne tvého účtu. Vyplň sem jméno svého osobního účtu na Telegramu.",
    "usernameMatch": "Jména se shodují.",
    "noUsernameNote": "Nemáš uživatelské jméno? V Telegramu si ho vytvoříš v Nastavení pod položkou Uživatelské jméno. Bez něj převod nejde.",
    "idLabel": "Telegram ID (z příkazu /myid)",
    "idHint": "Otevři chat se svým botem, pošli mu /myid a zkopíruj odpověď. Stačí i samotné číslo.",
    "idPlaceholder": "123456789#{bot}",
    "idPlaceholderPlain": "123456789#nazev_bota",
    "idGuideTitle": "Jak získat správné Telegram ID",
    "idGuideStep1": "Otevři v Telegramu chat se svým botem.",
    "idGuideStep2": "Pošli botovi příkaz /myid.",
    "idGuideStep3": "Zkopíruj celou odpověď a vlož ji do pole níže.",
    "idNormalized": "Uložíme jako {value}.",
    "idWrongBot": "Tohle číslo vypadá z jiného bota. Pošli /myid svému botovi @{bot}.",
    "startedCheckbox": "Můj bot už dostal první zprávu z mého osobního Telegram účtu",
    "submit": "Odeslat týmu",
    "submitting": "Odesílám...",
    "ownerOnly": "Účet pro převod zadává majitel.",
    "ownershipIntro": "Telegram bota už vlastníš. Tady stačí tvoje číselné Telegram ID.",
    "ownershipStored": "Použijeme účet uložený při převodu bota:",
    "idGuideStep1Link": "Otevři v Telegramu chat se svým botem {bot}.",
    "saved": "Odesláno týmu. Máme to uložené."
  },
  "sales": {
    "eyebrow": "Prodejní balíček",
    "title": "Tvoje prodejní podklady na jednom místě",
    "copy": "Každý výstup zveřejníme zvlášť. Můžeš proto kontrolovat hotové části, i když na dalších ještě pracujeme.",
    "deliverablesLabel": "Prodejní výstupy",
    "overview": {
      "eyebrow": "Příprava prodeje",
      "title": "Prodej krok za krokem",
      "copy": "Každý krok má vlastní stránku. Otevři si přesně ten podklad nebo úkol, který chceš řešit.",
      "listLabel": "Kroky přípravy prodeje",
      "unavailable": "Stav se nepodařilo načíst",
      "updated": "Aktualizováno {date}",
      "step": {
        "marketing_call": "Společně nastavíme cíl, nabídku a průběh kampaně.",
        "profile": "Zkontroluješ, co o tobě víme, doplníš, co chybí, a potvrdíš to.",
        "q2": "Tvoje odpovědi doplní podklady pro prodejní balíček.",
        "strategy": "Po kontrole a schválení navážou všechny prodejní materiály.",
        "salespage": "Zkontroluješ obsah i vzhled a pošleš připomínky.",
        "payments": "Platby ve tvém Stripe nastavíme my, ty nám jen dáš přístup.",
        "emails": "Dostaneš hotovou sérii připravenou ke kopírování.",
        "webinar": "Dostaneš osnovu, návaznost částí a prodejní závěr.",
        "stripe": "Propojíš vlastní účet, aby platby chodily přímo tobě.",
        "app_questionnaire": "Doplníš podklady potřebné pro mobilní aplikaci.",
        "publish": "Vybereš ZIP nebo Netlify, kde si můžeš připojit vlastní subdoménu.",
        "handover": "Převezmeš správu instance a přístupy.",
        "release": "Uvidíš stav sestavení a schvalování v obchodech."
      }
    },
    "pages": {
      "unavailable": "Aktuální stav a podklady se teď nepodařilo načíst. Zkus stránku za chvíli otevřít znovu.",
      "strategy": {
        "eyebrow": "Krok 11",
        "title": "Návrh prodejní strategie",
        "copy": "Tady najdeš návrh kampaně, ceny i tarify. Vše si projdi, přidej připomínky a potom návrh schval.",
        "doneCopy": "Odsouhlasený návrh kampaně včetně cen a tarifů tu zůstává ke stažení.",
        "locked": "Tento krok se odemkne po odeslání dotazníku k prodeji. Jakmile návrh připravíme, objeví se tady.",
        "processTitle": "Jak to probíhá",
        "processCopy": "Nejdřív si přečti celý návrh. Když něco nesedí, napiš nebo namluv připomínku přímo u dokumentu. Schválení posune přípravu dalších podkladů.",
        "backfillReview": "Tenhle návrh jsme doplnili k rozpracovanému projektu. Dotazník proto zůstává zamčený, ale strategii si můžeš projít, připomínkovat a schválit už teď.",
        "pricingIncluded": "Ceny a tarify jsou součástí návrhu. Schválení platí i pro ně.",
        "cardEyebrow": "Prodejní strategie",
        "cardTitle": "Návrh kampaně, cen a tarifů",
        "recap": "Strategie, ceny a tarify jsou předané v jednom schváleném dokumentu."
      },
      "salespage": {
        "eyebrow": "Krok 12",
        "title": "Prodejní stránka",
        "copy": "Krok má tři fáze: schválení stránky, odkazy na objednávku a publikace. Prohlédni si obsah i podobu stránky; připomínky a schválení patří do první fáze.",
        "locked": "Prodejní stránku otevřeme po schválení návrhu prodejní strategie.",
        "approvedNext": "Stránka je schválená. Stažení a zveřejnění najdeš v kroku Publikace prodejní stránky.",
        "openPublish": "Otevřít publikaci",
        "recap": "Schválená stránka je připravená k publikaci a zůstává dostupná ke kontrole."
      },
      "emails": {
        "eyebrow": "Krok 13",
        "title": "E-mail marketing",
        "copy": "Hotovou sérii si přečti po jednotlivých e-mailech. Každý text i celou sérii zkopíruješ přímo v dokumentu.",
        "locked": "E-mailovou sérii otevřeme po schválení návrhu prodejní strategie.",
        "recap": "Hotová e-mailová série je předaná po jednotlivých zprávách i jako celek."
      },
      "webinar": {
        "eyebrow": "Krok 14",
        "title": "Struktura webináře",
        "copy": "Na jednom místě máš osnovu, návaznost částí i prodejní závěr webináře.",
        "locked": "Strukturu webináře otevřeme po schválení návrhu prodejní strategie.",
        "recap": "Struktura webináře je předaná včetně návaznosti částí a prodejního závěru."
      },
      "publish": {
        "eyebrow": "Krok 17",
        "title": "Publikace prodejní stránky",
        "copy": "Tady si stáhneš hotový ZIP, nebo stránku publikuješ přes Netlify a případně k ní připojíš vlastní subdoménu."
      }
    },
    "kind": {
      "audit": "Audit",
      "plan": "Prodejní strategie",
      "salespage": "Prodejní stránka",
      "emails": "E-maily",
      "webinar": "Webinář",
      "avatar": "Avatar",
      "price_proposal": "Cenový návrh"
    },
    "preparingTitle": "Připravujeme",
    "avatarTitle": "Tvůj AI avatar",
    "avatarReady": "Hotový",
    "avatarView": "Zobrazit v plné velikosti",
    "avatarDownload": "Stáhnout",
    "preparing": {
      "audit": "Audit ještě dokončujeme.",
      "plan": "Návrh prodejní strategie se generuje. Obvykle to trvá 2-3 pracovní dny. Dáme ti vědět e-mailem.",
      "salespage": "Prodejní stránku ještě dokončujeme.",
      "emails": "E-mailovou sérii ještě dokončujeme.",
      "webinar": "Strukturu webináře ještě dokončujeme.",
      "avatar": "Z tvé fotky připravujeme AI avatara."
    },
    "preparingWait": {
      "strategy": {
        "title": "Připravujeme návrh prodejní strategie",
        "copy": "Pracujeme s tvými odpověďmi a připravujeme návrh prodejní strategie včetně cen a tarifů. Jakmile budeme mít materiál pro tebe připravený, uvidíš ho tady.",
        "eta": "Návrh připravujeme obvykle do 2-3 pracovních dnů. Pošleme ti upozornění, až bude potřeba tvoje zpětná vazba."
      },
      "salespage": {
        "title": "Připravujeme prodejní stránku",
        "copy": "Podle odsouhlasené strategie skládáme text, strukturu a finální podobu tvé stránky. Jakmile budeme mít materiál pro tebe připravený, uvidíš ho tady.",
        "eta": "Stránku připravujeme obvykle do 2-3 pracovních dnů. Pošleme ti upozornění, až bude potřeba tvoje zpětná vazba."
      },
      "emails": {
        "title": "Připravujeme e-mailovou sérii",
        "copy": "Píšeme e-maily, které navazují na tvou strategii a provedou čtenáře celou kampaní. Jakmile budeme mít materiál pro tebe připravený, uvidíš ho tady.",
        "eta": "Sérii připravujeme obvykle do 2-3 pracovních dnů. Pošleme ti upozornění, až bude potřeba tvoje zpětná vazba."
      },
      "webinar": {
        "title": "Připravujeme strukturu webináře",
        "copy": "Skládáme jasnou osnovu, argumentaci a nabídku pro tvůj prodejní webinář. Jakmile budeme mít materiál pro tebe připravený, uvidíš ho tady.",
        "eta": "Strukturu připravujeme obvykle do 2-3 pracovních dnů. Pošleme ti upozornění, až bude potřeba tvoje zpětná vazba."
      }
    },
    "status": {
      "draft": "Rozpracováno",
      "review": "Ke kontrole",
      "approved": "Schváleno"
    },
    "tileBlurb": {
      "audit": "Co jsme z tvých odpovědí pochopili a na čem postavíme tvou prodejní kampaň.",
      "plan": "Návrh tvé prodejní kampaně a důvody, proč ji stavíme právě takhle.",
      "emails": "Hotové e-maily k odeslání tvým lidem. Každý si zkopíruješ jedním tlačítkem.",
      "webinar": "Struktura a scénář tvého prodejního webináře."
    },
    "previewUnavailable": "Náhled se nepodařilo zobrazit. Ostatní výstupy zůstávají dostupné.",
    "previewLoading": "Načítáme skutečný náhled stránky",
    "previewChip": "Skutečný náhled",
    "previewReady": "Skutečný náhled načten",
    "previewAlt": "Náhled prodejní stránky",
    "previewError": "Náhled se nepodařilo načíst. Celý výstup můžeš otevřít samostatně.",
    "pageError": {
      "title": "Stránku se nepodařilo načíst",
      "copy": "Zkontroluj připojení a zkus to znovu."
    },
    "previewRetry": "Načíst znovu",
    "openPreview": "Otevřít celý výstup",
    "version": "Verze {version}",
    "lockedPreview": {
      "title": "Co se v tomto kroku objeví",
      "owner": "Kdo krok odemkne",
      "when": "Kdy se odemkne"
    },
    "doneRecap": {
      "eyebrow": "Předáno",
      "open": "Otevřít výstup"
    },
    "loadError": "Obsah se teď nepodařilo načíst. Nic se neztratilo, stačí to zkusit znovu.",
    "flowTitle": "Jak to proběhne",
    "flow1": "Projdi návrh prodejní strategie včetně cen a tarifů. Přidej připomínky, nebo ho schval.",
    "flow2": "Po schválení připravíme stránku, e-maily a webinář. Současně ti otevřeme propojení Stripe.",
    "flow3": "Schval prodejní stránku, propoj Stripe a pak si vyber způsob publikace.",
    "reviewLoop": {
      "intro": "Jak chceš {document} posunout dál",
      "commentsTitle": "Chci něco upravit",
      "commentsCopy": "Přidej připomínky textem nebo přes Mluv a ukazuj. Připravíme novou verzi.",
      "approveTitle": "Je to takhle správně",
      "approveCopy": "Dojdi na konec materiálu a odsouhlas ho. Tím se připomínky uzamknou.",
      "material": {
        "strategy": "prodejní strategii",
        "salespage": "prodejní stránku",
        "emails": "e-maily",
        "webinar": "webinář"
      },
      "unlocks": "Schválením se odemkne tvorba prodejní stránky, e-mailů a struktury webináře. Ceny a tarify jsou součástí návrhu, schválení platí i pro ně."
    },
    "feedbackSummary": {
      "waiting": "Celkem připomínek: {total}. Čeká na zapracování: {waiting}.",
      "partial": "Celkem: {total}. Zapracováno: {implemented}. Čeká: {waiting}.",
      "implemented": "Všech {total} připomínek je zapracovaných.",
      "error": "Stav připomínek se teď nepodařilo načíst.",
      "totalLabel": "Celkem",
      "implementedLabel": "Zapracováno",
      "waitingLabel": "Čeká"
    },
    "strategy": {
      "title": "Návrh prodejní strategie",
      "approvalHint": "Odsouhlasením potvrzuješ celý návrh včetně cen a tarifů. Připomínky přidej před odsouhlasením níže přes Mluv a ukazuj.",
      "reviewDownload": "Prohlédnout a stáhnout",
      "next": {
        "title": "Další materiály se vytváří",
        "action": "Přejít k dalšímu kroku"
      },
      "preparingWait": {
        "title": "Připravujeme návrh prodejní strategie",
        "copy": "Pracujeme s tvými odpověďmi a připravujeme návrh prodejní strategie včetně cen a tarifů. Jakmile budeme mít materiál pro tebe připravený, uvidíš ho tady.",
        "eta": "Návrh připravujeme obvykle do 2-3 pracovních dnů. Pošleme ti upozornění, až bude potřeba tvoje zpětná vazba."
      },
      "approvedWait": {
        "title": "Strategie je odsouhlasená",
        "calm": "Nyní nemusíš nic dělat. Připravujeme prodejní materiály.",
        "eta": "Obvykle 2-3 pracovní dny. Dáme ti vědět e-mailem."
      },
      "reviewGuide": {
        "eyebrow": "Až dokument otevřeš",
        "title": "Jak se strategie posune dál",
        "approveTitle": "Když je návrh v pořádku",
        "approveCopy": "Na konci ho odsouhlasíš. Tím spustíš přípravu prodejní stránky, e-mailů a webináře.",
        "feedbackTitle": "Když chceš něco změnit",
        "feedbackCopy": "Přímo v dokumentu napiš připomínku nebo použij Mluv a ukazuj. Připravíme novou verzi."
      }
    },
    "pageApprovalHint": "Odsouhlasením potvrzuješ obsah i podobu prodejní stránky. Připomínky přidej před odsouhlasením přes Mluv a ukazuj.",
    "gate": {
      "approve": "Odsouhlasit dokument",
      "approving": "Odsouhlasuji...",
      "approvedNote": "Dokument je odsouhlasený.",
      "readFirst": "Přečti návrh. Odsouhlasení najdeš na konci.",
      "readProgress": "Přečteno {progress} %",
      "endTitle": "Teď můžeš dokument odsouhlasit",
      "hint": "Připomínky přidej níže přes Mluv a ukazuj. Po odsouhlasení se uzamknou.",
      "feedbackLabel": "Připomínky k dokumentu",
      "feedbackPlaceholder": "Napiš, co upravit, doplnit nebo co nesedí…",
      "send": "Odeslat připomínky",
      "sending": "Odesílám…",
      "feedbackSent": "Připomínky jsme dostali. Zapracujeme je a ozveme se s novou verzí.",
      "approvedStrategyNote": "Strategie je odsouhlasená. Spouštíme tvorbu dalších marketingových materiálů.",
      "staffReturned": "Parťák ti to vrátil k dopracování: {reason}",
      "staffApprovedNote": "Schválení potvrdil parťák po domluvě s tebou."
    },
    "doc": {
      "read": "Otevřít dokument",
      "close": "Zavřít",
      "actionHint": "V dokumentu návrh odsouhlasíš, nebo k němu namluvíš připomínky.",
      "review": "Prohlédnout a komentovat",
      "panelLabel": "Připomínky",
      "meta": "Verze {version} · {date} · Připravil tým BuddyPro"
    },
    "walk": {
      "title": "Mluv a ukazuj",
      "explain": "Zapni nahrávání, ukazuj kurzorem (na telefonu prstem) na místa v dokumentu a říkej své připomínky nahlas. Uložíme hlas i to, na co ukazuješ.",
      "start": "Spustit nahrávání",
      "stop": "Zastavit a uložit",
      "cancel": "Zrušit",
      "recInstruction": "Ukazuj, o čem mluvíš. Mikrofon uloží.",
      "sendingNote": "Přepisujeme nahrávku a ukládáme tvoje připomínky.",
      "sentTitle": "Odesláno",
      "sent": "Připomínka je uložená níže v seznamu. Tvůj parťák ji uvidí; nic dalšího odesílat nemusíš.",
      "another": "Nahrát další",
      "error": "Nahrávání se nepodařilo spustit. Zkontroluj prosím přístup k mikrofonu.",
      "empty": "V nahrávce jsme nezachytili žádnou řeč. Zkus to prosím znovu.",
      "status": {
        "uploading": "Odesílá se...",
        "transcribing": "Přepisuje se...",
        "done": "Hotovo."
      }
    },
    "notes": {
      "title": "Uložené připomínky",
      "walkBadge": "Mluv a ukazuj",
      "delete": "Smazat připomínku",
      "writeToggle": "Napsat připomínku textově",
      "saveNote": "Uložit připomínku",
      "workedIn": "Nová verze zapracovala dřívější připomínky.",
      "voiceOnly": "Hlasová připomínka",
      "voiceTranscribing": "Hlasová připomínka, převádíme ji na text...",
      "voiceNoSpeech": "V nahrávce jsme nerozpoznali žádnou řeč. Poslechni si ji.",
      "voiceFailed": "Přepis nahrávky se nepovedl. Poslechni si ji.",
      "voicePlay": "Přehrát nahrávku",
      "anchorHint": "Ukázat místo v dokumentu (najetí zvýrazní, klik posune)",
      "anchorCount": "Místa v dokumentu ({count})",
      "state": {
        "saved": "Uloženo",
        "sent": "Odesláno ke zpracování",
        "working": "Zapracovává se",
        "handled": "Zapracováno",
        "dismissed": "Nerelevantní"
      },
      "hint": {
        "saved": "Parťák ji vidí. Až ji zapracujeme do nové verze, stav se tu změní.",
        "sent": "Parťák ji odeslal ke zpracování. Čeká na zahájení.",
        "working": "Právě ji zapracováváme do nové verze. Ta se tu objeví sama.",
        "handled": "Zapracovaná do nové verze materiálu.",
        "dismissed": "Parťák ji uzavřel jako nerelevantní. Zůstává tu pro dohledání."
      },
      "workingBanner": "Zapracováváme tvoje připomínky do nové verze. Stav každé z nich vidíš níže.",
      "flowHint": "Připomínky vidí tvůj parťák hned po uložení. Nic dalšího odesílat nemusíš.",
      "resolvedAt": "Zapracováno {time}"
    },
    "emails": {
      "copyAll": "Zkopírovat všechny e-maily",
      "copyOne": "Zkopírovat text",
      "copied": "Zkopírováno",
      "copyFailed": "Kopírování se nepovedlo. Označ si text ručně.",
      "copySubject": "Zkopírovat předmět",
      "copyFailedShort": "Nepovedlo se",
      "headHint": "Každý e-mail zkopíruješ přímo z osy. Klikni na něj, když si ho chceš přečíst celý.",
      "phaseFallback": "E-maily kampaně",
      "phaseCount": "{count}× e-mail",
      "strategyTitle": "Jak kampaň funguje",
      "strategyLead": "Rozesílací strategie: segmenty, kalendář a důvody, proč e-maily jdou právě v tomto pořadí.",
      "facts": {
        "emails": "e-mailů celkem",
        "phases": "fází kampaně",
        "span": "rozsah rozesílky"
      },
      "card": {
        "open": "Otevřít e-mail",
        "close": "Sbalit e-mail",
        "position": "{index} z {total}",
        "untitled": "E-mail {order}"
      },
      "detail": {
        "subject": "Předmět",
        "day": "Kdy odejde",
        "segment": "Komu jde",
        "task": "Co má e-mail udělat",
        "note": "Poznámka",
        "altSubjects": "Náhradní předměty na testování",
        "previous": "Předchozí e-mail",
        "next": "Další e-mail",
        "navLabel": "Pohyb mezi e-maily"
      }
    },
    "publish": {
      "eyebrow": "Publikace stránky",
      "title": "Možnosti publikace",
      "waiting_page": "Čeká na stránku",
      "locked_page": "Čeká na schválení",
      "locked_stripe": "Čeká na Stripe",
      "ready": "Připraveno k publikaci",
      "update": "Čeká nová verze",
      "published": "Publikováno",
      "waitingPage": "Nejdřív připravíme prodejní stránku. Možnosti publikace se tu objeví automaticky.",
      "lockedPage": "Nejdřív si prodejní stránku projdi a schval ji. Pak se otevřou možnosti publikace.",
      "lockedStripe": "Propoj Stripe. Stažení a publikaci otevřeme, až ověříme, že platby chodí na tvůj účet a stránka obsahuje platební odkazy.",
      "timeline": {
        "title": "Postup k publikaci",
        "page": "Schválení stránky",
        "stripe": "Stripe přijímá platby",
        "delivery": "Stažení nebo publikace",
        "preparing": "Připravujeme",
        "awaiting_approval": "Čeká na schválení",
        "awaiting_client": "Čeká na tebe",
        "done": "Hotovo",
        "locked": "Naváže potom",
        "next": "Další krok se otevře automaticky po dokončení aktuálního bodu."
      }
    },
    "delivery": {
      "title": "Kam stránku dostaneš",
      "lockedCopy": "Stránku ti vydáme, jakmile v ní budou vložené odkazy na objednávku (fáze Odkazy na objednávku výš).",
      "download": "Stáhnout ZIP",
      "downloadNote": "ZIP obsahuje index.html. Dej ho webaři, nebo ho nahraj na svůj hosting.",
      "netlify": "Netlify a vlastní subdoména",
      "netlifyNote": "Hosting zdarma pod tvým účtem. Stránku publikujeme za tebe a ukážeme ti přesný DNS záznam.",
      "netlifyExplain": "Netlify je hosting zdarma. Stránku tam publikujeme za tebe, ale účet i web jsou od začátku tvoje.",
      "netlifyAccountLink": "Založit účet Netlify",
      "netlifyAccountStep": "Otevři odkaz a dokonči bezplatnou registraci.",
      "netlifyTokenLink": "Otevřít osobní access tokeny",
      "netlifyTokenStep": "Klikni na New access token, pojmenuj ho Launchpad a token zkopíruj.",
      "netlifyPasteStep": "Vlož token do pole níže. Token se po uložení už nezobrazí.",
      "netlifyPublishStep": "Klikni na Publikovat stránku a počkej na potvrzení, že je web živý.",
      "netlifyTokenPlaceholder": "Vlož svůj Netlify access token",
      "netlifyPublish": "Publikovat stránku",
      "netlifyPublishing": "Publikuji...",
      "netlifyUpdate": "Publikovat novou verzi",
      "netlifyYours": "Web běží pod tvým Netlify účtem. Správa je čistě ve tvých rukou.",
      "netlifyDone": "Hotovo. Stránka je živá na tvém webu.",
      "netlifyAuthError": "Netlify token nepřijal. Zkontroluj, že je zkopírovaný celý a stále platí.",
      "netlifyTokenError": "Potřebujeme tvůj Netlify access token. Vlož ho prosím do pole.",
      "netlifyDeployError": "Netlify publikování odmítl. Zkus to znovu. Pokud chyba zůstane, domluv si mimořádný hovor s parťákem.",
      "netlifyArtifactError": "Prodejní stránka ještě nemá publikovatelný HTML soubor. Parťák musí nejdřív zveřejnit novou verzi stránky.",
      "netlifyPendingError": "Netlify stránku stále zpracovává. Počkej chvíli a pak klikni na Publikovat stránku znovu.",
      "dnsEyebrow": "Vlastní adresa",
      "dnsTitle": "Připojení vlastní subdomény",
      "dnsExplain": "Zadej celou adresu, třeba prodej.tvojedomena.cz. Launchpad ji nastaví na Netlify. U správce domény pak ručně přidáš jediný CNAME záznam.",
      "dnsDomainLabel": "Celá adresa prodejní stránky",
      "dnsDomainPlaceholder": "prodej.tvojedomena.cz",
      "dnsConfigure": "Nastavit adresu na Netlify",
      "dnsConfiguring": "Nastavuji adresu...",
      "dnsConfigured": "Netlify nastaveno",
      "dnsAuthError": "Uložený Netlify token už neplatí. Vlož nový token a publikuj stránku znovu.",
      "dnsConfigureError": "Netlify adresu nepřijal. Zkontroluj ji a zkus nastavení znovu.",
      "dnsStep": {
        "provider": "Přihlas se ke správci domény a otevři DNS záznamy.",
        "record": "Přidej CNAME s názvem a cílem uvedeným níže.",
        "wait": "Ulož změnu. Propagace obvykle trvá několik minut, někdy až hodinu."
      },
      "dnsType": "Typ",
      "dnsRecordType": "CNAME",
      "dnsName": "Název",
      "dnsHost": "prodej",
      "dnsValue": "Cíl",
      "dnsTtl": "TTL",
      "dnsPending": "Přesný CNAME cíl se ukáže po první úspěšné publikaci na Netlify.",
      "dnsPartnerCall": "Domluv si mimořádný hovor s parťákem"
    },
    "phases": {
      "listLabel": "Fáze kroku",
      "approve": "Schválení prodejní stránky",
      "links": "Odkazy na objednávku",
      "publish": "Publikace prodejní stránky",
      "publishLocked": "Publikaci odemkneme, jakmile budou odkazy na objednávku vložené ve stránce. Do té doby by sis {{g:stahoval|stahovala}} stránku, ze které nejde objednat.",
      "publishedVia": {
        "download": "Hotovo {when}, stránku sis {{g:stáhl|stáhla}}. Nic se tím nezavírá: stáhnout ji můžeš znovu a publikovat přes nás taky.",
        "netlify": "Hotovo {when}, stránka běží na tvém Netlify. Nic se tím nezavírá: novou verzi publikuješ jedním kliknutím a stáhnout ji můžeš pořád."
      }
    },
    "orderLinks": {
      "lockedCopy": "Odkazy na objednávku doplníš po schválení prodejní stránky.",
      "ownerOnly": "Odkazy na objednávku vyplňuje majitel účtu.",
      "intro": "Tarify máš ze schválené prodejní stránky. Ke každému doplň odkaz na objednávku. Může to být Stripe payment link, FAPI formulář nebo objednávka na tvém webu.",
      "introCustom": "Tarify se ze stránky nenačetly. Vypiš je přesně tak, jak je nabízí tvoje prodejní stránka, a ke každému doplň odkaz na objednávku.",
      "manualNote": "Tenhle režim se objevil jen proto, že se tarify ze stránky nepodařilo přečíst. Jinak je vypisujeme za tebe.",
      "missingTitle": "Tarify se ze stránky nenačetly",
      "missingCopy": "Ze schválené prodejní stránky se nepodařilo přečíst nabídku tarifů. Vypiš je ručně přesně tak, jak je stránka nabízí, a ke každému doplň odkaz na objednávku.",
      "manualEnable": "Vypsat tarify ručně",
      "manualEnabling": "Připravuju…",
      "nameLabel": "Název tarifu",
      "namePlaceholder": "Např. Roční členství",
      "urlLabel": "Odkaz na objednávku tarifu",
      "urlPlaceholder": "https://…",
      "add": "Přidat tarif",
      "remove": "Odebrat",
      "confirm": "Potvrzuji, že odkazy jsou správné",
      "confirming": "Ukládám…",
      "confirmedNote": "Odkazy jsou potvrzené. Teď je můžeme vložit do tvé stránky.",
      "integrate": "Vložit odkazy do stránky",
      "integrating": "Odesílám…",
      "fillHint": "Ještě chybí odkaz u: {list}.",
      "rowLabel": "řádek",
      "sentTitle": "Odesláno ke zpracování",
      "workingTitle": "Pracujeme na vložení odkazů",
      "workingCopy": "Vkládáme odkazy do tvé prodejní stránky. Dáme ti vědět, až to bude hotové.",
      "integratedCopy": "Odkazy jsou ve stránce. Stažení i publikace níže jsou odemčené.",
      "saveError": "Odkazy se teď nepodařilo uložit. Zkus to prosím znovu.",
      "confirmError": "Potvrzení se teď nepodařilo uložit. Zkontroluj, že je každý odkaz vyplněný, a zkus to znovu.",
      "integrateError": "Odeslání se teď nepovedlo. Zkus to prosím znovu."
    }
  },
  "doc": {
    "copy": {
      "action": "Zkopírovat",
      "done": "Zkopírováno",
      "failed": "Nezkopírovalo se"
    },
    "timeline": {
      "aria": "Časová osa kampaně",
      "jump": "Přejít na e-mail"
    },
    "email": {
      "subject": "Předmět",
      "altSubject": "Náhradní předmět",
      "preheader": "Náhled ve schránce",
      "preheaderTip": "Krátký text, který schránky ukážou vedle předmětu. Není to druhý předmět.",
      "body": "Text e-mailu",
      "auto": "odchází sám"
    },
    "map": {
      "aria": "Mapa kampaně"
    },
    "funnel": {
      "aria": "Funnel webináře",
      "goal": "Cíl",
      "jump": "Přejít na detail"
    },
    "wf": {
      "aria": "Drátěnka stránky",
      "form": "Formulář",
      "button": "Tlačítko"
    },
    "evening": {
      "aria": "Osa večera",
      "jump": "Přejít na fázi",
      "expandAll": "Rozbalit vše",
      "collapseAll": "Sbalit vše",
      "step1": "krok",
      "step2": "kroky",
      "step5": "kroků"
    },
    "seam": {
      "before": "Navazuje na",
      "after": "Připravuje"
    },
    "mi": {
      "example": "Příklad"
    },
    "arc": {
      "aria": "Příběhový oblouk večera"
    },
    "scope": {
      "covers": "Pokrývá",
      "offer": "Slib nabídky"
    },
    "calc": {
      "aria": "Kalkulačka výtěžnosti večera",
      "reset": "Vrátit přednastavená čísla",
      "audienceLegend": "Komu vysíláte",
      "modeLegend": "Co počítáte",
      "modeForward": "Z počtu lidí spočítat peníze",
      "modeGoal": "Z cíle spočítat, kolik lidí přivést",
      "driver": "Zadáváte",
      "answer": "Vychází",
      "visits": "Návštěvy registrační stránky",
      "visitsNeeded": "Kolik lidí přivést na registrační stránku",
      "registrations": "Registrací",
      "attended": "Lidí na vysílání",
      "orders": "Objednávek",
      "rateReg": "Registruje se",
      "rateShow": "Přijde na vysílání",
      "rateBuy": "Koupí",
      "baseVisits": "z lidí, kteří přišli na registrační stránku",
      "baseRegistrations": "z registrovaných",
      "baseAttended": "z těch, kdo přišli na vysílání",
      "from": "od",
      "to": "do",
      "rangeSep": "až",
      "decimalSep": ",",
      "midHint": "spíš počítejte s",
      "needsRate": "doplňte konverzi nad nulou",
      "goalUnits": "Kolik chcete prodat",
      "goalMoney": "Kolik chcete vydělat",
      "tariffLegend": "Za jaký tarif počítáte",
      "tariffSingle": "Počítáme s tarifem",
      "recommended": "doporučeno",
      "revenue": "Tržba",
      "cpv": "Cena za jednu návštěvu",
      "budget": "Rozpočet na reklamu",
      "net": "Zbyde Vám",
      "times": "Reklama se vrátí",
      "timesUnit": "krát",
      "currency": "Kč",
      "formula": "Vzorec: návštěvy × registrace × účast × nákup = objednávky, objednávky × cena tarifu = tržba."
    }
  },
  "handover": {
    "eyebrow": "Krok 18",
    "copy": "Telegram bota už vlastníš z beta testování. Zbývají poslední dva kroky: nastavíme tě jako {{g:majitele|majitelku}} instance a ty si otevřeš svůj Owner Dashboard.",
    "lockedCopy": "Předání otevřeme, jakmile budeš mít schválené všechny prodejní podklady. Do té doby od tebe nic dalšího nepotřebujeme.",
    "lockedEyebrow": "Co bude následovat",
    "lockedTitle": "Předání má tři jasné části",
    "lockedWaiting": "Čeká na tebe",
    "lockedLater": "Naváže potom",
    "lockedSteps": {
      "materials": "Schválení všech prodejních podkladů",
      "ownership": "Nastavení role majitele instance",
      "dashboard": "Předání Owner Dashboardu a přístupů"
    },
    "lockedNext": "Teď dokonči schvalování prodejních podkladů. Jakmile budou všechny schválené, předání se otevře automaticky.",
    "sellingCopy": "Hotovo: Buddy je celý tvůj a spravuješ ho ve svém Owner Dashboardu.",
    "sellingDate": "Předání dokončeno {date}",
    "licenseEyebrow": "Licence",
    "licenseTitle": "Co můžeš používat",
    "licenseValid": "Platí od {date}",
    "accessEyebrow": "Přístupy",
    "accessTitle": "Předané nástroje",
    "proof": {
      "bot_transferred": "Bot je převedený",
      "stripe_receiving": "Stripe přijímá platby",
      "assets_handed": "Prodejní podklady jsou předané",
      "first_campaign_or_trial": "První kampaň nebo trial běží",
      "telegram_launch": "Buddy běží na Telegramu",
      "app_live": "Mobilní aplikace je spuštěná",
      "order_links_integrated": "Odkazy na objednávku jsou v prodejní stránce",
      "salespage_published": "Prodejní stránka je vydaná"
    },
    "whatOwnershipTitle": "Správcovství instance",
    "whatOwnershipCopy": "V instanci ti nastavíme roli majitele. Získáš plnou kontrolu: statistiky, uživatele i nastavení.",
    "telegramCopy": "Napiš nám svůj osobní Telegram účet. Přes něj ti nastavíme roli majitele.",
    "telegramStored": "Roli majitele nastavíme účtu:",
    "telegramOwnerOnly": "Účet pro převod zadává majitel.",
    "sellingDashboard": "Předání je dokončené. Do Owner Dashboardu se přihlásíš kdykoli na dashboard.buddypro.ai.",
    "openDashboard": "Otevřít Owner Dashboard",
    "step2Title": "Vytvoř si přístup k Owner Dashboardu",
    "step2Copy": "Owner Dashboard je místo, kde budeš Buddyho spravovat: statistiky, uživatelé, předplatná i nastavení. Všechno na jednom místě a jen tvoje.",
    "step2Lock": "Otevře se hned po kroku 1. Potřebujeme tvoje Telegram ID: podle něj ti nastavíme roli majitele a bez ní ti bot propojení s dashboardem nevydá.",
    "licenseKeyEyebrow": "Licenční klíč",
    "licenseKeyLabel": "Tvůj licenční klíč",
    "licenseKeyCopy": "Zkopírovat",
    "licenseKeyCopied": "Zkopírováno",
    "licenseKeyOwn": "Tenhle klíč je tvoje licence: potvrzuje, že Buddy patří tobě. Vyplníš ho při registraci a ještě jednou při připojení experta.",
    "licenseKeyPreparing": "Licenční klíč připravujeme. Jakmile ho sem doručíme, uvidíš ho tady i s tlačítkem na zkopírování.",
    "licenseKeyDelayed": "Trvá to déle než obvykle. Víme o tom, řešíme to a ozveme se ti.",
    "licenseKeyUsed": "Licenční klíč už je použitý v tvém účtu Owner Dashboardu.",
    "flow": {
      "signupTitle": "Založ si účet na dashboard.buddypro.ai",
      "signupCopy": "Na registrační stránce vyplň e-mail, heslo a do pole Licenční klíč vlož klíč z pole výše. Potom klikni na Registrovat se.",
      "signupOpen": "Otevřít registraci",
      "syncTitle": "Obrazovka Nejprve synchronizujte svého BuddyPro",
      "syncCopy": "Po registraci tě dashboard pošle rovnou sem. Pod nadpisem Jak připravit vašeho experta jsou tři kroky:",
      "syncOpenTelegramKnown": "Otevřete Telegram: přejdi do chatu se svým botem",
      "syncOpenTelegram": "Otevřete Telegram: přejdi do chatu se svým BuddyPro expertem v Telegramu.",
      "syncUpdate": "Spusťte příkaz update: pošli botovi příkaz",
      "syncCheck": "Vraťte se sem: po dokončení aktualizace klikni na Zkontrolovat stav.",
      "connectTitle": "Obrazovka Připojte svého existujícího experta",
      "connectCopy": "Dashboard tvého experta pozná sám a rovnou nabídne jeho připojení. Chce od tebe dvě věci:",
      "connectLicense": "Vyžadován licenční klíč: do pole Licenční klíč vlož klíč z pole výše. Zjistíš ho i tak, že pošleš svému botovi /myLicense.",
      "connectCode": "Propojovací kód: pošli svému botovi příkaz /connectWeb a obratem ti přijde 12znakový kód. Vlož ho do pole Propojovací kód a klikni na Připojit experta. Otevře se tvůj dashboard a uvidíš svou instanci.",
      "openBotChat": "Otevřít chat s botem {bot}",
      "codeRoleReady": "Roli majitele máš nastavenou. Když ti bot na /connectWeb kód nepošle, počkej pár minut a zkus to znovu.",
      "codeRoleWaiting": "Tenhle krok zafunguje až po nastavení role majitele. Nastavujeme ji automaticky, obvykle do pár minut, a dáme ti vědět."
    },
    "confirmDashboard": "Dashboard se mi otevřel a vidím svou instanci",
    "confirmSending": "Odesílám...",
    "confirmedNote": "Máme potvrzeno, dashboard ti běží. Tým teď dokončí předání; hotový krok uvidíš tady i v cestě.",
    "confirmOwnerOnly": "Otevření dashboardu potvrzuje majitel.",
    "docsLink": "Podrobný postup s obrazovkami najdeš v dokumentaci.",
    "step1DoneReady": "Roli majitele máš nastavenou. Můžeš pokračovat krokem 2.",
    "step1DoneWaiting": "Roli majitele ti podle tohohle ID nastavujeme automaticky, obvykle to trvá pár minut. Dáme ti vědět, jakmile bude hotová. Do té doby si v kroku 2 můžeš založit účet a zkopírovat licenční klíč.",
    "ownerRolePill": "Nastavujeme roli",
    "confirmOwnerRoleWait": "Potvrzení otevřeme, jakmile ti nastavíme roli majitele. Děje se to automaticky, obvykle do pár minut. Bez role ti bot propojovací kód nevydá, takže by nebylo co potvrdit.",
    "ownerRoleFix": {
      "owner_not_member": "Účet s tímhle Telegram ID zatím není uživatelem tvého Buddyho, a roli majitele umí instance dát jen svému uživateli. Otevři si chat s botem, napiš mu cokoliv, a potom sem ID pošli znovu.",
      "invalid_owner_id": "Uložené číslo nevypadá jako Telegram ID. Napiš svému botovi /myid a pošli sem číslo, které ti odpoví."
    }
  },
  "app": {
    "eyebrow": "Mobilní aplikace",
    "title": "Mobilní aplikace běží vlastním tempem",
    "copy": "Apple účet, sestavení a schválení v obchodech mají vlastní postup. Dokončení předání na aplikaci nezávisí.",
    "checklistTitle": "Apple Developer účet",
    "checklistCopy": "Potvrď stav svého Apple Developer účtu. Vyplň, co už máš hotové, ať víme, kde jsi, a můžeme rozjet přípravu tvojí aplikace. Zaškrtávej jen to, co je opravdu za tebou.",
    "apple": {
      "eyebrow": "Krok 3",
      "lead": "Aby aplikace vyšla v obchodech pod jménem tvojí firmy, vyžaduje Apple tvůj vlastní vývojářský účet za 99 USD ročně. Založíš ho jen jednou. Publikaci i aktualizace pak řešíme my.",
      "confirmPrompt": "Registraci u Applu máš podle nás za sebou. Potvrď to a tenhle krok se uzavře.",
      "haveAccount": {
        "question": "Máš už Apple Developer účet?",
        "copy": "Podle odpovědi ti ukážeme jen to, co opravdu potřebuješ.",
        "yes": "Ano, účet už mám",
        "no": "Ne, teprve ho založím",
        "change": "Změnit odpověď"
      },
      "existing": {
        "heading": "Propoj svůj Apple Developer účet",
        "lead": "Účet už máš, takže nic nezakládáš. Stačí nám pár údajů, podle kterých aplikaci připojíme k tvému účtu.",
        "title": "Údaje o tvém účtu",
        "copy": "Vyplň typ účtu, Team ID a e-mail, který používáš v App Store Connect.",
        "active": "Členství v Apple Developer Program mám aktivní (roční poplatek je zaplacený).",
        "activeShort": "aktivní členství",
        "submit": "Uložit údaje o účtu"
      }
    },
    "appleGuide": {
      "eyebrow": "Nejdřív si připrav účet",
      "title": "Apple Developer účet krok za krokem",
      "intro": "Účet musí založit jeho budoucí majitel. Na žádost si vyhraď přibližně 20 minut. Apple si potom ověří firmu, obvykle to trvá 1 až 2 pracovní dny.",
      "approvalNote": "Po odeslání sleduj e-mail od Apple. Dokud žádost neschválí, můžeš dál vyplňovat podklady k aplikaci.",
      "needsTitle": "Co budeš potřebovat",
      "needs": {
        "appleId": "Apple ID se zapnutým dvoufaktorovým ověřováním.",
        "identity": "Celé právní jméno a dosažení zákonem stanoveného věku. Nepoužívej přezdívku ani alias.",
        "contact": "E-mail, telefon a skutečnou adresu. Apple nepřijímá P.O. box.",
        "company": "Pro firmu navíc D-U-N-S, právní název firmy, pracovní e-mail na její doméně a funkční veřejný web."
      },
      "pathTitle": "Vyber správný typ účtu",
      "path": {
        "recommended": "Doporučeno",
        "individualTitle": "Jednotlivec",
        "individualCopy": "Zvol jen tehdy, když nemáš firmu a v App Store může být jako prodejce uvedeno tvoje právní jméno. D-U-N-S nepotřebuješ, ale prodejce zůstane tvoje jméno.",
        "organizationTitle": "Organizace",
        "organizationCopy": "Tuhle cestu vedeme s klienty, kteří si kupují vlastní aplikaci: v obchodech je pak jako prodejce vidět tvoje firma. Firma musí být právnická osoba, potřebuje D-U-N-S a účet zakládá člověk, který za ni smí podepisovat."
      },
      "step": {
        "chooseTitle": "Zaregistruj se jako organizace",
        "chooseCopy": "Na developer.apple.com se registruj jako organizace, aby aplikace vyšla pod jménem tvojí firmy. Apple ID si případně založíš cestou. Jednotlivce zvol, jen když firmu nemáš.",
        "secureTitle": "Zkontroluj Apple ID a dvoufaktorové ověřování",
        "secureCopy": "Přihlas se ke svému Apple ID a ověř, že máš zapnuté dvoufaktorové ověřování. Bez něj žádost neodešleš.",
        "legalDetailsTitle": "Připrav přesné osobní údaje",
        "legalDetailsCopy": "Použij celé právní jméno, e-mail, telefon a adresu bydliště nebo sídla bez P.O. boxu. Pro registraci musíš dosáhnout zákonem stanoveného věku ve své zemi.",
        "enrollTitle": "Otevři registraci",
        "enrollCopy": "Žádost spusť na webu Apple Developer Program nebo v aplikaci Apple Developer. Přihlas se stejným Apple ID, které bude účet vlastnit.",
        "companyTitle": "Pokud registruješ firmu, ověř firemní údaje",
        "companyCopy": "Potřebuješ platné D-U-N-S od Dun & Bradstreet, přesný právní název firmy, pracovní e-mail na firemní doméně, veřejný funkční web na stejné doméně a oprávnění podepisovat za firmu. D-U-N-S je zdarma, státní instituce ho nepotřebují. Vyřízení obvykle trvá asi 5 dnů. Po více než 2 týdnech kontaktuj Dun & Bradstreet.",
        "reviewTitle": "Odešli žádost a počkej na ověření firmy",
        "reviewCopy": "Apple si firmu ověří, obvykle za 1 až 2 pracovní dny. Někdy si detaily ověří telefonicky, tak buď na příjmu. Odpověz přesně podle e-mailu od Apple.",
        "finishTitle": "Po schválení dokonči členství a potvrď účet",
        "finishCopy": "Odsouhlas licenční smlouvu a zaplať 99 USD za rok. Apple částku zobrazí v místní měně. Potom získáš přístup do App Store Connect a tady dole vyplníš Team ID a potvrdíš účet."
      },
      "webLink": "Otevřít registraci na webu Apple",
      "appLink": "Otevřít aplikaci Apple Developer",
      "blockersTitle": "Co žádost nejčastěji zastaví",
      "blockers": {
        "nickname": "Přezdívka nebo alias místo právního jména.",
        "address": "P.O. box místo skutečné adresy.",
        "twoFactor": "Vypnuté dvoufaktorové ověřování Apple ID.",
        "duns": "Neplatné nebo neshodné D-U-N-S u firemního účtu.",
        "website": "Firemní web nefunguje, má jen minimální obsah nebo nesedí s doménou pracovního e-mailu."
      }
    },
    "duns": {
      "title": "Co je D-U-N-S a jak ho získáš",
      "whatIs": "D-U-N-S je devítimístné číslo firmy. Přiděluje ho společnost Dun & Bradstreet a slouží jako mezinárodní rodné číslo firem.",
      "whyApple": "Apple si jím ověří, že tvoje firma opravdu existuje. Proto ho chce po každém, kdo si zakládá firemní účet.",
      "free": "Je zdarma a spousta firem ho už má, aniž by o tom věděla.",
      "lookupLink": "Ověřit D-U-N-S u Applu",
      "lookupCopy": "Apple na to má vlastní stránku. Zadáš na ní firmu a hned uvidíš, jestli číslo má. Když ji seznam nenajde, požádáš o přidělení na stejném místě.",
      "prepareTitle": "Co si připrav",
      "prepare": {
        "legalName": "Přesný právní název firmy podle obchodního rejstříku, ne obchodní značku ani zkratku.",
        "address": "Adresu sídla tak, jak je zapsaná.",
        "contact": "Jméno, pracovní e-mail a telefon člověka, který za firmu jedná."
      },
      "timingTitle": "Kolik času si nechat",
      "timingCopy": "Dun & Bradstreet číslo vyřídí zhruba do 5 pracovních dnů a Apple se o něm dozví do dalších dvou. Počítej tedy asi s týdnem, a to ještě než se pustíš do registrace u Applu.",
      "mismatchTitle": "Když údaje nesedí",
      "mismatchCopy": "Číslo samo nestačí. Pokud se název nebo adresa liší od rejstříku, Apple žádost zamítne. Opravu řeší Dun & Bradstreet na support.dnb.com a k Applu se propíše zhruba za dva dny.",
      "individualNote": "Podnikáš jako OSVČ a firmu jako právnickou osobu nemáš? Pak D-U-N-S neřeš a registruj se jako jednotlivec. V obchodech pak bude jako prodejce tvoje jméno."
    },
    "check": {
      "twoFactor": "Mám zapnuté dvoufaktorové ověřování",
      "accountType": "Typ účtu",
      "dunsRequired": "Firemní účet vyžaduje platné D-U-N-S.",
      "dunsConfirmed": "Mám platné D-U-N-S a údaje se shodují s firmou",
      "fee": "Počítám s poplatkem 99 USD za každý rok členství",
      "registration": "Stav registrace",
      "teamId": "Apple Team ID",
      "teamIdHelp": "10místný kód, najdeš ho na developer.apple.com v sekci Membership. Podle něj aplikaci připojíme k tvému účtu. Můžeš doplnit i později.",
      "connectEmail": "E-mail do App Store Connect",
      "connectEmailHelp": "E-mail, kterým se přihlašuješ do App Store Connect. Pošleme na něj pozvánku pro náš tým.",
      "twoFactorHelp": "Zapneš ho na appleid.apple.com v sekci Přihlášení a zabezpečení. Bez něj Apple žádost nepřijme.",
      "accountTypeHelp": "Organizace znamená, že v obchodech je jako prodejce vidět tvoje firma. Jednotlivec znamená tvoje jméno.",
      "dunsConfirmedHelp": "Číslo i název a adresa se musí shodovat s obchodním rejstříkem. Nevíš, jestli ho firma má?",
      "feeHelp": "Apple ho strhne po schválení a pak vždycky jednou za rok. Bez zaplacení aplikace v obchodě nezůstane.",
      "registrationHelp": "Vyber, kde právě jsi: ještě nezačala, odeslaná a čekáš na Apple, nebo aktivní a účet ti běží.",
      "registrationMissing": "Odeslaná nebo aktivní registrace",
      "ownerOnly": "Apple účet zakládá a potvrzuje majitel účtu. Ty tady vidíš, jak daleko je.",
      "stepNotOpen": "Krok se právě otevírá. Načti stránku za chvíli znovu a formulář půjde vyplnit.",
      "submitNeeds": "Ještě čekáme na: "
    },
    "account": {
      "individual": "Jednotlivec",
      "organization": "Organizace"
    },
    "registration": {
      "notStarted": "Ještě nezačala",
      "submitted": "Odesláno do Apple",
      "active": "Účet je aktivní"
    },
    "submit": "Potvrdit zahájení",
    "submitting": "Potvrzuji...",
    "confirmAccount": "Potvrzuji, že developer účet mám založený",
    "confirmingAccount": "Potvrzuji...",
    "accountConfirmed": "Apple developerský účet je potvrzený.",
    "confirmAccountError": "Účet se nepodařilo potvrdit. Zkus to prosím znovu.",
    "questionnaire": {
      "eyebrow": "Krok 16",
      "title": "Dotazník k mobilní aplikaci",
      "locked": "Otevře se po schválení prodejní stránky.",
      "working": "Předvyplňujeme",
      "prefilling": "Předvyplňujeme dotazník z tvých podkladů. Můžeš chvíli počkat, nebo rovnou začít s prázdnou verzí.",
      "prefillDelayed": "Trvá to déle, než by mělo. Víme o tom a doděláme to. Klidně ale začni rovnou, o nic nepřijdeš.",
      "prefilledCopy": "Část odpovědí jsme ti předvyplnili z tvých podkladů. Projdi je, uprav, co sedí jinak, a doplň zbytek.",
      "useEmpty": "Začít s prázdným dotazníkem",
      "appleIndependent": "Příprava Apple Developer účtu běží samostatně a na schválení stránky nečeká.",
      "focusCopy": "Vyplň podklady pro mobilní aplikaci. Každý krok se ukládá automaticky."
    },
    "release": {
      "eyebrow": "Krok 19",
      "focusCopy": "Tady uvidíš, jak je tvoje mobilní aplikace daleko cestou do obchodů. Nahrání do App Store i na Google Play řešíme my.",
      "googlePlayPublisher": "Na Google Play appku vydáváme my, nic zakládat nemusíš.",
      "openAppStore": "Otevřít v App Store",
      "openGooglePlay": "Otevřít na Google Play",
      "status": {
        "draft": {
          "title": "Čekáme na tvůj dotazník",
          "copy": "Aplikaci začneme připravovat, jakmile nám odešleš vyplněný dotazník. Do té doby tu není co hlásit."
        },
        "submitted_for_publishing": {
          "title": "Odesláno k publikaci",
          "copy": "Tvoji aplikaci teď připravujeme do obchodů. Kdybychom od tebe něco potřebovali, ozveme se."
        },
        "in_publishing": {
          "title": "Probíhá publikace",
          "copy": "Tvoje aplikace se právě nahrává do App Store a na Google Play."
        },
        "live": {
          "title": "Tvoje aplikace je v obchodech",
          "copy": "Aplikace je publikovaná a lidé si ji můžou stáhnout. Odkazy do obchodů máš tady."
        },
        "rejected": {
          "title": "Potřebujeme pár úprav",
          "copy": "Obchod si při schvalování vyžádal změny. Uprav dotazník k aplikaci a odešli ho znovu, o zbytek se postaráme."
        },
        "archived": {
          "title": "Aplikace už není v obchodech",
          "copy": "Aplikaci jsme z obchodů stáhli. Když ji chceš vrátit zpátky, napiš svému parťákovi."
        }
      }
    },
    "upsellTitle": "Mobilní aplikaci můžeš přidat později",
    "upsellCopy": "Tvůj současný balíček aplikaci neobsahuje. Buddy a celý prodejní proces fungují i bez ní.",
    "upsellCardTitle": "Vlastní ikona a distribuce přes App Store",
    "upsellCardCopy": "Když budeš chtít aplikaci doplnit, probereme rozsah, cenu a termín samostatně.",
    "upsellAction": "Požádat o aplikaci",
    "interestRecorded": "Zaznamenali jsme tvůj zájem o aplikaci. Ozveme se ti s rozsahem, cenou a termínem.",
    "interestSending": "Zaznamenáváme zájem...",
    "upsellLearnMore": "Zjistit více o aplikaci",
    "submittedLead": "Podklady pro aplikaci máme. Teď je řada na nás a na obchodech.",
    "submittedTitle": "Podklady odeslané",
    "submittedCopy": "Čekáme na schválení obchodem, většinou to trvá 1-2 dny. Ozveme se, jakmile se něco pohne."
  },
  "invites": {
    "eyebrow": "Tvoje pracovní skupina",
    "title": "Pozvánky do týmu",
    "description": "Pozvaní lidé tě mohou zastupovat při přípravě. Cenu a převzetí dál potvrzuješ ty."
  },
  "staff": {
    "eyebrow": "Provozní přístup",
    "title": "Jsi v Launchpadu jako člen týmu",
    "description": "Klientské operace najdeš v zabezpečeném rozhraní pro tým."
  },
  "questionnaire": {
    "loadError": "Obsah se teď nepodařilo načíst. Nic se neztratilo, stačí to zkusit znovu.",
    "loadingTitle": "Načítáme tvůj dotazník",
    "loadingSavedAnswers": "Obnovujeme uložené odpovědi a připravujeme první otázku.",
    "clientCopy": {
      "q1TwinMode": "Má být Buddy tvoje AI dvojče, které mluví jako ty a za tebe? Nebo samostatný AI expert s vlastním jménem a osobností, který vychází z tvého know-how?"
    },
    "mobile": {
      "navigationLabel": "Otázky v dotazníku",
      "position": "Otázka {current} z {total}",
      "previous": "Předchozí otázka",
      "next": "Další otázka"
    },
    "close": "Zpět na přehled",
    "required": "Povinná otázka",
    "optional": "Volitelná otázka",
    "waitingTitle": "Zpracováváme tvoje nahrávky",
    "waitingCopy": "Odpovědi jsou bezpečně uložené. Až budou přepisy hotové, zadání dokončíme automaticky.",
    "submittedWaiting": "Dotazník je odeslaný a uzavřený. Ještě dokončujeme přepisy nahrávek.",
    "submittedClosed": "Dotazník je odeslaný a uzavřený. Odpovědi už nejde měnit.",
    "revealEyebrow": "Zadání je hotové",
    "reveal": {
      "q1": {
        "title": "Buddy už má tvůj rukopis",
        "copy": "Tvoje odpovědi teď bereme do rukou a stavíme z nich Buddyho, ve kterém se poznáš po prvních dvou větách."
      },
      "q2": {
        "title": "Teď stavíme tvůj prodejní tah",
        "copy": "Z tvého zadání připravíme balíček, se kterým Buddy osloví první zákazníky přesně po tvém."
      }
    },
    "backHome": "Zpět na přehled",
    "submitError": "Odeslání se nepovedlo. Zkontroluj povinné odpovědi a zkus to znovu.",
    "submitTechnicalError": "Odeslání se nepovedlo technickou chybou na naší straně. Zkus to znovu; kdyby to nepomohlo, napiš parťákovi.",
    "loadNewerAnswer": "Načíst novější verzi",
    "voiceRecommendationTitle": "Doporučení: odpovídej hlasem",
    "voiceRecommendationCopy": "Nahraj odpovědi jako hlasové zprávy. Je to rychlejší a odpovědi bývají bohatší. Přepis se uloží automaticky a drobné překlepy v něm vůbec nevadí. Nemusíš nic opravovat, s přepisem si poradíme.",
    "navigation": "Pohyb v dotazníku",
    "back": "Zpět",
    "next": "Pokračovat",
    "submit": "Přejít k dalšímu kroku",
    "submitAndContinue": "Odeslat dotazník a přejít k dalšímu kroku",
    "submitting": "Odesílám...",
    "save": {
      "idle": "Odpověď zatím není uložená",
      "dirty": "Ukládám za chvíli...",
      "saving": "Ukládám...",
      "saved": "Uloženo",
      "offline": "Jsi offline. Odpověď zůstala uložená v tomto zařízení.",
      "conflict": "Tahle odpověď se mezitím změnila v jiném okně.",
      "error": "Uložení se nepovedlo. Zkus to znovu."
    },
    "factCategory": {
      "identity": "Identita",
      "business": "Byznys",
      "audience": "Publikum",
      "offer": "Nabídka",
      "voice": "Hlas a styl",
      "proof": "Výsledky",
      "other": "Další informace"
    },
    "fact": {
      "confirm": "Sedí",
      "correct": "Upravit",
      "irrelevant": "Neplatí"
    },
    "sourceUnknown": "Zdroj z úvodního průzkumu",
    "permissionConfirmed": "Potvrzuji, že tyto příběhy, výsledky a reference smíme použít v rámci tvých prodejních materiálů.",
    "fields": {
      "buddyName": "Jméno Buddyho",
      "username": "Telegram username",
      "voice": "Hlas",
      "meditation": "Má Buddy vytvářet meditace?",
      "email_range": "Velikost e-mailové databáze",
      "audience_range": "Velikost publika na sítích",
      "mode": "Varianta",
      "model": "Prodejní model",
      "priceMin": "Cena od v Kč",
      "priceMax": "Cena do v Kč",
      "has_stripe": "Máš Stripe účet?",
      "googleAccount": "Google účet",
      "lexicon": "Tvoje pojmy a názvy",
      "lexiconPlaceholder": "Metoda NoCzenglish\nspaced repetition\nPryč s Czenglish",
      "selected": "Vyber odpověď",
      "community_where": "Napiš kde.",
      "campaign_type": "Jaký typ kampaní děláš nejčastěji?",
      "payment_method": "Jak tedy dnes přijímáš platby?",
      "other_gateway": "Napiš která.",
      "order_form_url": "Pokud něco běží, vlož odkaz na objednávkový formulář.",
      "materials": "Vlož odkazy nebo popiš, co máš. A u čeho chceš, abychom ho zachovali, a co klidně nahradíme?",
      "channels": "Jak k tobě přijdou noví lidé? Vyber, co je pro tebe reálné:",
      "budget": "Kolik peněz celkem můžeš dát do marketingu svého Buddyho?",
      "style_source": "Odkaz na tvůj web nebo grafiku, ze které máme vzít barvy a styl.",
      "design_feel": "Popiš vlastními slovy, jak má působit design webu tvého Buddyho.",
      "inspiration": "Příklady webů, které se ti líbí, klidně z jiného oboru.",
      "real_vs_estimate": "Typ zkušenosti",
      "list_engagement": "Jak často svému seznamu píšeš a kdy naposledy? Jak lidé reagují?",
      "marketing_time_weekly": "Kolik času týdně můžeš dát do marketingu svého Buddyho?",
      "own_links": "Přidej odkaz na svůj web nebo grafiku, ze které máme vzít barvy a styl.",
      "example_links": "Příklady webů, které se ti líbí, klidně z jiného oboru."
    },
    "usernameManual": "Dostupnost username ověří tým při zpracování zadání.",
    "choose": "Vyber možnost",
    "yes": "Ano",
    "no": "Ne",
    "options": {
      "clone": "Můj klon",
      "knowledge_expert": "AI expert na mém know-how",
      "other": "Jiný hlas",
      "under_1000": "Méně než 1 000",
      "1000_4999": "1 000 až 4 999",
      "5000_19999": "5 000 až 19 999",
      "20000_plus": "20 000 a více",
      "two_day_trial": "Dvoudenní trial",
      "webinar": "Webinář",
      "email_campaign": "Kampaň na databázi",
      "inside_program": "V rámci mého programu",
      "recommend": "Doporučte mi variantu",
      "range": "Mám cenové rozmezí",
      "both": "Obojí",
      "none": "Zatím nijak",
      "no_database": "Nemám",
      "database_under_1000": "Do 1 000",
      "database_1000_5000": "1 000 až 5 000",
      "database_5000_20000": "5 000 až 20 000",
      "database_more": "Víc",
      "has_stripe": "Mám",
      "no_stripe": "Nemám",
      "1000_5000": "1 000 až 5 000",
      "5000_20000": "5 000 až 20 000",
      "more": "Víc než 20 000",
      "inactive": "Nikde aktivně",
      "profiles_only": "Mám profily, ale nepřispívám",
      "active": "Aktivně přispívám",
      "community": "Mám živou komunitu",
      "unknown": "Nevím",
      "fapi": "FAPI",
      "other_gateway": "Jiná brána",
      "owner": "Pod mým jménem",
      "standalone": "Samostatná značka",
      "brand_recommend": "Doporučte mi",
      "paid_ads": "Placená reklama",
      "own_audience": "Oslovím vlastní okruh a komunitu",
      "build_socials": "Začnu aktivně budovat sítě",
      "acquisition_recommend": "Nevím, doporučte mi",
      "real": "Reálná zkušenost",
      "estimate": "Můj odhad",
      "yes": "Ano",
      "no": "Ne"
    },
    "repeat": {
      "item": "Položka {number}",
      "add": "Přidat další položku",
      "remove": "Odebrat",
      "minimum": "Přidej alespoň {count} kompletní položky."
    },
    "items": {
      "q1_01_business_essence_and_value": "Vyprávěj nám o své práci tak, jako když ji vysvětluješ někomu, kdo tě ještě nezná. Co děláš, komu pomáháš a čím se lišíš od ostatních v oboru? Co si má člověk odnést už po pěti minutách s tvým Buddym? V čem pro něj má být Buddy nejvíc užitečný?",
      "q1_02_twin_mode": "Má být Buddy tvůj digitální dvojník, který mluví jako ty a za tebe? Nebo samostatný AI expert s vlastním jménem a osobností, který vychází z tvého know how?",
      "q1_03_target_client": "Popiš svými slovy svého ideálního zákazníka. S čím za tebou nejčastěji přichází? Co ti napíše, když je mu nejhůř?",
      "q1_04_voice_and_impression": "Jak má Buddy na lidi působit? Jako přísný trenér, starostlivý parťák, chytrý stratég, nebo úplně jinak? Nejlépe nám to ukážeš na příkladu. Vzpomeň si na chvíli, kdy se ti podařilo klientovi opravdu pomoct, a nahraj nám, jak ten rozhovor tehdy zněl.",
      "q1_11_addressing_and_lexicon": "Tykáš svým klientům, nebo vykáš? A jaká slova, hlášky nebo oblíbené obraty od tebe lidé slýchají pořád? Buddy je po tobě zdědí.",
      "q1_05_method_or_framework": "Máš vlastní postup, pravidla nebo pojmy, podle kterých lidem radíš? Používáš vlastní název metody nebo kroky, které doporučuješ každému? Řekni nám o nich.",
      "q1_17_lexicon": "Používáš ve své práci vlastní názvy, zkratky nebo neobvyklá slova? Třeba název metody, programu, akronym, cizí termín nebo jméno, které se píše specificky. Vypiš je sem, každé zvlášť a přesně tak, jak se správně píše. Nemusíš nic vysvětlovat.",
      "q1_06_boundaries": "Co Buddy dělat nemá? Jsou témata, kterým se má vyhnout? A kdy má člověka raději odkázat na tebe nebo na odborníka?",
      "q1_12_never_advise": "Co by ti Buddy nikdy neměl říct ani poradit? Rady, se kterými nesouhlasíš, mýty, které vyvracíš. A přidej i značky nebo lidi, které nemá kritizovat.",
      "q1_07_buddy_name": "Jak se bude tvůj Buddy jmenovat? Rovnou zkusíme najít i volné uživatelské jméno na Telegramu.",
      "q1_08_voice_and_meditation": "Jakým hlasem má tvůj Buddy mluvit? Chceš, aby vytvářel také meditace?",
      "q1_09_first_message": "Představ si, že ti klient ráno napíše jen 'Ahoj'. Co mu odpovíš? Napiš nebo namluv přesně to, co by od tebe dostal. Pak ti připravíme návrh, který si upravíš.",
      "q2_01_origin_story": "Jak vedla tvoje cesta k tomu, co dnes děláš? Vyprávěj svůj příběh: kde začala, co byl moment zlomu a co tě naučila. Čím osobnější příběh bude, tím silnější marketing pro tebe postavíme.",
      "q2_02_intent_and_success": "Proč Buddyho spouštíš právě teď a co ti má přinést? Příjem navíc, volnější ruce, větší dosah tvé práce? A podle čeho za rok poznáš, že se to povedlo?",
      "q2_03_enemy_and_beliefs": "Co tvoji klienti obvykle vyzkoušeli, než našli tebe, a proč jim to nezafungovalo? A proti čemu se ve svém oboru vymezuješ ty: co se běžně radí, ale ty s tím nesouhlasíš?",
      "q2_04_client_stories": "Vyprávěj dva nebo tři skutečné příběhy z klientské praxe: jaká byla výchozí situace, co se změnilo a jaká čísla za tím jsou. U každého řekni, jestli ho smíme ukázat se jménem, nebo jen anonymně.",
      "q2_05_objections": "Co ti lidé říkají, když nakonec nekoupí? Jaké námitky slyšíš pořád dokola: cena, čas, nedůvěra? A co naopak rozhodlo u těch, kteří koupili?",
      "q2_06_proof": "Reference, recenze a výsledky, které smíme ukázat v marketingu. Napiš nebo namluv, co máš, a vlož odkazy, kde je najdeme.",
      "q2_07_authority_numbers": "Tvoje čísla, jak platí dnes: kolik let se oboru věnuješ, kolika lidem tvoje práce pomohla, kolik máš za sebou přednášek, kurzů nebo knih. Vezmeme jen to, co nám tady řekneš, nic si nebudeme domýšlet.",
      "q2_08_products_prices": "Tvoje produkty a ceny, jak je známe. Sedí to? Oprav, co je jinak, a doplň, co chybí.",
      "q2_09_one_on_one_value": "Kolik dnes stojí hodina s tebou: konzultace, mentoring, práce jeden na jednoho? A co všechno by musel člověk pořídit, aby získal to, co mu předáš ty: nejen tvoje vlastní produkty, ale i knihy, kurzy nebo nástroje, které by si jinak musel koupit jinde?",
      "q2_10_price": "Cena předplatného tvého Buddyho: mám představu (od do), nebo mi ji doporučte ve strategii.",
      "q2_11_first_audience": "Komu chceš Buddyho prodat jako prvnímu a kde tyhle lidi dnes máš? E-mailová databáze, Instagram, YouTube, komunita, firemní klienti? Odkud dnes přicházejí tvoji zákazníci? A zhruba jaké je jejich věkové a genderové složení?",
      "q2_12_audience_size": "Velikost e-mailové databáze a publika (rozsahy).",
      "q2_13_launch_experience": "Jaké prodejní akce už máš za sebou? Webináře, kampaně na databázi, placená reklama, spouštění kurzů? Co fungovalo nejlíp a jaká čísla si pamatuješ?",
      "q2_14_involvement": "Co chceš pro spuštění osobně udělat? Odvysílat živý webinář, natočit krátká videa, poslat svým lidem sérii e-mailů? Kolik času tomu můžeš dát a kdy chceš spouštět?",
      "q2_15_sales_model": "Prodejní model, který ti je blízký: dvoudenní trial / webinář / kampaň na databázi / v rámci mého programu / nechám na vás.",
      "q2_16_stripe": "Stripe účet: mám / nemám (založíme spolu v dalším kroku).",
      "q1_13_profile_photo": "Nahraj svou profilovou fotku: tu, ze které máme vytvořit AI verzi tebe a která poslouží jako náhledový obrázek tvého Buddyho. Ideálně portrét s dobře viditelným obličejem. Můžeš přidat i odkaz na fotku v plném rozlišení.",
      "q1_10_google_account": "Na jaký Google účet ti máme nasdílet složku pro tvoje know-how?",
      "q2_17_big_idea": "Jakou jedinou myšlenku by si měl trh od tebe zapamatovat? Řekni ji jako na pódiu. A dodej, v čem je tvůj přístup tak jiný, že se nedá srovnat s ničím, co lidé znají.",
      "q2_19_sales_photos": "Teď více fotek pro prodejní stránku: momentky z akcí, z práce s klienty nebo z natáčení a klidně další portréty. Skutečné fotky dělají stránku důvěryhodnou. Přidej i odkaz na web nebo složku, kde jsou fotky v plném rozlišení.",
      "q2_18_ai_value": "V čem vidíš hlavní výhodu toho, že lidi budou používat tvého Buddyho? Kde bude jeho největší hodnota a co je pro tvoji cílovku klíčový argument, proč si ho koupit?",
      "q2_20_moment_of_need": "V jakých chvílích ti klienti píšou nebo by potřebovali pomoc, když zrovna nejsi k dispozici? Vzpomeň si na dvě nebo tři konkrétní situace, kdy by jim tvůj Buddy nejvíc pomohl.",
      "q2_21_owner_usage": "Používáš svého Buddyho i pro sebe? Pokud ano, popiš konkrétní situaci, kdy ti opravdu pomohl: jaký problém se s ním podařilo vyřešit, co ti to přineslo a kde ti ušetřil práci. Čím konkrétnější příklad dáš, tím silnější argument získáš pro své klienty.",
      "q2_22_beta_group": "Máš kolem sebe pět až dvacet lidí, kteří by Buddyho na pár týdnů dostali zdarma výměnou za upřímnou zpětnou vazbu a příběhy? Napiš ano nebo ne a koho konkrétně chceš oslovit.",
      "q1_16_expression_style": "Co je typické pro tvůj způsob vyjadřování? Používáš humor, přirovnání nebo oblíbené příklady? Říkáš věci na rovinu, nebo je balíš do vaty? Popiš svou energii, klidně na příkladu.",
      "q1_15_situational_replies": "Jak povzbudíš někoho, komu se zrovna nedaří? A jak zareaguješ, když se někomu něco fakt povedlo? Odpověz svými slovy, klidně doslova. Přesně takhle bude v těch chvílích mluvit i tvůj Buddy.",
      "q1_14_initiated_messages": "Dobrý parťák se umí ozvat první. Na co by se měl tvůj Buddy svých klientů sám aktivně ptát? Napiš nebo namluv pět až deset otázek, které jim má položit. Třeba 'Jak ti šel minulý týden?' nebo 'Jak vypadá tvoje cash flow?'"
    },
    "v2": {
      "items": {
        "q2_m01_database": "Máš e-mailovou databázi kontaktů?",
        "q2_m02_socials": "Jak jsi na tom se sociálními sítěmi?",
        "q2_m03_allies": "Znáš lidi nebo firmy, kteří mluví ke stejným lidem jako ty a mohli by tvého Buddyho doporučit?",
        "q2_m04_practice": "Pracuješ s klienty jeden na jednoho?",
        "q2_m05_infoproducts": "Prodáváš aktivně online kurzy nebo e-booky?",
        "q2_m06_campaign": "{{g:Spustil|Spustila}} jsi někdy prodejní kampaň? Webinář, výzvu, funnel, launch.",
        "q2_m07_payments": "Máš Stripe účet?",
        "q2_m08_promo": "Už jsi svého Buddyho někdy {{g:propagoval|propagovala}}, nebo máš rozdělané materiály či stránky?",
        "q2_07_authority_numbers": "Kolika lidem jsi za svou kariéru {{g:pomohl|pomohla}}? Stačí odhad a řekni, od kdy počítáš. A jaké výsledky za tebou stojí, kterými se můžeš prezentovat veřejně?",
        "q2_02_intent_and_success": "Proč Buddyho spouštíš právě teď a co ti má přinést? Příjem navíc, volnější ruce, větší dosah tvé práce? A podle čeho za rok poznáš, že se to povedlo?",
        "q2_59_buddy_name": "Jak se tvůj Buddy jmenuje? Napiš jméno přesně tak, jak ho máme psát v textech.",
        "q2_60_addressing_and_lexicon": "Tykáš svým klientům, nebo jim vykáš? A jaká slova, hlášky nebo oblíbené obraty od tebe lidé slýchají pořád? Tvým jazykem pak napíšeme prodejní stránku i celou kampaň.",
        "q2_61_voice_and_impression": "Jak na lidi působíš, když s nimi pracuješ? Jako přísný trenér, starostlivý parťák, chytrý stratég, nebo úplně jinak? Nejlépe nám to ukážeš na příkladu: vzpomeň si na chvíli, kdy jsi klientovi opravdu {{g:pomohl|pomohla}}, a nahraj nám, jak ten rozhovor tehdy zněl.",
        "q2_62_expression_style": "Co je typické pro tvůj způsob vyjadřování? Používáš humor, přirovnání nebo oblíbené příklady? Říkáš věci na rovinu, nebo je balíš do vaty? Popiš svou energii, klidně na příkladu.",
        "q2_63_situational_replies": "Jak povzbudíš někoho, komu se zrovna nedaří? A jak zareaguješ, když se někomu něco fakt povedlo? Odpověz svými slovy, klidně doslova. Přesně tyhle věty pak zaznějí v tvých textech.",
        "q2_64_method_or_framework": "Máš vlastní postup, pravidla nebo pojmy, podle kterých lidem radíš? Popiš svou metodu tak, jak ji vysvětluješ člověku naproti. Ne definici z webu, ale tvoje vlastní slova.",
        "q2_65_lexicon": "Používáš ve své práci vlastní názvy, zkratky nebo neobvyklá slova? Třeba název metody, programu, akronym, cizí termín nebo jméno, které se píše specificky. Vypiš je sem, každé zvlášť a přesně tak, jak se správně píše. Nemusíš nic vysvětlovat.",
        "q2_66_initiated_messages": "Na co se tvůj Buddy svých klientů sám aktivně ptá? Vypiš pár otázek, které jim posílá sám od sebe. Použijeme je v ukázkách, jak Buddy funguje.",
        "q2_31_typical_customer": "Představ si typického zákazníka, pro kterého bude tvůj Buddy nejhodnotnější. A teď si pod ním představ jednoho konkrétního člověka: kolik mu je, co dělá a v jaké situaci teď je? Popiš ho, jako bys ho {{g:představoval kamarádovi|představovala kamarádce|představoval/a kamarádovi}}.",
        "q2_32_customer_words": "Jak by ten člověk popsal svůj problém Buddymu, když by přišel poprvé? Zkus vystihnout jeho slova: co by říkal, jak by se cítil, jak by si Buddymu postěžoval.",
        "q2_33_customer_goals": "Co si tvůj typický zákazník přeje? Jaké má cíle a podle čeho by poznal, že se mu to povedlo?",
        "q2_34_customer_obstacles": "A jaké strachy, obavy a pochybnosti mu stojí v cestě? Řekni to jeho slovy, jak by to řekl on sám.",
        "q2_53_failed_solutions": "Jak se tvůj zákazník snaží nebo se v minulosti snažil své problémy řešit? Co vyzkoušel a nefungovalo mu to optimálně? A proč to nefungovalo?",
        "q2_35_not_for": "A na rovinu: pro koho tvůj Buddy není? Koho bys radši {{g:poslal|poslala}} jinam?",
        "q2_36_backstory": "Vzpomeň si na chvíli, kdy jsi {{g:byl|byla}} přesně tam, kde je dnes tvůj ideální zákazník. Kde jsi {{g:byl|byla}}, co se dělo a co jsi tehdy {{g:cítil|cítila}}? Vyprávěj tu scénu.",
        "q2_37_breakthrough": "Kde nastal bod zlomu? Jaká jedna věc, kterou jsi {{g:pochopil|pochopila}} nebo {{g:objevil|objevila}}, po které už nešlo jet postaru? A co se stalo pak?",
        "q2_38_old_ways": "Co jsi předtím {{g:zkoušel|zkoušela}} a nefungovalo to? Vyjmenuj dvě tři věci a řekni, proč selhaly.",
        "q2_39_belief_vehicle": "Co ti lidé odpoví, když jim řekneš, že jim s tímhle pomůže tvoje AI? Jaká je jejich první pochybnost o té cestě jako takové? A vzpomeneš si na někoho, komu jsi ji {{g:vyvrátil|vyvrátila}}? Co se s ním pak stalo?",
        "q2_40_belief_internal": "Proč si tvůj zákazník myslí, že zrovna jemu to nepůjde, i kdyby to fungovalo ostatním? A znáš příběh, který dokazuje opak?",
        "q2_41_belief_external": "Co ho podle něj brzdí zvenku, na co nemá vliv? Čas, peníze, rodina, zdraví? A co bys mu na to {{g:řekl|řekla}}?",
        "q2_42_big_idea": "Doplň větu: Kdyby můj zákazník uvěřil jediné věci, a to že ..., musel by si mého Buddyho pořídit, protože ...",
        "q2_43_use_cases": "K čemu konkrétně budou lidi tvého Buddyho používat? Přidávej use casy jeden po druhém: v jaké situaci člověk je, co Buddy udělá a co mu to přinese. U každého označ, jestli je to reálná zkušenost, nebo zatím tvůj odhad.",
        "q2_44_value_stack": "Teď hodnota uvnitř. Přidej jednu po druhé nejcennější části svého know-how, které Buddy nese: metoda, databáze, kurz, knížka, zkušenost. U každé řekni, co díky ní člověk dokáže a kolik by ho stálo získat ji jinde.",
        "q2_45_method_names": "Má tvůj Buddy uvnitř metody s vlastními názvy? Jednu nebo víc. Pojmenovaná metoda prodává líp než popis.",
        "q2_21_owner_usage": "Používáš svého Buddyho i pro sebe? Pokud ano, popiš konkrétní situaci, kdy ti opravdu pomohl: jaký problém se s ním podařilo vyřešit, co ti to přineslo a kde ti ušetřil práci. Čím konkrétnější příklad dáš, tím silnější argument získáš pro své klienty.",
        "q2_04_client_stories": "Vyprávěj dva nebo tři skutečné příběhy z klientské praxe: jaká byla výchozí situace, co se změnilo a jaké výsledky za tím zatím jsou. U každého řekni, jestli ho smíme ukázat se jménem, nebo jen anonymně.",
        "q2_06_proof": "Reference, recenze a výsledky, které smíme ukázat v marketingu. Namluv nebo napiš, co máš, a vlož odkazy, kde je najdeme. Kdo už dnes tvého Buddyho reálně používá nebo používal a co ti na něj říkají? Klidně nahraj i screenshoty zpráv, které lidi tvému Buddymu nebo tobě o něm napsali.",
        "q2_19_sales_photos": "Teď více fotek pro prodejní stránku: momentky z akcí, z práce s klienty nebo z natáčení a klidně další portréty. Skutečné fotky dělají stránku důvěryhodnou. Přidej i odkaz na web nebo složku, kde jsou fotky v plném rozlišení.",
        "q2_54_writing_style_samples": "Nahraj své vlastní marketingové materiály, na které jsi {{g:hrdý|hrdá}}: e-maily, prodejní stránky, příspěvky na sítě. Pomůže nám to trefit tvůj způsob psaní a vyjadřování.",
        "q2_55_big_promise": "Co je hlavní myšlenka a hlavní slib, o kterém věříš, že když ho budeme prezentovat, lidi si tvého Buddyho koupí?",
        "q2_46_sales_intent": "Jak chceš Buddyho reálně prodávat? Jako samostatný produkt, v balíčku s online kurzem, jako bonus k osobní spolupráci, nebo třeba ke vzdělávacímu klubu? Popiš svůj záměr.",
        "q2_47_value_economics": "Kolik dnes tvůj zákazník utrácí, aby tenhle problém řešil jinde? Kurzy, konzultace, produkty, pokusy. A co získá nebo ušetří, když to s Buddym bude fungovat? Zkus to vyčíslit, v penězích nebo v čase.",
        "q2_56_price_history": "Co nejdražšího a nejlevnějšího si od tebe tvoji zákazníci už koupili? Jaký typ produktů a služeb jsi dosud {{g:prodával|prodávala}} nejčastěji? A co ti vydělalo nejvíc peněz?",
        "q2_48_price_thinking": "Jak přemýšlíš nad cenou svého Buddyho? Za kolik bys ho {{g:chtěl|chtěla}} prodávat a proč? Řekni celou svoji úvahu, klidně i s pochybnostmi. Finální cenu spočítáme ve strategii.",
        "q2_49_guarantee": "Chceš na Buddyho dávat garanci vrácení peněz? Pokud ano, na jak dlouho? A co jsi {{g:připravený|připravená}} splnit doopravdy? Slibuj jen to, co uneseš.",
        "q2_50_deadline_reason": "Existuje skutečný důvod, proč se má člověk rozhodnout do určitého data? Omezená kapacita, skupina, tvůj čas?",
        "q2_11_first_audience": "Komu chceš Buddyho nabídnout jako prvnímu a jak tyto lidi oslovíš?",
        "q2_13_launch_experience": "Co ti při prodeji obvykle funguje? Webináře, kampaně, placená reklama, spouštění kurzů? Co fungovalo nejlíp a co si z toho pamatuješ?",
        "q2_23_red_lines": "Jsou věci, které jsou pro tebe v marketingu skutečně nepřekročitelné? Webináře, denní přispívání na sítě, placená reklama, e-mail marketing... Vyjmenuj jen to, co je opravdu nepřekročitelné. Pokud jsi něčemu aspoň trochu {{g:otevřený|otevřená}}, nejmenuj to, ať si zbytečně nezmenšujeme hřiště.",
        "q2_14_involvement": "Co chceš pro spuštění osobně udělat? Odvysílat živý webinář, natočit krátká videa, poslat svým lidem sérii e-mailů? Kolik času tomu můžeš dát a kdy chceš spouštět kampaň?",
        "q2_28_acquisition": "Jak k tobě přijdou noví lidé? Vyber, co je pro tebe reálné: placená reklama / oslovím vlastní okruh a komunitu / začnu aktivně budovat sítě / nevím, doporučte mi. A kolik peněz celkem můžeš dát do marketingu svého Buddyho?",
        "q2_57_expected_first_sales": "Jaké máš realistické očekávání od první kampaně? Kolik lidí si podle tebe Buddyho koupí po prvním představení veřejnosti?",
        "q2_58_longterm_promo": "Jak si představuješ, že budeš Buddyho propagovat dlouhodobě? Jak do něj budeš průběžně přivádět nové zákazníky?",
        "q2_24_brand_face": "Má se Buddy prodávat pod tvým jménem a tváří (tvůj AI klon, ty ho doporučuješ), nebo jako samostatná značka? Nebo nevíš a chceš doporučit?",
        "q2_52_design_inputs": "Jak má působit design webu tvého Buddyho? Přidej odkaz na svůj web nebo grafiku, ze které máme vzít barvy a styl, a případně příklady webů, které se ti líbí.",
        "q2_26_constraints": "Je něco, co o sobě nebo o výsledcích své práce nesmíš tvrdit? Třeba zdravotní sliby nebo něco jiného. Vyjmenuj limity, které tvůj marketing musí respektovat."
      }
    },
    "prefillEmpty": "Podklady o tobě právě připravujeme. Tuhle otázku můžeš přeskočit a pokračovat dál, fakta ti ukážeme, jakmile budou ověřená.",
    "submitDossierPending": "Všechny odpovědi máš uložené. Tým právě dokončuje tvoje podklady, odeslání za tebe dokončíme hned potom.",
    "resumed": "Vítej zpět. Pokračuješ od poslední uložené odpovědi.",
    "prefillIntro": "Tohle jsme o tobě našli ve veřejných zdrojích na internetu. U každého jen potvrď, uprav nebo označ, že to není podstatné.",
    "foundOnline": "Našli jsme na internetu",
    "saveHint": "Odpovědi se ukládají, kdykoliv můžeš odejít a pokračovat později.",
    "closedHint": "Dotazník je uzavřený. Odpovědi už nejdou měnit.",
    "closedNext": "Pokračovat na další krok",
    "prefillVoicePrompt": "Nahraj nám hlasovku, ve které se představíš, řekneš, co sedí a co ne, a doplníš víc o sobě, svém podnikání a brandu. Něco už nemusí být aktuální a výjimečně může jít o tvého jmenovce.",
    "resume": {
      "title": "Vítej zpátky",
      "copy": "Tady vidíš, co už máš hotové, a můžeš navázat na poslední uloženou odpověď.",
      "cta": "Pokračovat v dotazníku",
      "answered": "Zodpovězeno",
      "pending": "Čeká na tebe"
    },
    "list": {
      "progress": "Zodpovězeno {done} z {total}",
      "allDone": "Máš hotovo. Pokračuj na další krok.",
      "answered": "Zodpovězeno",
      "edit": "Upravit",
      "viewAnswer": "Prohlédnout odpověď",
      "hideAnswer": "Skrýt odpověď",
      "savedAnswer": "Uložená odpověď",
      "savedFile": "Uložený soubor",
      "remaining": "Pro přechod k dalšímu kroku ještě dokonči tyto otázky:",
      "remainingFold": "Do dalšího kroku zbývá {count} otázek",
      "linkedPrefill": "Předvyplnili jsme podle tvé odpovědi z prvního dotazníku. Klidně změň."
    },
    "username": {
      "free": "Username vypadá volně, finálně ho ověří tým.",
      "taken": "Username je obsazený, zkus jiný.",
      "invalid": "Použij 5 až 32 písmen, čísel nebo podtržítek.",
      "checking": "Ověřuji dostupnost..."
    },
    "help": {
      "lexicon": "Tvoje nahrávky přepisujeme do textu. Když tahle slova známe předem, přepíšou se správně a tvůj Buddy je bude říkat i psát přesně jako ty. Stejný seznam dostane tvůj Buddy i pro přepisy tvého know-how, hlasovek a videí.",
      "existingBotUsername": "Tvůj Buddy už na Telegramu existuje jako {username}. Uživatelské jméno zůstává, jméno Buddyho můžeš upravit.",
      "voiceAndMeditation": "Pro Buddyho si můžeš vybrat standardní AI hlas, nebo klon vlastního hlasu vytvořený z tvých nahrávek. Klon zní kvalitněji a osobněji, ale jeho provoz stojí zhruba o 20 procent víc a umožní Buddymu vytvářet skvělé meditace namluvené tvým hlasem, které náklady ještě mírně zvýší. Meditace můžeš kdykoliv zapnout nebo vypnout a také omezit jejich počet pro jednoho uživatele.",
      "googleAccount": "Na tento účet ti nasdílíme složku na Google Disku. Do ní pak nahraješ kurzy, nahrávky a dokumenty, ze kterých Buddyho vytrénujeme. Účet jde kdykoliv později změnit."
    },
    "groups": {
      "business": {
        "title": "Tvůj byznys",
        "copy": "Teď nastavujeme, co má Buddy umět: co děláš, komu pomáháš a čemu se má vyhnout."
      },
      "persona": {
        "title": "Osobnost tvého Buddyho",
        "copy": "Teď nastavujeme, jak se bude Buddy chovat: jak mluví, jak reaguje a na co se sám ptá. Čím víc mu dáš ze sebe, tím víc bude znít jako ty."
      },
      "setup": {
        "title": "Praktické nastavení",
        "copy": "Zbývá pár praktických věcí: jméno, hlas, fotka a přístup ke know-how."
      },
      "story": {
        "title": "Tvůj příběh a záměr",
        "copy": "Marketing prodává tebe, ne technologii. Potřebujeme slyšet, kdo jsi a proč do toho jdeš."
      },
      "clients": {
        "title": "Tvoji klienti doopravdy",
        "copy": "Slova skutečných klientů jsou nejsilnější texty, které kampaň může mít."
      },
      "proof": {
        "title": "Důkazy a čísla",
        "copy": "Ukážeme jen to, co nám tady potvrdíš. Nic si nedomýšlíme."
      },
      "offer": {
        "title": "Nabídka a cena",
        "copy": "Z tvých dnešních cen odvodíme, kolik má Buddy stát a kam v nabídce patří."
      },
      "launch": {
        "title": "Spuštění",
        "copy": "Kde a jak Buddyho poprvé nabídneme, aby kampaň sedla na to, co už máš."
      },
      "miniprofile": {
        "title": "Osm rychlých kliknutí",
        "copy": "Nejdřív osm rychlých kliknutí, ať se dál ptáme jen na to, co dává u tebe smysl."
      },
      "about": {
        "title": "Ty v kostce",
        "copy": "Nejdřív si ukotvíme tvoje ověřitelné výsledky a záměr Buddyho."
      },
      "voice": {
        "title": "Tvůj hlas",
        "copy": "Tvůj Buddy už běží, tahle část je o tobě. Ať v celém marketingu mluvíš ty, ne my."
      },
      "customer": {
        "title": "Zákazník tvého Buddyho",
        "copy": "Potřebujeme ho slyšet jako konkrétního člověka, jeho vlastními slovy."
      },
      "story_v2": {
        "title": "Tvůj příběh",
        "copy": "Scéna, bod zlomu a věci, které předtím nefungovaly."
      },
      "beliefs": {
        "title": "Přesvědčení a hlavní myšlenka",
        "copy": "Pojmenujeme pochybnosti, které musí marketing pravdivě překonat."
      },
      "value": {
        "title": "Tvůj Buddy a jeho hodnota",
        "copy": "Konkrétní použití a know-how, které člověk dostane dovnitř."
      },
      "pricing": {
        "title": "Prodejní záměr, cena a garance",
        "copy": "Ukotvíme hodnotu, cenovou úvahu a sliby, které uneseš."
      },
      "launch_v2": {
        "title": "Prodej a tvoje zapojení",
        "copy": "Vybereme cestu k prvním lidem, která odpovídá tvým možnostem."
      },
      "brand": {
        "title": "Design a značka",
        "copy": "Nakonec sladíme jméno, vizuální směr a hranice tvrzení."
      }
    },
    "profilePhoto": {
      "linksLabel": "Odkaz na fotku v plném rozlišení",
      "addLink": "Přidat odkaz",
      "remove": "Odebrat",
      "file": "Soubor",
      "upload": "Nahraj profilovou fotku",
      "uploadHint": "Portrét s dobře viditelným obličejem. PNG, JPG nebo WebP.",
      "uploadError": "Soubor se teď nepodařilo nahrát. Zkus to prosím znovu."
    },
    "photos": {
      "linksLabel": "Odkazy na fotky (web, Google Disk, složka v plném rozlišení)",
      "addLink": "Přidat odkaz",
      "remove": "Odebrat",
      "file": "Soubor",
      "upload": "Nahraj fotku",
      "uploadHint": "Momentky z akcí, z práce s klienty, další portréty. PNG, JPG nebo WebP.",
      "uploadError": "Soubor se teď nepodařilo nahrát. Zkus to prosím znovu.",
      "noPhotosButton": "Zatím žádné fotky nemám",
      "noPhotosNote": "Prodejní stránku postavíme bez fotek. Jakmile nějaké budeš mít, přidej je sem a my je doplníme."
    },
    "proof": {
      "linksLabel": "Odkazy na reference (recenze, posty, stránky s výsledky)",
      "addLink": "Přidat odkaz",
      "remove": "Odebrat",
      "file": "Soubor",
      "upload": "Nahraj screenshot reference",
      "uploadHint": "Zprávy od klientů, recenze, výsledky. PNG, JPG nebo WebP.",
      "uploadError": "Soubor se teď nepodařilo nahrát. Zkus to prosím znovu."
    },
    "upload": {
      "converted_photo": "Fotku v tomhle formátu (HEIC z iPhonu, TIFF nebo RAW) zatím neumíme zpracovat. Ulož ji jako JPEG nebo PNG a nahraj znovu. Na Macu to udělá Náhled přes Soubor > Exportovat, na iPhonu pomůže Nastavení > Fotoaparát > Formáty > Nejkompatibilnější.",
      "unsupported_type": "Tenhle formát souboru nepřijímáme. Nahraj fotku jako PNG, JPG nebo WebP.",
      "too_large": "Soubor je moc velký. Vejde se do 60 MB, tak fotku zmenši nebo pošli odkaz na plné rozlišení.",
      "quota": "Došlo ti místo pro nahrané soubory. Denní limit se uvolní sám do 24 hodin, jinak napiš svému parťákovi.",
      "storage": "Úložiště teď nereaguje. Zkus to za chvíli, nebo místo souboru vlož odkaz na fotku.",
      "offline": "Vypadá to, že jsi offline. Připoj se a nahraj fotku znovu.",
      "not_an_image": "Tenhle soubor uvnitř není fotka, i když se tak jmenuje. Otevři ho, ulož jako PNG nebo JPEG a nahraj znovu.",
      "generic": "Soubor se teď nepodařilo nahrát. Zkus to prosím znovu, nebo vlož odkaz na fotku.",
      "progress": "Nahrávám soubor {done} z {total}..."
    },
    "testOpenNote": "Testovací režim: dotazník je otevřený a odpovědi se ukládají. Odeslat krok půjde, až na něj přijde řada doopravdy.",
    "links": {
      "add": "Přidat odkaz",
      "remove": "Odebrat"
    },
    "design": {
      "deferButton": "Nechám to na vás",
      "deferNote": "Design zvolí náš tým podle tvé značky a oboru. Cokoli níže doplníš, vezmeme jako inspiraci.",
      "file": "Soubor",
      "upload": "Nahraj obrázek, grafiku nebo PDF",
      "uploadHint": "PNG, JPG, WebP nebo PDF",
      "remove": "Odebrat"
    },
    "writingSamples": {
      "linksLabel": "Odkazy na tvoje texty: prodejní stránky, články, příspěvky.",
      "addLink": "Přidat odkaz",
      "remove": "Odebrat",
      "file": "Soubor",
      "upload": "Nahraj soubor se svým textem",
      "uploadHint": "PDF, PNG, JPG nebo WebP"
    },
    "staffReturned": "Parťák ti dotazník vrátil k dopracování: {reason}"
  },
  "celebration": {
    "nextLead": "Pokračuj krokem",
    "dismiss": "Skrýt hlášku",
    "steps": {
      "q1": {
        "title": "Dotazník k přípravě Buddyho je odeslaný.",
        "waiting": "Odpovědi máme. Ještě dopisujeme přepisy tvých hlasovek, jakmile budou hotové, posuneme tě dál.",
        "queued": "Odpovědi máme a jdou k nám do přípravy. Jakmile se otevře další krok, dáme ti vědět."
      },
      "q2": {
        "title": "Dotazník k prodeji je odeslaný.",
        "waiting": "Odpovědi máme. Ještě dopisujeme přepisy tvých hlasovek, jakmile budou hotové, posuneme tě dál.",
        "queued": "Odpovědi máme a jdou k nám do přípravy. Jakmile se otevře další krok, dáme ti vědět."
      }
    }
  },
  "attachments": {
    "storageNotReady": "Nahrávání souborů zatím není zapnuté."
  },
  "voice": {
    "modeLabel": "Způsob odpovědi",
    "speak": "Mluvit",
    "write": "Psát",
    "textPlaceholder": "Napiš svou odpověď...",
    "warning35": "Zbývá přibližně 5 minut nahrávání.",
    "warning39": "Zbývá přibližně 1 minuta nahrávání.",
    "unsupported": "Tento prohlížeč nahrávání nepodporuje. Odpověď můžeš napsat.",
    "permissionError": "Mikrofon se nepodařilo otevřít. Zkontroluj jeho povolení v prohlížeči.",
    "uploadError": "Nahrávku se nepodařilo uložit.",
    "start": "Začít nahrávat",
    "requesting": "Připojuji mikrofon...",
    "liveTranscript": "Mluv dál, přepis se průběžně objevuje v poli.",
    "stopAndSend": "Dokončit a odeslat",
    "resume": "Pokračovat",
    "pause": "Pozastavit",
    "finish": "Dokončit",
    "cancel": "Zrušit",
    "status": {
      "recording": "Nahrávám",
      "paused": "Nahrávání je pozastavené"
    },
    "transcribing": "Převádíme nahrávku na text...",
    "transcribeError": "Zkus to znovu, nebo odpověz textem.",
    "silenceStopped": "Ticho delší než 30 vteřin, nahrávání jsem vypnul.",
    "textFieldLabel": "Odpověď",
    "failure": {
      "unsupported": "Tenhle prohlížeč nahrávání nepodporuje. Připomínku můžeš napsat do pole níže.",
      "permission": "Prohlížeč nás k mikrofonu nepustil. Povol mikrofon (ikona vedle adresy stránky) a zkus to znovu.",
      "busy": "Mikrofon právě drží jiná aplikace nebo jiná záložka. Zavři ji a zkus to znovu.",
      "noDevice": "Žádný mikrofon jsme nenašli. Připoj ho a zkus to znovu.",
      "micFailed": "Nahrávání se nepodařilo spustit. Zkus to prosím znovu.",
      "offline": "Vypadlo připojení k internetu. Nahrávku držíme, po připojení ji pošli znovu.",
      "transcribe": "Přepis nahrávky se nepodařilo dokončit. Nahrávku držíme, zkus ji poslat znovu.",
      "sessionRenewed": "Tvoje přihlášení se mezitím obnovilo, proto to napoprvé neprošlo. Nahrávku držíme, pošli ji znovu, teď už projde.",
      "rateLimited": "Nahrávek přišlo za chvíli moc. Počkej pár vteřin a pošli ji znovu, držíme ji tady.",
      "tooLong": "Tahle nahrávka je moc dlouhá na jedno odeslání. Rozděl ji prosím na kratší části.",
      "send": "Připomínku se nepodařilo odeslat. Nahrávku držíme, zkus to prosím znovu.",
      "empty": "V nahrávce jsme nezachytili žádnou řeč. Zkus to prosím znovu.",
      "retrySend": "Odeslat znovu",
      "retryRecord": "Zkusit znovu",
      "heldNote": "Nahrávku máme uloženou tady v prohlížeči, dokud ji neodešleš.",
      "resumeTitle": "Máš tu nedokončenou připomínku",
      "resumeBody": "Nahrávka z minule se nestihla odeslat. Můžeš ji poslat teď, nebo zahodit.",
      "resumeSend": "Odeslat nahrávku",
      "resumeDiscard": "Zahodit",
      "silenceStopped": "Ticho delší než půl minuty, nahrávání jsem zastavil a nic se nepřepisovalo.",
      "limitStopped": "Nahrávání dosáhlo maximální délky, zastavil jsem ho a ukládám.",
      "textDraftRestored": "Vrátil jsem ti rozepsaný text z minule."
    }
  },
  "staffConsole": {
    "adminReload": "Načíst znovu",
    "clientPickerDuplicate": "{index}. záznam",
    "duplicateRecord": {
      "one": "{index}. z {count} záznamu",
      "few": "{index}. ze {count} záznamů",
      "other": "{index}. z {count} záznamů"
    },
    "duplicateRecordCreated": "vznikl {date}",
    "eyebrow": "Operátorský přehled",
    "adminTitle": "Řízení celého Launchpadu",
    "partnerTitle": "Tvoji klienti na jednom místě",
    "description": "Fáze, čekající úkoly a další krok týmu jsou vidět bez přepínání mezi nástroji.",
    "callLinks": {
      "title": "Stálé odkazy z hovorů",
      "hint": "Stejný odkaz použij při každém úvodním nebo marketingovém hovoru tohoto klienta.",
      "onboarding": "Úvodní hovor",
      "marketing": "Marketingový hovor"
    },
    "stableCallKind": {
      "onboarding": "úvodním hovoru",
      "marketing": "marketingovém hovoru"
    },
    "role": {
      "admin": "Administrátor",
      "partner": "Parťák"
    },
    "summary": "Souhrn klientů",
    "metricClients": "klientů v přehledu",
    "metricFeedback": "podnětů",
    "feedbackLabel": {
      "one": "podnět",
      "few": "podněty",
      "other": "podnětů"
    },
    "metricCalls": "naplánovaných hovorů",
    "matrixKicker": "Denní přehled",
    "matrixTitle": "Klienti a fáze",
    "matrixTitleCount": "Klienti a fáze ({count})",
    "hideTestTenants": "Skrýt testovací klienty",
    "hiddenDeepLink": "Klient {name} je skrytý filtrem testovacích klientů.",
    "hiddenDeepLinkShow": "Vypnout filtr a otevřít ho",
    "search": "Hledat klienta",
    "searchPlaceholder": "Hledat klienta",
    "mobileQueue": "Nejdřív čekají na tým",
    "mobileQueueSorted": "Seřazeno podle toho, kdo potřebuje pozornost",
    "emptyMatrixSearch": "Hledání nemá žádný výsledek",
    "emptyMatrixFilter": "Filtru neodpovídá žádný klient",
    "emptyMatrixAll": "V přehledu zatím není žádný klient",
    "emptyMatrixSearchHint": "Zkus jiné jméno nebo e-mail. Hledá se i v adresách.",
    "emptyMatrixFilterHint": "Změň výběr a vrať se k celému přehledu.",
    "emptyMatrixAllHint": "Jakmile ti přibude první klient, uvidíš ho tady.",
    "clearMatrixSearch": "Vymazat hledání",
    "clearMatrixFilter": "Zrušit výběr",
    "partnerFilter": "Parťák",
    "partnerFilterAll": "Všichni parťáci",
    "partnerFilterNone": "Bez parťáka",
    "partnerFilterUnnamed": "Parťák bez jména",
    "partnerFilterGone": "Vybraný parťák už nemá klienty",
    "accountMenu": "Otevřít nabídku účtu",
    "client": "Klient",
    "currentPhase": "Aktuální fáze",
    "age": "Dny ve fázi",
    "nextCall": "Další hovor",
    "pending": "Otevřené podněty",
    "stepProgress": "Postup",
    "legend": {
      "title": "Legenda postupu",
      "done": "zelená: hotovo",
      "done_ahead": "zelený kroužek: hotové napřed",
      "next": "modrá: na řadě",
      "working": "azurová: pracuje se",
      "blocked": "červená: zablokované, zasáhni",
      "locked": "prázdná: zamčeno",
      "current": "bílý kroužek: tady klient právě je"
    },
    "stepChapter": {
      "buddy": "Buddy",
      "sales": "Prodej"
    },
    "stepPosition": {
      "global": "Krok {position} z {total}",
      "buddy": "Buddy {position}/{total}",
      "sales": "Prodej {position}/{total}",
      "doneAhead": {
        "one": "{count} hotový napřed",
        "other": "{count} hotové napřed"
      }
    },
    "stepOverview": {
      "title": "Cesta klienta",
      "hint": "Stejné kroky a stavy, které má klient ve svém Launchpadu.",
      "clientNext": "Klient je teď u kroku {step}.",
      "state": {
        "locked": "Krok zatím nemůže otevřít.",
        "next": "Krok může otevřít a pokračovat.",
        "working": "Vidí, že na kroku pracuje tým nebo systém.",
        "done": "Krok vidí jako hotový."
      }
    },
    "none": "Zatím nic",
    "detailKicker": "Pracovní detail",
    "selectClient": "Vyber klienta",
    "selectHint": "Klikni na jméno klienta v matici. Otevře se jeho pracovní detail.",
    "clientSection": {
      "overview": {
        "eyebrow": "Stav a materiály",
        "title": "Přehled klienta",
        "lead": "Kde klient stojí, co má výroba zadané a co už vzniklo."
      },
      "activity": {
        "eyebrow": "Záznam",
        "title": "Aktivita",
        "lead": "Historie kroků a odeslaných zpráv. Nic se tu nemění.",
      "openNotes": {
        "one": "1 nová připomínka, otevřít",
        "few": "{count} nové připomínky, otevřít",
        "other": "{count} nových připomínek, otevřít"
      },
        "auditTitle": "Historie klienta",
        "notificationsTitle": "Notifikace klienta"
      },
      "settings": {
        "eyebrow": "Zásahy",
        "title": "Nastavení",
        "lead": "Údaje o klientovi, jeho zdroje a vratné zásahy.",
        "resourcesTitle": "Zdroje klienta"
      }
    },
    "workspaceUnknown": {
      "title": "Krok bez pracoviště",
      "body": "Tenhle krok konzole nezná. Vyber jiný krok v cestě vlevo; pokud se to opakuje, jde o chybu dat na naší straně."
    },
    "saved": "Změna je uložená.",
    "error": "Akci se nepodařilo dokončit. Data se nezměnila.",
    "emptyAnswers": "Klient zatím nemá uložené odpovědi.",
    "emptySubmissions": "Zadání pro výrobu zatím nevzniklo.",
    "emptyProfile": "Profil zatím nemá změny.",
    "emptyFeedback": "Ve frontě není žádný podnět.",
    "emptyMatrix": "Žádný klient neodpovídá hledání.",
    "emptyResources": "Klient zatím nemá žádný zdroj.",
    "emptyDeliverables": "Klient zatím nemá žádný výstup.",
    "emptyAudit": "Zatím tu není žádná aktivita.",
    "clientActivity": {
      "order_links_integrated": "Odkazy na objednávku jsou v prodejní stránce.",
      "app_release_status_changed": "Změnili jsme stav vydání aplikace.",
      "bot_transfer_false_done_repaired": "Opravili jsme převod bota, který se dřív zapsal jako hotový.",
      "bot_transfer_settings_updated": "Nastavení automatického převodu bota se změnilo.",
      "bot_transferred_automatically": "Bot změnil majitele automaticky.",
      "global_unlock_link_changed": "Společný odkaz na hovor dostal nové jméno.",
      "instance_folder_recorded": "Známe složku Buddyho na Disku.",
      "knowhow_handover_verified": "Ověřili jsme, že klient má do složky přístup.",
      "license_key_imported": "Licenční klíč je připravený.",
      "material_regeneration_requested": "Parťák nechal materiál vyrobit znovu od nuly.",
      "notification_label_fallback": "Zprávě o materiálu chybělo jméno materiálu.",
      "order_links_confirmed": "Klient potvrdil odkazy na objednávku.",
      "order_links_integration_requested": "Klient poslal odkazy na objednávku ke zpracování.",
      "owner_role_done": "Instance přešla na klienta.",
      "owner_role_failed": "Předání instance klientovi se nepovedlo.",
      "owner_role_id_refused": "Telegramové číslo klienta jsme nepřijali.",
      "owner_role_job_queued": "Předání instance klientovi čeká ve frontě.",
      "owner_role_settings_updated": "Nastavení automatického předání instance se změnilo.",
      "partner_brief_saved": "Parťák uložil poznámku k výrobě.",
      "sales_edit_merged": "Úprava prodejní stránky je zapracovaná.",
      "staff_override_approved": "Parťák potvrdil krok za klienta.",
      "sales_only_import": "Krok proběhl mimo Launchpad a my ho jen zapsali.",
      "training_resume_requested": "Parťák požádal o pokračování tréninku.",
      "ai_avatar_received": "Dorazil AI avatar klienta.",
      "app_upsell_interest": "Klient projevil zájem o mobilní aplikaci.",
      "apple_account_started": "Klient začal zakládat Apple účet.",
      "auth_login": "Klient se přihlásil do Launchpadu.",
      "beta_feedback_started": "Beta běží: klient poslal první podnět.",
      "bot_acceptance_reported": "Klient potvrdil převzetí bota v Telegramu.",
      "bot_transfer_ready": "Převod bota je připravený, čeká na klienta.",
      "buddy_ready": "Buddy je natrénovaný. Klientovi se otevřela beta.",
      "call_created": "Přidaný nový termín hovoru.",
      "call_enrolled": "Klient se přihlásil na hovor.",
      "client_initialized": "Klientský účet je založený.",
      "client_selling": "Předání dokončené. Klient prodává.",
      "client_updated": "Údaje klienta se změnily.",
      "client_confirmation_reverted": "Tým vrátil potvrzení klienta: {what}.",
      "deliverable_client_approved": "Klient schválil materiál {what}.",
      "deliverable_created": "Vznikla nová verze materiálu {what}.",
      "deliverable_feedback_added": "Nový podnět k materiálu {what}.",
      "deliverable_updated": "Změna u materiálu {what}.",
      "dfy_build_launched": "Spustili jsme výrobu materiálu {what}.",
      "prompt_rebuild_requested": "Tým spustil přegenerování system promptu Buddyho.",
      "prompt_patch_requested": "Tým poslal podněty k zapracování do system promptu Buddyho.",
      "prompt_patch_proposed": "Alex připravil návrh úpravy system promptu.",
      "prompt_patch_approved": "Tým schválil úpravu system promptu.",
      "prompt_patch_rejected": "Tým zamítl návrh úpravy system promptu.",
      "prompt_patch_applied": "Úprava system promptu je zapsaná a podněty jsou zapracované.",
      "prompt_patch_failed": "Zapsání úpravy system promptu se nepovedlo.",
      "feedback_processed": "Podnět je označený jako zpracovaný.",
      "impersonation_acting": "Tým přepnul náhled do režimu jednání za klienta.",
      "impersonation_ended": "Náhled očima klienta skončil.",
      "impersonation_looking": "Tým vrátil náhled do režimu jen koukám.",
      "impersonation_started": "Tým si zobrazil aplikaci očima klienta.",
      "impersonated_write": "Tuhle změnu udělal tým za klienta.",
      "instance_team_done": "Tým instance je připravený.",
      "instance_team_requested": "Odešla žádost o založení týmu instance.",
      "invite_accepted": "Tester přijal pozvánku.",
      "invite_created": "Vznikla pozvánka pro testera.",
      "knowhow_folder_shared": "Složka s know-how je nasdílená.",
      "knowhow_resources_ready": "Podklady pro know-how jsou pro klienta připravené.",
      "knowhow_uploaded": "Klient uzavřel nahrávání know-how a odeslal podklady k tréninku.",
      "magic_link_issued": "Klientovi odešel přihlašovací odkaz.",
      "manual_state_forward": "Tým ručně posunul fázi klienta.",
      "map_apply_completed": "Alex zapracoval změny z myšlenkové mapy.",
      "map_apply_rejected": "Změnu z myšlenkové mapy se nepodařilo zapracovat.",
      "marketing_call_completed": "Krok Marketingové video je dokončený.",
      "milestone_set": "Splněný milník: {what}.",
      "onboarding_completed": "Krok Úvodní video je dokončený.",
      "price_approved": "Klient odsouhlasil cenu.",
      "profile_research_completed": "Průzkum profilu klienta je hotový.",
      "profile_research_failed": "Průzkum profilu klienta selhal.",
      "profile_research_requested": "Průzkum profilu klienta je zadaný.",
      "q2_ready": "Prodejní dotazník je uzavřený. Práce na prodeji začíná.",
      "questionnaire_submitted": "Klient odeslal dotazník: {what}.",
      "r2_orphan_sweep": "Proběhl systémový úklid souborů.",
      "resource_updated": "Změna podkladu: {what}.",
      "sales_edit_done": "Alex dokončil úpravu materiálu.",
      "sales_edit_failed": "Úprava materiálu přes Alexe selhala.",
      "sales_edit_requested": "Alex dostal zadání na úpravu materiálu.",
      "sales_package_ready": "Prodejní balíček je kompletní.",
      "stable_call_link_redeemed": "Klient použil stálý odkaz po {what}.",
      "staff_client_viewed": "Parťák si otevřel náhled klientova Launchpadu.",
      "stripe_import_settings_updated": "Nastavení Stripe importu se změnilo.",
      "stripe_invite_confirmed": "Klient potvrdil pozvánku do Stripe.",
      "training_result_received": "Dorazil výsledek tréninku dvojčete.",
      "unlock_code_created": "Vznikl kód pro připojení na hovor.",
      "answers_imported": "Do dotazníků jsme naimportovali odpovědi.",
      "app_wizard_prefilled": "Průvodce aplikací je předvyplněný.",
      "app_wizard_submitted": "Klient odeslal průvodce aplikací.",
      "bot_transfer_done": "Bot změnil majitele, teď patří klientovi.",
      "bot_transfer_failed": "Převod bota se nepovedl.",
      "bot_transfer_job_queued": "Převod bota čeká ve frontě.",
      "bot_transfer_recipient_refused": "Telegram převod odmítl kvůli účtu příjemce.",
      "bot_transfer_returned_to_client": "Převod bota jsme vrátili klientovi k opravě.",
      "call_cancelled": "Termín hovoru je zrušený.",
      "call_deleted": "Termín hovoru je smazaný.",
      "call_enrollment_updated": "Přihlášení na hovor se změnilo.",
      "call_series_cancelled": "Série hovorů je zrušená.",
      "call_series_created": "Vznikla nová série hovorů.",
      "call_series_extended": "Série hovorů má další termíny.",
      "call_updated": "Termín hovoru se změnil.",
      "client_owner_email_changed": "Adresa klienta se změnila.",
      "client_step_confirmed": "Klient potvrdil krok.",
      "deliverable_deleted": "Rozpracovaný materiál je smazaný.",
      "deliverable_published": "Zveřejnili jsme klientovi materiál {what}.",
      "dev_mail_allowlist_sent": "Vývojový e-mail odešel na povolenou adresu.",
      "feedback_dismissed": "Podnět je uzavřený jako nerelevantní.",
      "feedback_note_deleted": "Poznámka týmu je smazaná.",
      "handover_owner_role_set": "Klient je majitelem instance.",
      "handover_telegram_submitted": "Klient poslal svůj telegramový účet.",
      "invite_revoked": "Pozvánka je zrušená.",
      "knowhow_opened_from_sharing_email": "Klient otevřel složku z e-mailu o sdílení.",
      "manual_state_regression": "Tým vrátil krok o kus zpátky.",
      "milestone_deleted": "Milník {what} je zrušený.",
      "map_apply": "Změny v profilu čekají na zapracování.",
      "notification_delivery_tested": "Tým vyzkoušel doručování zpráv.",
      "notification_requeued": "Zpráva jde znovu do fronty.",
      "partner_material_added": "Parťák přidal klientovi podklad.",
      "partner_material_removed": "Parťák odebral podklad.",
      "partner_message_sent": "Parťák poslal klientovi zprávu.",
      "profile_map_deleted": "Mapa profilu je smazaná.",
      "q1_ready": "Dotazník k Buddymu je připravený.",
      "q2_submitted_waiting": "Prodejní dotazník je odeslaný a čeká na tým.",
      "questionnaire_submission_reverted": "Tým vrátil dotazník klientovi.",
      "resource_deleted": "Záznam {what} je smazaný.",
      "sales_edit_claimed": "Úpravu prodejní stránky si převzala automatika.",
      "sales_edit_reclaimed": "Úpravu prodejní stránky jsme uvolnili k dalšímu pokusu.",
      "salespage_netlify_domain_configured": "Prodejní stránka má nastavenou doménu.",
      "salespage_netlify_published": "Prodejní stránka je publikovaná na Netlify.",
      "sessions_revoked": "Aktivní přihlášení skončila.",
      "stable_call_links_ensured": "Stálé odkazy na hovory jsou připravené.",
      "staff_created": "V týmu přibyl člověk.",
      "staff_deactivated": "Člen týmu je deaktivovaný.",
      "staff_profile_updated": "Profil člena týmu se změnil.",
      "staff_reactivated": "Člen týmu je zase aktivní.",
      "staff_role_changed": "Role člena týmu se změnila.",
      "stripe_connect_url_set": "Klient dostal odkaz na připojení Stripe.",
      "stripe_connected": "Stripe je připojený.",
      "submission_exported": "Dotazník je vyexportovaný do výroby.",
      "training_run_failed": "Trénink dvojčete spadl.",
      "training_run_started": "Trénink dvojčete začal.",
      "transcript_requeued": "Přepis jde znovu ke zpracování.",
      "unlock_code_renewed": "Kód na připojení je obnovený.",
      "unlock_code_revoked": "Kód na připojení je zneplatněný.",
      "payments_setup_checklist_updated": "Tým upravil postup napojení plateb.",
      "payments_setup_completed": "Tým dokončil napojení plateb.",
      "payments_setup_reopened": "Tým vrátil napojení plateb do práce.",
      "payments_setup_flag_changed": "Tým změnil, jestli má klient napojení plateb."
    },
    "clientNotifications": {
      "to": "Komu",
      "recipientUnknown": "Příjemce se nepodařilo dohledat",
      "older": "Starší notifikace ({count})",
      "channel": {
        "email": "E-mail",
        "push": "Push",
        "other": "Jiný kanál"
      }
    },
    "clientActivityOlder": "Starší aktivita ({count})",
    "clientActivityUnknown": "Zaznamenali jsme změnu u klienta.",
    "emptyCalls": "Klient zatím není přihlášený na hovor.",
    "emptyNotifications": "Klient zatím nemá žádnou notifikaci.",
    "clientSettings": "Klient a přiřazení",
    "assignment": {
      "partnerNone": "Zatím nikdo",
      "select": "Komu klienta přiřadit",
      "pick": "Vyber parťáka",
      "assign": "Přiřadit parťáka",
      "change": "Změnit parťáka",
      "saving": "Ukládám",
      "hint": "Parťák dostane e-mail a klient se mu objeví v konzoli. Zprávy o klientovi od té chvíle chodí jen jemu.",
      "failed": "Přiřazení se nepovedlo. Načti stránku znovu a zkus to ještě jednou."
    },
    "confirmationUndo": {
      "title": "Potvrzení klienta",
      "hint": "Každé potvrzení můžeš vrátit do stavu, ve kterém ho klient znovu upraví nebo odsouhlasí.",
      "confirmed": "Potvrzeno klientem",
      "button": "Vrátit potvrzení",
      "confirm": "Vrátit potvrzení „{item}“ klientovi {client}? Klient bude moct obsah znovu upravit a potvrdit.",
      "confirmButton": "Ano, vrátit potvrzení",
      "kind": {
        "profile": "Profil",
        "apple": "Apple účet",
        "q1_submit": "Odeslání zadání pro Buddyho",
        "q2_submit": "Odeslání prodejního zadání",
        "strategy": "Prodejní strategie",
        "salespage": "Prodejní stránka",
        "emails": "E-maily",
        "webinar": "Webinář",
        "knowhow_submit": "Odeslání know-how k tréninku",
        "video_onboarding": "Úvodní video (uzavření kroku)",
        "video_marketing": "Marketingové video (uzavření kroku)"
      }
    },
    "editClient": "Upravit klienta a přiřazení",
    "email": "E-mail",
    "partner": "Parťák",
    "owner": "Vlastník",
    "ownerId": "ID vlastníka",
    "includesApp": "Součástí je aplikace",
    "source": {
      "direct": "Přímý nákup",
      "upsell": "Doplňkový prodej",
      "webinar": "Webinář"
    },
    "start": {
      "new": "Nová instance",
      "existing": "Existující instance"
    },
    "axes": "Varianty",
    "regression": "Vrátit proces zpět",
    "regressionWarning": "Tato akce mění historii postupu. Zkontroluj náhled a potvrď přesné jméno klienta.",
    "reasonLong": "Důvod, alespoň 10 znaků",
    "typeClientName": "Napiš přesné jméno klienta",
    "confirmRegression": "Potvrdit návrat",
    "state": {
      "locked": "Zamčeno",
      "next": "Další",
      "working": "Rozpracováno",
      "done": "Hotovo"
    },
    "stepStatus": {
      "locked": "Zamčeno",
      "on_deck": "Na řadě",
      "review": "Ke kontrole",
      "waiting_apple": "Čeká na Apple",
      "working": "Pracujeme",
      "done": "Hotovo",
      "open": "Otevřeno"
    },
    "reason": "Důvod změny",
    "milestones": "Milníky",
    "milestoneUnknown": "Nepojmenovaný milník",
    "milestoneEditor": "Editor milníku",
    "milestoneDeleteReason": "Ruční odebrání milníku po potvrzení administrátorem.",
    "confirmDelete": "Opravdu chceš tuto položku smazat?",
    "confirmMilestoneDelete": "Odebráním milníku změníš auditovaný důkaz. Klient:",
    "confirmResourceDelete": "Smazáním zdroje ho odstraníš z klientského procesu. Klient:",
    "confirmDeliverableDelete": "Smazáním odstraníš tento nepublikovaný výstup. Klient:",
    "confirmDeliverablePublish": "Publikací nahradíš dřívější publikovanou verzi stejného typu. Klient:",
    "confirmCallDelete": "Smazáním odstraníš tento termín globálně. Klient v aktuálním detailu:",
    "confirmCodeRevoke": "Zneplatněný kód už nepůjde použít. Klient v aktuálním detailu:",
    "process": "Označit jako zpracované",
    "resourceEditor": "Editor zdroje",
    "visible": "Viditelné klientovi",
    "save": "Uložit",
    "delete": "Smazat",
    "deliverableEditor": "Nový výstup",
    "openDeliverable": "Otevřít výstup",
    "deliverableUrl": "URL výstupu",
    "deliverableStatus": "Stav výstupu",
    "deliverableState": {
      "draft": "Koncept",
      "review": "Ke kontrole",
      "approved": "Schváleno"
    },
    "saveDeliverable": "Uložit výstup",
    "publish": "Publikovat klientovi",
    "title": "Název",
    "create": "Vytvořit",
    "noCode": "Kód zatím není vydaný",
    "codeIssued": "Kód vydaný",
    "codeInactive": "Kód už neplatí",
    "issueCode": "Vydat kód",
    "revokeCode": "Zneplatnit kód",
    "confirmRevoke": "Opravdu chceš tento kód zneplatnit?",
    "callKind": "Druh hovoru",
    "callKindValue": {
      "onboarding": "Úvodní hovor",
      "marketing": "Marketingový hovor"
    },
    "callLocale": "Jazyk hovoru",
    "callStartsAt": "Začátek hovoru",
    "zoomUrl": "URL hovoru",
    "recordingUrl": "URL záznamu",
    "saveCall": "Uložit hovor",
    "deleteCall": "Smazat hovor",
    "clientNotEnrolled": "Klient na tento termín není zapsaný.",
    "enrollmentStatus": "Stav zápisu",
    "enrollment": {
      "enrolled": "Zapsaný",
      "attended": "Zúčastnil se",
      "watchedRecording": "Zhlédl záznam"
    },
    "enrollClient": "Zapsat klienta",
    "saveEnrollment": "Uložit stav zápisu",
    "oneTimeCode": "Jednorázově zobrazený kód:",
    "openZoom": "Otevřít Zoom",
    "retryNotifications": "Odeslat všechny čekající notifikace",
    "retryNotification": "Zopakovat odeslání této notifikace",
    "notificationRetryHint": "Zopakujeme odeslání jen téhle jedné zprávy jejímu původnímu příjemci. Nic dalšího se nepošle.",
    "notificationDrainHint": "Odešle všechny zprávy, které právě čekají ve frontě. Nejdřív se podívej, kolik jich je.",
    "notificationRetryDone": "Odeslání této notifikace je znovu naplánované. Výsledek zkontroluj v přehledu notifikací.",
    "notificationDrainDone": "Čekající notifikace byly zpracované. Výsledek zkontroluj v přehledu notifikací.",
    "notificationOperations": "Notifikace a opakování",
    "failedNotification": "Neúspěšná notifikace",
    "noFailedNotifications": "Žádná neúspěšná notifikace",
    "notificationId": "ID notifikace",
    "attempts": "Pokusy",
    "createClient": "Založit klienta",
    "createCall": "Vypsat hovor",
    "staffProfile": "Profil člena týmu",
    "attachmentId": "ID přílohy",
    "failedAttachment": "Příloha s neúspěšným přepisem",
    "noFailedAttachments": "Žádná příloha k opakování",
    "retryTranscript": "Zopakovat přepis této přílohy",
    "transcriptRetryHint": "Vyber jednoho klienta a jednu jeho přílohu. Znovu se zpracuje pouze přepis této přílohy.",
    "transcriptRetryDone": "Přepis této přílohy se zpracuje znovu. Výsledek zkontroluj u klientových příloh.",
    "staffId": "ID člena týmu",
    "photoUrl": "URL fotografie",
    "photoQualityHint": "Použij ostrý portrét s celou hlavou a prostorem kolem obličeje. Kruhový náhled níže odpovídá klientské vizitce.",
    "photoPreviewAlt": "Náhled portrétu na klientské vizitce",
    "photoPreviewCaption": "Zkontroluj, že kruhový ořez neřeže čelo, bradu ani boky obličeje.",
    "calendlyUrl": "URL Calendly",
    "publicEmail": "Veřejný e-mail",
    "clientName": "Jméno klienta",
    "clientNameExample": "Například Studio Novák",
    "ownerEmail": "E-mail vlastníka",
    "ownerName": "Jméno vlastníka",
    "ownerNameExample": "Například Jana Nováková",
    "ownerEmailExample": "expert@example.cz",
    "ownerEmailChange": {
      "title": "E-mail vlastníka",
      "hint": "Na tuhle adresu chodí přihlašovací odkaz i všechna upozornění. Když je v ní překlep, klient se nikdy nepřihlásí.",
      "current": "Současná adresa",
      "newLabel": "Nová adresa",
      "repeatLabel": "Nová adresa ještě jednou",
      "button": "Změnit adresu",
      "confirm": "Přepsat e-mail vlastníka? Klient: {client}. Nová adresa: {email}.",
      "consequences": "Dosud rozeslané přihlašovací odkazy přestanou platit, pošli klientovi nový. Rozepsaná upozornění odejdou už na novou adresu. Klient, který je právě přihlášený, přihlášený zůstane.",
      "confirmSave": "Ano, přepsat adresu",
      "saving": "Ukládám adresu...",
      "saved": "Hotovo. Adresa je teď {email}.",
      "invalid": "Tohle není platná e-mailová adresa.",
      "same": "Tuhle adresu klient už má.",
      "mismatch": "Adresy se neshodují. Napiš ji dvakrát stejně.",
      "error": {
        "generic": "Adresu se nepodařilo změnit. Nic se nezměnilo.",
        "email_taken": "Tuhle adresu už má jiný uživatel. Použij jinou, nebo nejdřív uvolni tu původní.",
        "email_unchanged": "Klient tuhle adresu už má, není co měnit.",
        "invalid_request": "Adresa nemá správný tvar. Zkontroluj ji a pošli znovu.",
        "not_found": "Klienta ani jeho vlastníka se nepodařilo najít. Načti stránku znovu.",
        "state_conflict": "Adresu mezitím změnil někdo jiný. Načti klienta znovu.",
        "idempotency_mismatch": "Tenhle požadavek už proběhl s jiným obsahem. Načti klienta znovu.",
        "forbidden": "Na tuhle akci nemáš právo.",
        "csrf_invalid": "Bezpečnostní kontrola neprošla. Načti stránku znovu.",
        "origin_invalid": "Bezpečnostní kontrola neprošla. Načti stránku znovu.",
        "impersonation_readonly": "V zobrazení za klienta se nedá nic měnit."
      }
    },
    "missingOutput": {
      "adminWhere": "Chybějící výstup doplníš v sekci Nastavení, v Editoru zdroje. Krok se pak uvolní sám.",
      "partnerWhere": "Tohle doplní admin v sekci Nastavení, v Editoru zdroje. Na tvojí straně tu žádné tlačítko není, napiš mu, co chybí.",
      "openResources": "Otevřít Nastavení"
    },
    "partnerId": "ID parťáka",
    "clientId": "ID klienta",
    "sendStep": "Provést vybraný krok dossieru",
    "dossierImportHint": "Vyber jednoho klienta. Provede se jen krok popsaný v poli níže a ostatní klienti se nezmění.",
    "dossierImportDone": "Vybraný krok dossieru je hotový. Výsledek zkontroluj v profilu tohoto klienta.",
    "dossierSteps": {
      "reserve": "1. Runner založí novou verzi dossieru a ověří manifest.",
      "upload": "2. Runner nahraje ověřené dávky faktů.",
      "finalize": "3. Runner zkontroluje počet a hash a teprve potom dossier zveřejní."
    },
    "dossierRunnerOnly": "Tyto kroky přijímají podepsaná data z runneru. V kokpitu se raw JSON ručně neupravuje.",
    "issueLoginLink": "Vydat nový přihlašovací odkaz",
    "loginLinkIssued": "Jednorázově zobrazený odkaz pro klienta:",
    "stripeConnect": {
      "title": "Stripe connect odkaz",
      "hint": "Vlož odkaz, který ti vygeneruje Alex. Klientovi se ukáže jako tlačítko Připojit Stripe. Odkaz nemá časovač; vyměň ho jen tehdy, když ho Stripe odmítne.",
      "current": "Aktuální odkaz:",
      "clear": "Odebrat",
      "saved": "Uloženo. Klient odkaz vidí ve svém kroku Stripe.",
      "afterTariffs": "Až v Owner Dashboardu nastavíš předplatná, pošli platební odkazy Alexovi přes Úpravy s Alexem na prodejní stránce. Doplní je do stránky a ty pak novou verzi zveřejníš klientovi."
    },
    "stripeImport": {
      "title": "Stripe import klientů",
      "masterSwitch": "Automatický import",
      "enabled": "zapnuto",
      "disabled": "vypnuto",
      "enabledHint": "Nákup napárovaného produktu založí klienta, pošle mu přihlašovací odkaz a podle jména a e-mailu spustí hledání ověřitelných informací na veřejném webu.",
      "disabledHint": "Import je vypnutý. Nákupy se pouze zapisují do přehledu níže, žádný klient nevznikne. Bezpečný zkušební režim.",
      "enableLabel": "Zapnout automatický import",
      "defaultPartner": "Výchozí parťák",
      "selectPartner": "Vyber výchozího parťáka",
      "empireExistingPartner": "Parťák pro Empire s existujícím Buddym",
      "selectEmpireExistingPartner": "Stejný jako výchozí parťák",
      "empireExistingPartnerHint": "Kupující Empire, který v poli Note při platbě uvede svého existujícího Buddyho, dostane tohoto parťáka.",
      "saveSettings": "Uložit nastavení",
      "saved": "Nastavení uloženo.",
      "mappings": "Napárované produkty",
      "emptyMappings": "Zatím žádné produkty. Přidej Stripe produkt, který obsahuje službu Done For You.",
      "addMapping": "Přidat produkt",
      "productId": "Produkt ve Stripe",
      "productLabel": "Produkt ze Stripe",
      "selectProduct": "Vyber produkt podle názvu",
      "selectLanguage": "Vyber jazyk klienta",
      "includesApp": "včetně mobilní aplikace",
      "loadProducts": "Načíst produkty ze Stripe",
      "productsUnavailable": "Produkty ze Stripe se nepodařilo načíst. Zkontroluj připojení ke Stripe a zkus to znovu.",
      "active": "aktivní",
      "inactive": "vypnuté",
      "deactivate": "Vypnout",
      "activate": "Zapnout",
      "events": "Události ze Stripe",
      "emptyEvents": "Zatím žádné události.",
      "outcome": {
        "imported": "importováno",
        "switch_off": "jen zaznamenáno (import vypnutý)",
        "no_match": "bez shody produktu",
        "already_client": "klient už existuje",
        "deferred_unpaid": "čeká na zaplacení",
        "error": "chyba",
        "unknown": "neznámý výsledek"
      },
      "jobs": "Sestavení profilu",
      "emptyJobs": "Zatím se žádný profil nesestavuje.",
      "jobStatus": {
        "pending": "ve frontě",
        "running": "probíhá",
        "done": "hotovo",
        "failed": "selhalo",
        "canceled": "zrušeno",
        "unknown": "stav není známý"
      },
      "selectClient": "Vyber klienta podle jména",
      "runResearch": "Sestavit profil klienta",
      "researchQueued": "Sestavení profilu čeká ve frontě.",
      "researchCurated": "Profil už má převzatý ruční podklad. Automatický výzkum ho nebude přepisovat.",
      "failure": {
        "notEnoughFacts": "Zadané jméno a e-mail nevedly k dostatečně jistému profilu. Doplň nebo oprav tyto údaje, ověř správnou osobu a sestavení spusť znovu.",
        "temporary": "Spojení se během sestavení přerušilo. Zkus sestavení spustit znovu.",
        "unknown": "Profil se nepodařilo sestavit z veřejně ověřitelných informací dohledaných podle jména a e-mailu. Ověř údaje klienta a zkus to znovu."
      },
      "eventIssue": {
        "missingPartner": "Import se zastavil, protože není vybraný výchozí parťák. Vyber ho v nastavení nahoře a změnu ulož.",
        "metadataFlag": "Produkt má ve Stripe klíč launchpad, ale jeho hodnota není 1. Oprav ji přímo u produktu ve Stripe.",
        "metadataLabel": "U produktu ve Stripe chybí launchpad_label, nebo je delší než 120 znaků. Doplň krátký název toho, co klient kupuje.",
        "metadataLanguage": "launchpad_language u produktu ve Stripe musí být cs nebo en. Oprav ho a nákup dolož ručním importem.",
        "metadataApp": "launchpad_app u produktu ve Stripe musí být 1 nebo 0. Oprav ho a nákup dolož ručním importem.",
        "metadataSource": "launchpad_source u produktu ve Stripe musí být direct, upsell nebo webinar. Oprav ho a nákup dolož ručním importem.",
        "metadataStart": "launchpad_start u produktu ve Stripe musí být new nebo existing. Oprav ho a nákup dolož ručním importem.",
        "stalePartner": "Klient vznikl, ale výchozí parťák z nastavení už není aktivní. Přiřaď klienta ručně a nastavení oprav.",
        "staleEmpirePartner": "Klient vznikl, ale parťák pro Empire s existujícím Buddym už není aktivní. Přiřaď klienta ručně a nastavení oprav.",
        "metadataProductType": "productType u produktu ve Stripe musí být start nebo empire. Oprav ho a nákup dolož ručním importem.",
        "metadataProductLanguage": "language u produktu ve Stripe musí být cs nebo en. Oprav ho a nákup dolož ručním importem.",
        "metadataProductApp": "enableMobileApp u produktu ve Stripe musí být true nebo false. Oprav ho a nákup dolož ručním importem.",
        "metadataDialectsDisagree": "Produkt ve Stripe nese obě sady metadat a neshodnou se. Nech u produktu jen jednu sadu a nákup dolož ručním importem.",
        "missingEmail": "Ve Stripe chybí email kupujícího. Doplň ho u platby a import zopakuj.",
        "noProducts": "U platby není žádný produkt. Zkontroluj položky nákupu ve Stripe.",
        "profileAlreadyQueued": "Klient vznikl a sestavení jeho profilu už čeká ve frontě. Stav najdeš výše.",
        "repeatedPurchase": "Tento nákup už Launchpad zpracoval. Nový klient nevznikl.",
        "stripeConnection": "Launchpad se nedostal k údajům ze Stripe. Zkontroluj propojení a zkus import znovu.",
        "clientCreation": "Klienta se nepodařilo založit. Zkontroluj jeho email a výchozího parťáka.",
        "unknown": "Import se nepodařilo dokončit. Zkontroluj údaje o nákupu a zkus to znovu.",
        "staleSalesOnlyPartner": "Klient vznikl, ale parťák pro Jen prodej už není aktivní, proto dostal výchozího parťáka. Zkontroluj přiřazení a nastavení oprav.",
        "metadataPayments": "launchpad_payments u produktu ve Stripe musí být 1 nebo 0. Oprav ho a nákup dolož ručním importem."
      },
      "configSource": {
        "metadata": "Nastavení tohoto nákupu přišlo z metadat produktu ve Stripe.",
        "mapping": "Nastavení tohoto nákupu přišlo z mapování produktů v Launchpadu."
      },
      "loadFailed": "Přehled se nepodařilo načíst.",
      "manualImport": "Ruční import klienta",
      "manualImportHint": "Formulář předá výzkumu jen jméno a e-mail. Podle nich dohledá ověřitelné informace na veřejném webu, takže před spuštěním zkontroluj, že údaje patří správné osobě. Import funguje i při vypnuté automatice.",
      "manualName": "Jméno klienta",
      "manualEmail": "E-mail klienta",
      "manualPartnerDefault": "Použít výchozího",
      "manualImportButton": "Importovat klienta a sestavit profil",
      "manualImportDone": "Klient je importovaný a jeho profil se sestavuje.",
      "manualImportFailed": "Import se nepovedl. Zkontroluj e-mail a výchozího parťáka.",
      "addMappingNeedsProduct": "Vyber produkt, který chceš namapovat.",
      "selectJourney": "Vyber cestu klienta",
      "addMappingNeedsLanguage": "Vyber jazyk, ve kterém tenhle produkt klienta obsluhujeme. Odvíjí se od něj celá aplikace i všechny materiály.",
      "addMappingNeedsLoad": "Nejdřív načti produkty ze Stripu, pak z nich vyber ten, který chceš namapovat.",
      "manualImportNeedsJourney": "Vyber, kterou část nákup obsahoval. Celá cesta začíná Úvodním videem, Jen prodej Marketingovým videem. Opravit to jde jen v detailu klienta.",
      "clientLabel": "Klient",
      "salesOnlyPartner": "Parťák pro Jen prodej",
      "selectSalesOnlyPartner": "Stejný jako výchozí parťák",
      "salesOnlyPartnerHint": "Každý nákup produktu s launchpad_journey=sales_only dostane tohoto parťáka, i když kupující v poli Note uvede svého Buddyho."
    },
    "phaseName": {
      "home": "Domov",
      "onboarding_call": "Úvodní video",
      "q1": "Dotazník k přípravě",
      "knowhow": "Know-how",
      "training": "Trénink Buddyho",
      "beta": "Beta testování",
      "marketing_call": "Marketingové video",
      "q2": "Prodejní dotazník",
      "sales": "Prodejní materiály",
      "stripe": "Napojení Stripe",
      "handover": "Předání",
      "app": "Mobilní aplikace"
    },
    "phaseInfo": {
      "home": "Domovská stránka klienta: souhrn kroků, průběh a další akce. Vždy dostupná.",
      "onboarding_call": "Klient sleduje úvodní video. Další krok (dotazník) se mu otevře v nastaveném čase videa.",
      "q1": "Klient hlasem nebo textem popisuje sebe, klienty, metodu, hranice, jméno a hlas Buddyho a nahrává profilovou fotku. Z odpovědí trénujeme instanci.",
      "knowhow": "Klient potvrzuje Google účty a plní sdílenou složku svými materiály (kurzy, texty, nahrávky). Tým z ní staví znalostní základ.",
      "training": "Tým vytváří instanci z odpovědí a know-how. Klient čeká, vidí animaci s avatarem a do 24 hodin dostává první verzi.",
      "beta": "Klient a pár testerů si s Buddym píší, sbírají dojmy a posílají podněty. Tým podněty zapracovává.",
      "marketing_call": "Video o prodeji instance. V nastaveném čase odemyká prodejní dotazník.",
      "q2": "Klient popisuje svůj příběh, klienty, důkazy, ceny a publikum plus fotky pro prodejní stránku. Z toho vzniká prodejní balíček.",
      "sales": "Tým připravuje audit, strategii, prodejní stránku a e-maily. Klient je postupně potvrzuje.",
      "stripe": "Klient si zakládá Stripe, zve tvůj e-mail do týmu a ty mu pomáháš nastavit platby.",
      "handover": "Klient dodává Telegram ID pro roli majitele a připojuje si Owner Dashboard. Hotovo, když klient potvrdí, že se mu dashboard otevřel.",
      "app": "Pro balíčky s aplikací: Apple účet, build a schvalování v obchodech. Bez aplikace nabídka doplnění."
    },
    "myProfile": {
      "language": {
        "title": "Jazyk konzole",
        "copy": "Volba se uloží k tvému účtu a platí pro celou konzoli i pro klientské obrazovky."
      },
      "open": "Můj profil",
      "kicker": "Tvoje vizitka",
      "title": "Uprav svůj profil",
      "name": "Jméno",
      "photo": "Profilová fotka",
      "choosePhoto": "Vybrat fotografii",
      "changePhoto": "Změnit fotografii",
      "photoSaved": "Aktuální fotografie je uložená, klienti ji vidí na tvé kartě",
      "noPhotoChosen": "Zatím není vybraná žádná fotografie",
      "photoTooSmall": "Fotka se nenahrála, je příliš malá. Vyber snímek alespoň 384 × 384 px.",
      "photoUnreadable": "Tenhle soubor neumíme přečíst. Ulož si fotku jako JPEG, PNG nebo WEBP a zkus to znovu.",
      "copyValue": "Zkopírovat celou hodnotu",
      "copiedValue": "Hodnota je zkopírovaná. Teď ji můžeš vložit tam, kde ji potřebuješ.",
      "calendly": "Calendly odkaz",
      "email": "E-mail pro klienty",
      "emailHint": "Na tento e-mail se ti klienti ozvou, když budou u kroku plateb potřebovat pomoct.",
      "telegram": "Telegram uživatelské jméno",
      "telegramId": "Telegram ID (z /myid)",
      "telegramHint": "Potřebujeme tě přidávat do týmu každé instance. ID zjistíš tak, že libovolnému Buddymu pošleš /myid.",
      "save": "Uložit profil",
      "saving": "Ukládám...",
      "saved": "Uloženo. Klienti uvidí novou kartu hned.",
      "previewLabel": "Takhle se tvoje karta zobrazuje klientům v jejich Launchpadu:",
      "telegramIdPlaceholder": "např. 123456789",
      "phone": "Telefon včetně předvolby",
      "phonePlaceholder": "+420 777 123 456",
      "phoneHint": "Klient pak u tvé karty uvidí tlačítko Napsat na Telegramu. Když máš vyplněné i uživatelské jméno na Telegramu, otevře se chat přes něj. Jen s telefonem se chat otevře, pokud máš v Telegramu v Soukromí u Telefonního čísla povoleno, že tě lidé podle čísla najdou.",
      "vPhone": "Telefon napiš i s předvolbou, třeba +420 777 123 456",
      "calendlyPlaceholder": "https://calendly.com/...",
      "vName": "Vyplň prosím jméno (aspoň 2 znaky).",
      "vPhoto": "Fotka musí být https adresa, nebo nahraj soubor tlačítkem.",
      "vCalendly": "Odkaz na kalendář musí začínat https://",
      "vEmail": "E-mail pro klienty nemá správný tvar.",
      "vTelegram": "Telegram jméno: 5 až 32 znaků, písmena, čísla a podtržítka.",
      "vTelegramId": "Telegram ID je číslo z příkazu /myid (5 až 15 číslic).",
      "google": "Google účet pro Drive složky",
      "googleHint": "Na tento účet ti nasdílíme know-how složky tvých klientů. Když ho nevyplníš, použijeme e-mail pro klienty.",
      "vGoogle": "Google účet musí být platná e-mailová adresa."
    },
    "answerEmpty": "Bez odpovědi",
    "submissionStatus": "Stav",
    "submissionState": {
      "draft": "Rozpracované",
      "waiting_for_transcripts": "Čeká na přepisy nahrávek",
      "ready": "Připravené k výrobě",
      "exported": "Předané do výroby"
    },
    "submissionExportedAt": "Do výroby",
    "submissionBuddy": "Buddy",
    "submissionLanguage": "Jazyk trhu",
    "submissionLanguageName": {
      "cs": "čeština",
      "en": "angličtina"
    },
    "submissionInstance": "Instance",
    "submissionInstanceMode": {
      "new": "nová",
      "existing": "existující"
    },
    "submittedAt": "Odesláno",
    "rawData": "Technická data",
    "yes": "Ano",
    "no": "Ne",
    "crm": {
      "title": "Záznam v CRM",
      "none": "Klient v CRM zatím není.",
      "error": "CRM se teď nepodařilo načíst.",
      "errorHint": "Spojení s CRM neodpovědělo. Data klienta v Launchpadu zůstávají beze změny.",
      "company": "Firma",
      "phone": "Telefon",
      "website": "Web",
      "meeting": "Schůzka",
      "meetingYes": "Domluvená",
      "meetingNo": "Žádná domluvená"
    },
    "purchaseLicense": {
      "title": "Licence z nákupu",
      "unconfigured": "Napojení na licenční API BuddyPro zatím není nastavené, licence z nákupu se proto nenačítají.",
      "error": "Licence z nákupu se teď nepodařilo načíst.",
      "errorHint": "Licenční API neodpovědělo. Data klienta v Launchpadu zůstávají beze změny.",
      "none": "Na e-mail klienta zatím žádná licence z nákupu nevznikla.",
      "credits": "Kredity",
      "creditsCount": {
        "one": "1 kredit",
        "few": "{count} kredity",
        "other": "{count} kreditů"
      },
      "creditsUnknown": "Neuvedeno",
      "productType": "Balíček",
      "productTypeUnknown": "Neuvedeno",
      "bot": "Bot",
      "botNone": "Zatím u žádného bota",
      "state": "Stav",
      "stateActive": "Aktivní",
      "stateDisabled": "Vypnutá"
    },
    "notify": {
      "title": "Poslat klientovi zprávu",
      "hint": "E-mail (a push, pokud má aplikaci) odejde klientovi hned. Použij, když ho chceš na něco upozornit.",
      "subject": "Předmět",
      "message": "Text zprávy",
      "send": "Odeslat klientovi",
      "sending": "Odesílám...",
      "sent": "Odesláno."
    },
    "resourceName": {
      "drive_folder": "Složka na Google Disku",
      "url_doc": "Dokument s odkazy",
      "trial_link": "Zkušební pozvánka Buddyho",
      "license": "Licence",
      "bot_transfer_state": "Převod Telegram bota",
      "app_state": "Stav mobilní aplikace",
      "stripe_setup": "Nastavení Stripe",
      "q1_question_overrides": "Personalizace dotazníku 1",
      "q2_question_overrides": "Personalizace dotazníku 2",
      "knowhow_google_account": "Google účty pro know-how",
      "handover_telegram": "Telegram účet klienta",
      "instance_folder": "Složka Buddyho instance",
      "license_key": "Licenční klíč",
      "dfy_package": "Balíček DFY",
      "order_links": "Odkazy na objednávku",
      "knowhow_handover": "Předání složky know-how",
      "staff_overrides": "Zásahy parťáka",
      "app_interest": "Zájem o aplikaci",
      "instance_team_request": "Žádost o tým instance",
      "sales_edit_request": "Audio úprava materiálu",
      "onboarding_video": "Úvodní video",
      "marketing_video": "Marketingové video",
      "step_confirmations": "Potvrzení kroků",
      "partner_materials": "Materiály od parťáka"
    },
    "resourceField": {
      "accepted_at": "Přijato",
      "app_store_review": "Recenze v App Store",
      "bot_username": "Bot",
      "build": "Build aplikace",
      "client_invited_team": "Klient pozval tým",
      "confirmed_at": "Potvrzeno",
      "description": "Popis",
      "duration_seconds": "Délka v sekundách",
      "email": "E-mail",
      "google_account_required": "Vyžaduje účet Google",
      "google_play_review": "Recenze na Google Play",
      "invite_limit": "Počet pozvánek",
      "label": "Název",
      "next_actor": "Na tahu",
      "note": "Poznámka",
      "requested_at": "Požádáno",
      "resolved_at": "Vyřízeno",
      "shared_at": "Nasdíleno",
      "shared_email": "Nasdílený účet",
      "state": "Stav",
      "status": "Stav",
      "telegram_username": "Telegram",
      "title": "Název pro klienta",
      "transferred_at": "Předáno",
      "type": "Typ",
      "updated_at": "Aktualizováno",
      "url": "Odkaz",
      "valid_from": "Platí od",
      "verified_at": "Ověřeno",
      "verified_receiving": "Příjem plateb ověřen"
    },
    "videos": {
      "title": "Videa",
      "none": "Klient zatím žádné video nemá.",
      "kind": {
        "onboarding_video": "Úvodní video",
        "marketing_video": "Marketingové video"
      },
      "watched": "Zhlédnuto",
      "completed": "Dokončeno",
      "notStarted": "Zatím nespuštěné",
      "source": {
        "client": "Vlastní video klienta",
        "global": "Výchozí video"
      },
      "unconfiguredHistory": "Video už není nastavené, průběh zůstává uložený.",
      "defaultsTitle": "Výchozí videa",
      "defaultHint": "Platí pro všechny klienty bez vlastního videa. Vlastní video pro konkrétního klienta nastavíš v jeho detailu v editoru zdrojů.",
      "urlLabel": "Adresa videa (mp4 nebo stream)",
      "titleLabel": "Název pro klienta",
      "durationLabel": "Délka v sekundách (povinná, když nastavuješ čas odemčení)",
      "confirmClearDefault": "Opravdu odebrat výchozí video? Klientům s vlastním videem zůstane jejich.",
      "saved": "Uloženo.",
      "unlockAtLabel": "Čas odemčení dalšího kroku (sekundy od začátku)",
      "unlockAtHint": "Moment videa, kdy se klientovi otevře další krok. Bez vyplnění se krok otevře dokoukáním.",
      "unlockReady": "Další krok odemčen"
    },
    "instance": {
      "title": "BuddyPro instance",
      "detail": "Detail instance (log, agentic a debug mód)",
      "openBot": "Otevřít bota",
      "drive": "Složka na Disku",
      "trial": "Zkušební pozvánka",
      "modesHint": "V detailu instance na Hubu ovládáš instanci (agentic mód), debuguješ ji a vidíš celý záznam vytváření včetně system promptu.",
      "teamTitle": "Členství v týmu instance",
      "teamHint": "Nejdřív jednou otevři bota a napiš mu (Telegram jinak přidání nedovolí). Pak klikni a přidáme tě jako člena týmu s právy správce.",
      "teamAutoHint": "Máš vyplněné Telegram ID, takže tě do týmu přidáme sami, jakmile je bot hotový. Tlačítko níž použij, když chceš přidání vyvolat hned.",
      "teamNeedIdHint": "Nejdřív si v Mém profilu vyplň Telegram ID (z /myid) a jednou napiš botovi. Pak tě do týmu přidáme automaticky.",
      "teamFailedHint": "Telegram nedovolí přidat člověka, který botovi nikdy nenapsal. Otevři bota, pošli mu libovolnou zprávu a dej Zkusit znovu.",
      "join": "Přidat mě do týmu",
      "joining": "Odesílám...",
      "teamPending": "Žádost běží, přidání proběhne do pár minut.",
      "teamDone": "Jsi členem týmu s právy správce.",
      "teamFailed": "Přidání do týmu se nepovedlo.",
      "needTelegram": "Nejdřív si v Mém profilu vyplň Telegram ID (z /myid).",
      "manage": "Spravovat instanci",
      "retry": "Zkusit znovu"
    },
    "salesEdit": {
      "sending": "Nahrávám...",
      "queued": "Odesláno. Přepis a úprava proběhnou automaticky.",
      "processing": "Úprava podle tvé nahrávky právě běží. Nová verze se tu objeví sama.",
      "done": "Úprava hotová, nová verze materiálu je v seznamu.",
      "failed": "Úprava se nepovedla:",
      "hint": "Řekni, co v materiálu změnit. Přepíšeme to a AI úpravy rovnou zapracuje jako novou verzi."
    },
    "paneError": "Tuhle záložku se nepodařilo vykreslit. Zbytek konzole běží dál.",
    "instanceMode": "Instance",
    "journeyMode": "Režim cesty",
    "journeyHint": "Jen prodej znamená, že Buddy vznikl mimo systém. Klient projde šest kroků prodejní kapitoly a Přípravu Buddyho ani Předání nikdy neuvidí.",
    "journey": {
      "full": "Celá cesta",
      "sales_only": "Jen prodej"
    },
    "clientGender": "Rod klienta",
    "gender": {
      "unknown": "Nevíme",
      "female": "Žena",
      "male": "Muž"
    },
    "purchaseMode": "Nákup",
    "appMode": "Mobilní aplikace",
    "axis": {
      "instance_new": "Nová instance",
      "instance_existing": "Existující instance",
      "purchase_direct": "Přímý nákup",
      "purchase_upsell": "Upsell",
      "purchase_webinar": "Z webináře",
      "app_yes": "Ano",
      "app_no": "Ne"
    },
    "enum": {
      "not_started": "nezačato",
      "in_progress": "probíhá",
      "done": "hotovo",
      "failed": "selhalo",
      "new": "nové",
      "preparing": "připravuje se",
      "awaiting_client": "čeká na klienta",
      "client_confirmed": "klient potvrdil",
      "transferred": "převedeno",
      "none": "nikdo"
    },
    "answerConfirmed": "Klient potvrdil, že údaje sedí.",
    "answerChoice": {
      "clone": "Digitální dvojník (mluví jako expert)",
      "knowledge_expert": "Samostatný AI expert s vlastní osobností"
    },
    "answerRange": {
      "under_1000": "do 1 000",
      "1000_4999": "1 000 až 4 999",
      "5000_19999": "5 000 až 19 999",
      "20000_plus": "20 000+"
    },
    "metricUnassigned": "bez parťáka",
    "unassigned": {
      "eyebrow": "Úkol dne",
      "title": "Nepřiřazení klienti",
      "lead": "Vyber parťáka, který klienta převezme. Dokud ho klient nemá, vidí na dashboardu, že se parťák přiřazuje.",
      "empty": "Každý klient má svého parťáka.",
      "truncated": "Zobrazujeme prvních {shown} z {total} nepřiřazených klientů. Přiřaď tyhle a další se načtou.",
      "product": "Produkt",
      "productManual": "Ručně založený klient",
      "productUnknown": "Z nákupu, produkt neumíme pojmenovat",
      "market": "Trh",
      "arrived": "V Launchpadu od",
      "profileFacts": { "one": "{count} fakt v profilu", "few": "{count} fakta v profilu", "other": "{count} faktů v profilu" },
      "profileEmpty": "Profil zatím nemáme",
      "openClient": "Otevřít profil klienta",
      "assignLabel": "Parťák",
      "assignSubmit": "Přiřadit",
      "assigning": "Přiřazuji...",
      "assignDone": "Hotovo, klient má parťáka.",
      "errorPartnerUnavailable": "Tenhle parťák už není aktivní. Vyber jiného.",
      "error": "Přiřazení se nepovedlo. Zkus to znovu.",
      "noPartners": "V týmu není žádný aktivní parťák. Nejdřív někoho přidej ve Správě."
    },
    "metricStuck": "zaseklých (14+ dní)",
    "staffProfileMember": "Člen týmu",
    "dossierPayload": "Data kroku (JSON)",
    "team": {
      "title": "Tým",
      "hint": "Přidej člena a rozhodni jeho roli. Parťák se může stát administrátorem. Poslední aktivní administrátor je chráněný.",
      "email": "E-mail",
      "name": "Jméno",
      "nameExample": "Například Tomáš Novák",
      "emailExample": "partner@example.cz",
      "role": "Role",
      "sendInvite": "Poslat přihlašovací odkaz",
      "add": "Přidat člena",
      "exists": "Tento e-mail už v týmu je.",
      "inviteReady": "Přihlašovací odkaz (jen ty ho vidíš):",
      "you": "vy",
      "inactive": "Neaktivní",
      "clients": "Klientů",
      "lastSeen": "Naposledy",
      "never": "nikdy",
      "profileOk": "Profil vyplněn",
      "profileMissing": "Profil chybí",
      "deactivate": "Deaktivovat",
      "reactivate": "Obnovit",
      "sendLink": "Poslat přihlašovací odkaz",
      "reassignTo": "Předat klienty",
      "choose": "Vyber",
      "assignLater": "Přiřadím později",
      "allFiltered": "Všichni parťáci v seznamu jsou testovací. Vypni filtr testovacích klientů, nebo přidej člena týmu.",
      "showTestMembers": "Zobrazit i testovací členy",
      "confirmReassign": "Předat a deaktivovat",
      "needHeir": "Tento parťák má klienty. Vyber, kdo je převezme.",
      "lastAdmin": "Nelze deaktivovat posledního administrátora.",
      "lastAdminNote": "Poslední administrátor: role a stav jsou zamčené.",
      "roleBlocked": "Změnu role se nepodařilo provést.",
      "linkSent": "Přihlašovací odkaz odeslán.",
      "adminCount": "Administrátoři: {count}",
      "partnerCount": "Parťáci: {count}",
      "search": "Hledat v týmu",
      "filterRole": "Role",
      "filterActivity": "Aktivita účtu",
      "allRoles": "Všechny role",
      "onlyActive": "Jen aktivní",
      "onlyInactive": "Jen neaktivní",
      "allActivity": "Aktivní i neaktivní",
      "activeHeading": "Aktivní tým",
      "inactiveHeading": "Neaktivní účty",
      "noResults": "Tomuto filtru nikdo neodpovídá.",
      "heirsAllFiltered": "Všichni možní dědicové jsou testovací účty. Vypni filtr testovacích klientů, nebo přidej do týmu skutečného parťáka."
    },
    "activity": {
      "empty": "Zatím žádná aktivita.",
      "openClient": "Otevřít klienta",
      "systemActor": "Systémová operace",
      "noTarget": "Bez klientského detailu",
      "version": "verze {version}",
      "materialCreated": "Vytvořen materiál",
      "materialUpdated": "Upraven materiál",
      "materialPublished": "Zveřejněn materiál",
      "materialFailed": "Selhala výroba materiálu",
      "unknown": "Provozní změna",
      "unknownDetail": "Pokud tuto změnu nepoznáváš, zkontroluj související plochu.",
      "detail": {
        "app_release_status_changed": "Zapsali jsme, kde aplikace stojí ve schvalování.",
        "bot_transfer_false_done_repaired": "Převod bota se dřív zapsal jako hotový, i když neproběhl. Stav je vrácený.",
        "bot_transfer_settings_updated": "Automatický převod bota je nově zapnutý nebo vypnutý.",
        "bot_transferred_automatically": "Bot změnil majitele bez ručního zásahu. Klientovi se otevřel další krok.",
        "global_unlock_link_changed": "Odkaz na hovor má nové jméno. Staré přestává platit.",
        "instance_folder_recorded": "Známe složku Buddyho na Disku. Předání na ni může navázat.",
        "knowhow_handover_verified": "Google potvrdil, že klient do složky vidí.",
        "license_key_imported": "Klíč je u klienta. V předání si ho může zkopírovat.",
        "material_regeneration_requested": "Materiál se dělá znovu od nuly podle aktuálního zadání.",
        "notification_label_fallback": "Notifikace o materiálu neznala jeho název. Zkontroluj mapování druhů.",
        "order_links_confirmed": "Klient odkazy odsouhlasil. Můžou se zapracovat do stránky.",
        "order_links_integrated": "Prodejní stránka vede na objednávku. Klient si ji může stáhnout.",
        "order_links_integration_requested": "Běží úprava prodejní stránky. Výsledek se zveřejní sám.",
        "owner_role_done": "Klient je majitelem instance. My už ji nenastavujeme.",
        "owner_role_failed": "Nastavení majitele neprošlo. Podívej se na frontu předání.",
        "owner_role_id_refused": "Číslo od klienta se nedá použít. Klient dostal výzvu k opravě.",
        "owner_role_job_queued": "Čeká se na běh, který nastaví majitele.",
        "owner_role_settings_updated": "Automatické předání instance je nově zapnuté nebo vypnuté.",
        "partner_brief_saved": "Zadání pro Alexe se změnilo. Platí od příští výroby.",
        "sales_edit_merged": "Nová verze prodejní stránky je venku.",
        "staff_override_approved": "Parťák rozhodl místo klienta a napsal proč.",
        "sales_only_import": "Import režimu Jen prodej. Krok proběhl mimo systém, e-mail nikomu neodešel.",
        "training_resume_requested": "Trénink dvojčete se má rozjet znovu.",
        "staff_created": "Člen je v týmu. Zkontroluj jeho roli a profil.",
        "staff_role_changed": "Nová role platí pro další práci v Launchpadu.",
        "staff_deactivated": "Účet už se nepřihlásí. Ověř, že klienti mají parťáka.",
        "staff_reactivated": "Účet se může znovu přihlásit.",
        "call_created": "Termín je v přehledu hovorů.",
        "call_updated": "Přehled hovorů už ukazuje nové údaje.",
        "call_deleted": "Termín už v přehledu není.",
        "unlock_code_created": "Kód je připravený pro vybraný hovor.",
        "unlock_code_revoked": "Kód už nejde použít.",
        "resource_updated": "Nová hodnota je uložená u klienta.",
        "partner_message_sent": "Zpráva odešla klientovi.",
        "impersonation_acting": "Náhled přepnut do režimu jednání za klienta.",
        "impersonation_looking": "Náhled vrácen do režimu jen koukám.",
        "impersonated_write": "Změnu za klienta provedl člen týmu.",
        "impersonation_started": "Byl otevřený náhled klientské plochy.",
        "sessions_revoked": "Vybrané relace už neplatí.",
        "magic_link_issued": "Přihlašovací odkaz byl vydaný.",
        "profile_research_completed": "Profil klienta je sestavený a čeká na kontrolu.",
        "profile_research_failed": "Profil se nesestavil. Důvod najdeš ve Stripe importu.",
        "deliverable_published": "Klient už vidí novou verzi materiálu.",
        "notification_requeued": "Odeslání jedné notifikace bylo zopakované.",
        "profile_change": "Profil klienta nebo jeho podklady se změnily.",
        "material_change": "Stav klientského materiálu nebo připomínky se změnil.",
        "call_change": "Změna je vidět v přehledu hovorů a rezervací.",
        "client_progress": "Klientův postup je aktualizovaný v jeho detailu.",
        "client_resource": "Technický údaj klienta byl změněný.",
        "automation_result": "Automatizace dokončila nebo zopakovala konkrétní úlohu.",
        "access_change": "Přístup nebo pozvánka byly změněné.",
        "system_change": "Proběhla údržba nebo změna nastavení Launchpadu.",
        "import_change": "Změnil se import dat nebo jeho nastavení.",
        "transcript_requeued": "Přepis je zpátky ve frontě. Hotový text se objeví v profilu klienta.",
        "staff_profile_updated": "Změnu najdeš v panelu Tým a přístupy, v detailu toho člena.",
        "notification_delivery_tested": "Zkušební zpráva na adresu administrátora, který ji spustil. Výsledek je v Notifikační frontě."
      },
      "type": {
        "app_release_status_changed": "Změněn stav vydání aplikace",
        "bot_transfer_false_done_repaired": "Opraven falešně hotový převod",
        "bot_transfer_settings_updated": "Změněn přepínač převodu bota",
        "bot_transferred_automatically": "Bot převeden automaticky",
        "global_unlock_link_changed": "Přejmenován společný odkaz",
        "instance_folder_recorded": "Zapsána složka instance",
        "knowhow_handover_verified": "Ověřen přístup ke složce",
        "license_key_imported": "Dorazil licenční klíč",
        "material_regeneration_requested": "Vyžádána nová výroba materiálu",
        "notification_label_fallback": "Zpráva bez jména materiálu",
        "order_links_confirmed": "Potvrzeny odkazy na objednávku",
        "order_links_integrated": "Odkazy zapracovány do stránky",
        "order_links_integration_requested": "Odkazy poslány ke zpracování",
        "owner_role_done": "Instance předána klientovi",
        "owner_role_failed": "Předání instance selhalo",
        "owner_role_id_refused": "Odmítnuto telegramové číslo",
        "owner_role_job_queued": "Předání instance ve frontě",
        "owner_role_settings_updated": "Změněn přepínač předání instance",
        "partner_brief_saved": "Uložena poznámka k výrobě",
        "sales_edit_merged": "Zapracována úprava stránky",
        "staff_override_approved": "Krok potvrzen za klienta",
        "sales_only_import": "Zapsán krok z importu Jen prodej",
        "training_resume_requested": "Vyžádáno pokračování tréninku",
        "staff_created": "Přidán člen týmu",
        "staff_role_changed": "Změněna role",
        "staff_deactivated": "Deaktivován člen",
        "staff_reactivated": "Obnoven člen",
        "call_created": "Vytvořen hovor",
        "call_updated": "Upraven hovor",
        "call_deleted": "Smazán hovor",
        "unlock_code_created": "Vytvořen odemykací kód",
        "unlock_code_revoked": "Zrušen odemykací kód",
        "resource_updated": "Upraven zdroj",
        "partner_message_sent": "Odeslána zpráva klientovi",
        "impersonation_acting": "Jednání za klienta zapnuto",
        "impersonation_looking": "Jen koukám",
        "impersonated_write": "Změna za klienta",
        "impersonation_started": "Otevřeno jako klient",
        "sessions_revoked": "Odhlášeny relace",
        "magic_link_issued": "Vydán přihlašovací odkaz",
        "profile_research_completed": "Sestaven profil klienta",
        "profile_research_failed": "Selhalo sestavení profilu",
        "deliverable_published": "Zveřejněn materiál",
        "notification_requeued": "Zopakována notifikace",
        "profile_change": "Změněn profil klienta",
        "material_change": "Změněn klientský materiál",
        "call_change": "Změněn hovor nebo rezervace",
        "client_progress": "Změněn postup klienta",
        "client_resource": "Změněn údaj klienta",
        "automation_result": "Dokončena automatizace",
        "access_change": "Změněn přístup",
        "system_change": "Změněn provoz Launchpadu",
        "import_change": "Změněn import dat",
        "transcript_requeued": "Znovu spuštěný přepis",
        "staff_profile_updated": "Upraven profil člena týmu",
        "notification_delivery_tested": "Vyzkoušeno doručení zprávy"
      }
    },
    "promptPatch": {
      "title": "Zapracování podnětů do promptu",
      "hint": "Zaškrtni nahoře podněty, které má Alex zapracovat do system promptu Buddyho. Alex navrhne konkrétní úpravu (před a po) a u každého podnětu řekne, jestli patří do promptu, do know-how klienta, nebo jde o chybu platformy. Do promptu se nic nezapíše bez tvého schválení.",
      "selectLabel": "Vybrat k zapracování do promptu",
      "selectedCount": "Vybrané podněty: {count}",
      "noteLabel": "Poznámka pro Alexe (nepovinné)",
      "notePlaceholder": "Například: hlavně ať odpovídá stručněji.",
      "submit": "Zapracovat do promptu",
      "submitting": "Odesílám…",
      "selectHint": "Nejdřív zaškrtni aspoň jeden nový podnět.",
      "openBlocks": "Rozpracovaná žádost musí nejdřív doběhnout, potom jde poslat další.",
      "requestedAt": "Odesláno {date}, podnětů: {count}",
      "partnerNote": "Tvoje poznámka: {note}",
      "summaryLabel": "Shrnutí návrhu",
      "itemsTitle": "Kam který podnět patří",
      "unknownPodnet": "Podnět, který už v seznamu není",
      "patchTitle": "Úpravy promptu",
      "before": "Před",
      "after": "Po",
      "why": "Proč: {why}",
      "noPatch": "Návrh text promptu nemění. Podněty patří jinam, viz rozdělení výše.",
      "edit": "Upravit text po",
      "editDone": "Hotovo",
      "edited": "Upraveno ručně",
      "approve": "Schválit",
      "reject": "Zamítnout",
      "rejectNoteLabel": "Proč návrh nesedí (nepovinné)",
      "confirmReject": "Opravdu zamítnout",
      "cancel": "Zrušit",
      "deciding": "Ukládám…",
      "resultNote": "Poznámka: {note}",
      "appliedHint": "Podněty zařazené do promptu jsou označené jako zapracované a klient je tak vidí.",
      "categories": {
        "prompt": "Do promptu",
        "knowhow": "Chybí know-how, doplní klient",
        "platform": "Chyba platformy, řešíme my",
        "irrelevant": "Není relevantní"
      },
      "states": {
        "queued": "Čeká, Alex připraví návrh úpravy promptu.",
        "proposing": "Alex právě připravuje návrh úpravy promptu.",
        "proposed": "Návrh je připravený. Projdi ho, případně uprav text po, a schval nebo zamítni.",
        "approved": "Schváleno. Zapisuje se do promptu.",
        "applying": "Zapisuje se do promptu.",
        "applied": "Zapracováno. Prompt je upravený a nasazený.",
        "rejected": "Návrh je zamítnutý. Do promptu se nic nezapsalo.",
        "failed": "Zapsání do promptu se nepovedlo.",
        "unavailable": "Stav teď nejde načíst. Zkus to za chvíli."
      },
      "errors": {
        "already_open": "U tohoto klienta už jedna žádost běží. Počkej, až doběhne.",
        "invalid_feedback": "Některý z vybraných podnětů už není otevřený. Obnov stránku a vyber znovu.",
        "state_conflict": "Žádost se mezitím posunula. Obnov stránku.",
        "generic": "Akce se nepovedla. Zkus to za chvíli."
      }
    },
    "promptRebuild": {
      "title": "System prompt Buddyho",
      "hint": "Přegeneruje system prompt a uvítací zprávy z know-how, které je teď ve složce instance, a pustí /update. Běh trvá desítky minut a přepíše současný prompt.",
      "launch": "Přegenerovat prompt",
      "confirmOverwrite": "Přesto přegenerovat a přepsat ruční úpravy",
      "cancel": "Zrušit",
      "starting": "Spouštím…",
      "states": {
        "idle": "Prompt se zatím z Launchpadu nepřegenerovával.",
        "queued": "Běh čeká na spuštění.",
        "running": "Prompt se právě přegenerovává. Trvá to desítky minut, stránku můžeš zavřít.",
        "done": "Prompt je přegenerovaný a nasazený.",
        "failed": "Poslední běh se nepovedl.",
        "unavailable": "Stav běhu teď nejde načíst. Zkus to za chvíli."
      },
      "reasons": {
        "doc_edited_by_human": "Prompt někdo upravoval ručně. Přegenerování ty úpravy přepíše.",
        "already_running": "U tohoto klienta nebo jiného právě běží přegenerování. Počkej, až doběhne.",
        "not_enough_sources": "Ve složce instance zatím není dost know-how, ze kterého by šlo prompt postavit.",
        "no_instance": "K tomuto klientovi nemáme instanci, ze které by šlo prompt postavit.",
        "no_workspace": "K tomuto klientovi nemáme instanci, ze které by šlo prompt postavit.",
        "unavailable": "Spuštění teď nejde. Zkus to za chvíli, případně napiš do vlákna #dfy-service."
      },
      "summary": "Zpracováno přepisů: {transcripts} · délka promptu: {chars} znaků · otevřené otázky: {questions}",
      "promptDoc": "Otevřít system prompt",
      "onboardingDoc": "Otevřít uvítací zprávy",
      "finishedAt": "Dokončeno {date}"
    },
    "dfyBuild": {
      "title": "Prodejní materiály (DFY)",
      "hint": "Výroba se spouští automaticky. Tlačítka použij, jen když je potřeba ruční zásah.",
      "notReady": "Nejdřív musí klient odeslat prodejní dotazník.",
      "launch": "Spustit tvorbu prodejní stránky",
      "launchGate": "Spustit výrobu",
      "launched": "Spuštěno, pracuje se",
      "gates": {
        "audit": "Návrh prodejní strategie",
        "salespage": "Prodejní stránka",
        "emails": "E-maily",
        "webinar": "Webinář"
      },
      "gateLocked": "Tento krok se odemkne, až klient potvrdí předchozí dokument.",
      "gateLaunched": "{gate}: spuštěno",
      "launching": "Spouštím…",
      "running": "Výroba právě běží.",
      "stale": "Výroba se odmlčela, možná spadla. Můžeš ji spustit znovu.",
      "failed": "Výroba skončila chybou.",
      "done": "Podklad je připravený.",
      "retry": "Spustit znovu",
      "materialVersion": "verze {version}",
      "materialState": {
        "none": "Zatím nevzniklo",
        "draft": "Rozpracováno",
        "review": "Ke kontrole",
        "approved": "Schváleno",
        "published": "Zveřejněno"
      },
      "openDeliverables": "Otevřít podklady",
      "elapsed": "Běží {minutes} min",
      "lastActivity": "Poslední aktivita před {minutes} min",
      "estimateStrategy": "Obvykle 10-30 minut.",
      "estimateOther": "Může trvat i desítky minut.",
      "etaAt": "Hotovo přibližně v {time} (odhad z {count} běhů)",
      "etaRemaining": "Zbývá asi {minutes} min",
      "steps": {
        "knowledge-pack": "Znalosti Online Stratéga",
        "audit-brief": "Podklady pro audit",
        "audit-readback": "Audit: čtení vstupů",
        "plan-brief": "Zadání strategie",
        "sol-draft": "Psaní návrhu",
        "gates": "Kontrolní brány",
        "kritika-prepis": "Kritika a přepis",
        "rubric-score": "Hodnocení kvality",
        "delivery": "Doručení dokumentu",
        "summary": "Závěr",
        "strategy-contract": "Kontrakt schválené strategie",
        "icp": "Profil ideální zákaznice",
        "design-direction": "Designový směr",
        "photos": "Fotky klienta",
        "brief": "Zadání pro copy",
        "native-round": "Kolo rodilého jazyka",
        "assembly": "Sestavení stránky",
        "screenshots": "Kontrolní náhledy",
        "podpis-designera": "Podpis designéra",
        "soulad-se-strategii": "Soulad se strategií",
        "instance-card": "Karta Buddyho",
        "campaign-shape": "Tvar kampaně",
        "sending-strategy": "Rozesílací strategie",
        "faze": "Fáze kampaně: {name}",
        "instance-soul": "Duše Buddyho",
        "self-improvement-3-kola": "Tři kola sebezlepšení",
        "delivery-doc": "Příprava doručovacího dokumentu",
        "faze-warmup": "Fáze kampaně: rozehřátí",
        "faze-reveal": "Fáze kampaně: odhalení",
        "faze-showup": "Fáze kampaně: účast na vysílání",
        "faze-replay": "Fáze kampaně: záznam",
        "faze-deadline": "Fáze kampaně: uzavření nabídky",
        "faze-downsell": "Fáze kampaně: menší nabídka",
        "faze-trial": "Fáze kampaně: vyzkoušení",
        "faze-onboarding": "Fáze kampaně: onboarding",
        "struktura-timing": "Struktura a časování",
        "sol-brief": "Zadání pro texty",
        "outline": "Scénář vysílání"
      }
    },
    "notes": {
      "composerTitle": "Přidat vlastní poznámku k výstupu",
      "targetLabel": "Vyber výstup...",
      "placeholder": "Co má agent v další verzi změnit...",
      "addNote": "Uložit poznámku",
      "sendToAgent": "Přestavět celý výstup (nová verze)",
      "sentToAgent": "Odesláno agentovi",
      "otherTitle": "Ostatní zpětná vazba",
      "betaTitle": "Podněty k Buddymu",
      "materialsElsewhere": "Tady je fronta podnětů k Buddymu. Připomínky k materiálům ({materials}) patří do kroků těch materiálů.",
      "editWithAlex": "Upravit s Alexem",
      "dismiss": "Není relevantní",
      "delete": "Smazat poznámku",
      "deleteConfirm": "Smazat tuhle poznámku? Vzít zpět to nepůjde. Klient:",
      "anchorsOpen": "Otevřít materiál s ukázanými místy",
      "composerToggle": "Přidat vlastní poznámku",
      "moreActions": "Další akce",
      "openCount": {
        "one": "1 nová",
        "few": "{count} nové",
        "other": "{count} nových"
      },
      "failedShort": "Úprava se nepovedla",
      "retryOpen": "Otevřít a poslat znovu",
      "filterLabel": "Filtr připomínek podle stavu",
      "filter": {
        "all": "Vše",
        "open": "Nové",
        "alex": "U Alexe",
        "handled": "Zapracované"
      },
      "filterEmpty": "Tomuhle filtru neodpovídá žádná připomínka."
    },
    "material": {
      "open": "Otevřít materiál",
      "panelLabel": "Úpravy s Alexem",
      "composerTitle": "Napiš Alexovi, co upravit",
      "placeholder": "Např. Zkrať úvod na polovinu a do ceny doplň splátky...",
      "send": "Poslat Alexovi",
      "hint": "Alex upraví materiál podle tvé zprávy i podle označených připomínek níže. Nová verze se tu objeví sama.",
      "working": "Alex zapracovává připomínky. Nová verze se tu objeví sama.",
      "updated": "Hotovo. Díváš se na novou verzi {version}.",
      "notesTitle": "Připomínky",
      "notesHint": "Alex je při úpravě zapracuje a označí jako vyřízené.",
      "noteState": {
        "new": "Nová",
        "handled": "Zapracováno",
        "sent": "Odeslána Alexovi",
        "working": "Alex pracuje",
        "dismissed": "Nerelevantní"
      },
      "noteHint": {
        "new": "Čeká na tvoje rozhodnutí. Vyber ji pro Alexe, nebo ji uzavři.",
        "sent": "Požadavek je přijatý a čeká na zahájení zpracování.",
        "working": "Alex ji právě zapracovává do nové verze.",
        "handled": "Je uzavřená a zůstává tu pro dohledání.",
        "dismissed": "Uzavřená jako nerelevantní. Zůstává tu pro dohledání."
      },
      "versions": "Verze",
      "oldVersion": "Prohlížíš starší verzi {version}, jen ke čtení.",
      "publishVersion": "Zveřejnit klientovi v{version}",
      "publishBackToCurrent": "Vrať se na aktuální verzi, publikuje se vždy ta.",
      "backToCurrent": "Zpět na aktuální",
      "manageVersions": "Správa verzí a metadat",
      "latestVersion": "Nejnovější",
      "liveVersion": "Klient ji vidí",
      "updatedAt": "Upraveno {time}",
      "inlineContent": "Obsah je uložený přímo v Launchpadu. Žádnou interní adresu nemusíš upravovat.",
      "openPublishedPage": "Otevřít zveřejněnou stránku",
      "saveVersion": "Uložit změny verze",
      "selectHint": "Zaškrtni, co má Alex zapracovat, a pošli to jedním tlačítkem dole.",
      "selectNote": "Zapracovat tuto připomínku",
      "noOpenNotes": "Žádné nové připomínky. Nahraj první níže, nebo počkej na klienta.",
      "resolvedTitle": "Zapracované ({count})",
      "addTitle": "Přidat připomínku",
      "writeNote": "Napsat připomínku textově",
      "messageTitle": "Vzkaz pro Alexe",
      "messageToggle": "Přidat vzkaz pro Alexe",
      "sendMessageOnly": "Poslat Alexovi vzkaz",
      "sendNeeds": "Zatím není co poslat. Vyber aspoň jednu připomínku, nebo napiš Alexovi vzkaz.",
      "sendHint": "Alex vybrané zapracuje do nové verze. Stránka se obnoví sama a zapracované připomínky se označí.",
      "writeShort": "Napsat textově",
      "messageEdit": "Upravit vzkaz pro Alexe",
      "workingShort": "Alex pracuje...",
      "anchorHint": "Ukázat místo ve stránce (klik posune, najetí zvýrazní)",
      "selectAll": "Vybrat vše",
      "selectNone": "Zrušit výběr",
      "sendNotesCount": {
        "one": "Poslat Alexovi 1 připomínku",
        "few": "Poslat Alexovi {count} připomínky",
        "other": "Poslat Alexovi {count} připomínek"
      },
      "sendNotesAndMessageCount": {
        "one": "Poslat Alexovi 1 připomínku a vzkaz",
        "few": "Poslat Alexovi {count} připomínky a vzkaz",
        "other": "Poslat Alexovi {count} připomínek a vzkaz"
      },
      "versionsCount": {
        "one": "{count} verze",
        "few": "{count} verze",
        "other": "{count} verzí"
      },
      "showChanges": "Co se změnilo",
      "updatedShowChanges": "Ukázat, co se změnilo",
      "diffLegend": "Zeleně podbarvené je nové, přeškrtnuté z minulé verze zmizelo.",
      "unpublished": "Nezveřejněná verze v{version}.",
      "clientSees": "Klient vidí v{version}.",
      "clientSeesNothing": "Klient zatím žádnou verzi nevidí.",
      "publish": "Zveřejnit klientovi",
      "publishError": {
        "edit_base_not_live": "Tahle verze vznikla úpravou jiné verze, než kterou teď klient vidí. Pošli připomínky znovu a Alex je zapracuje do aktuální verze."
      },
      "unpublishedChip": "čeká na zveřejnění",
      "queued": "Odesláno Alexovi. Zpracování začne během chvilky.",
      "queuedShort": "Odesláno Alexovi",
      "sentAt": "Odesláno {time}",
      "workingSince": "Alex pracuje od {time}",
      "doneStatus": "Hotovo. Alex zapracoval připomínky do verze {version}.",
      "stuck": "Trvá to déle, než je obvyklé. Požadavek můžeš poslat znovu.",
      "retry": "Poslat znovu",
      "alexQueued": "Připomínky jsou odeslané Alexovi, čekají ve frontě.",
      "alexWorking": "Alex právě zapracovává připomínky do nové verze.",
      "noteExpand": "Zobrazit celé",
      "noteCollapse": "Zkrátit"
    },
    "materials": {
      "title": "Materiály za klienta",
      "hint": "Soubory a odkazy, které nahraješ za klienta. Klient je uvidí v sekci know-how a Alex je použije při tréninku.",
      "scopeKnowhow": "Know-how",
      "scopeLegacy": "Zpětné doplnění",
      "upload": "Nahrát soubor",
      "uploading": "Nahrávám...",
      "addLink": "Přidat odkaz",
      "linkUrl": "https://...",
      "linkLabel": "Název odkazu",
      "note": "Poznámka pro klienta i Alexe",
      "empty": "Zatím žádné materiály.",
      "remove": "Odebrat",
      "confirmRemove": "Opravdu odebrat materiál klienta",
      "fileTypes": "Nahrávky (audio), fotky a PDF do 60 MB. Větší a jiné formáty patří do Drive složky."
    },
    "backfill": {
      "title": "Zpětné doplnění",
      "hint": "Označ hotové sekce a otevři tu, kterou má klient na řadě. Jsou to stavy pod povrchem, ne kroky na klientově ploše: klient v režimu Jen prodej Přípravu Buddyho nevidí ani po doplnění. Profil, Apple účet a zpětná vazba se řídí vlastním stavem.",
      "stepsLabel": "Hotové sekce",
      "step": {
        "onboarding_call": "Úvodní video",
        "q1": "Dotazník k přípravě Buddyho",
        "knowhow": "Know-how",
        "training": "Trénink",
        "beta": "Beta testování a zpětná vazba",
        "marketing_call": "Marketingové video",
        "q2": "Dotazník k prodeji"
      },
      "entry": "Vstupní sekce: {step}",
      "reason": "Důvod doplnění (povinný)",
      "submit": "Doplnit stav",
      "submitting": "Ukládám...",
      "nothing": "Není co doplnit, klient už je dál.",
      "done": "Stav doplněn."
    },
    "adminImports": {
      "title": "Historie importů",
      "hint": "Jedna fronta pro Stripe, dossier i sestavení profilu. Kde jde něco bezpečně zopakovat, najdeš u řádku tlačítko.",
      "loadFailed": "Historii importů se teď nepodařilo načíst.",
      "empty": "Zatím sem nic nepřišlo. Až dorazí první nákup nebo profil, uvidíš ho tady.",
      "emptyFiltered": "Tomuhle filtru neodpovídá žádný záznam.",
      "clearFilters": "Zrušit filtry",
      "unknownSubject": "Bez jména",
      "working": "Pracuji na tom...",
      "actionFailed": "Akce se nepovedla. Zkus to prosím znovu.",
      "attempts": "Pokusů: {count}",
      "openClient": "Otevřít klienta",
      "noClient": "Klient z tohohle řádku nevznikl",
      "retry": "Sestavit profil znovu",
      "retryWorking": "Zakládám nový běh...",
      "retryQueued": "Nový běh profilu je ve frontě: {client}. Až doběhne, uvidíš ho v téhle historii.",
      "retryRunning": "U klienta {client} už jeden běh čeká ve frontě, druhý zakládat nemusíš.",
      "retryFailed": "Opakování se nepodařilo spustit. Zkus to prosím ještě jednou.",
      "filter": {
        "source": "Zdroj",
        "status": "Stav",
        "all": "Vše"
      },
      "summary": {
        "total": "Záznamů: {count}",
        "failed": "Selhalo: {count}",
        "pending": "Probíhá: {count}"
      },
      "source": {
        "stripe": "Stripe",
        "dossier": "Dossier",
        "research": "Sestavení profilu"
      },
      "status": {
        "done": "Hotovo",
        "failed": "Selhalo",
        "pending": "Probíhá",
        "skipped": "Přeskočeno"
      },
      "reason": {
        "noMatch": "Nákup neodpovídá žádnému mapovanému produktu.",
        "switchOff": "Import byl vypnutý, řádek je jen záznam o nákupu.",
        "alreadyClient": "Klient s tímhle e-mailem už v Launchpadu je.",
        "unpaid": "Platba ještě nedoběhla, čeká se na potvrzení ze Stripe.",
        "missingPartner": "Chybí výchozí parťák, komu klienta přiřadit.",
        "metadataFlag": "Klíč launchpad u produktu ve Stripe nemá hodnotu 1.",
        "metadataLabel": "U produktu ve Stripe chybí launchpad_label.",
        "metadataLanguage": "launchpad_language u produktu ve Stripe není cs ani en.",
        "metadataApp": "launchpad_app u produktu ve Stripe není 1 ani 0.",
        "metadataSource": "launchpad_source u produktu ve Stripe není direct, upsell ani webinar.",
        "metadataStart": "launchpad_start u produktu ve Stripe není new ani existing.",
        "metadataProductType": "productType u produktu ve Stripe není start ani empire.",
        "metadataProductLanguage": "language u produktu ve Stripe není cs ani en.",
        "metadataProductApp": "enableMobileApp u produktu ve Stripe není true ani false.",
        "metadataDialectsDisagree": "Produkt ve Stripe nese obě sady metadat a neshodnou se.",
        "missingEmail": "Nákup nemá e-mail zákazníka.",
        "noProducts": "Objednávka nenesla žádnou položku.",
        "profileAlreadyQueued": "Sestavení profilu už u klienta běželo, nový běh se nezakládal.",
        "repeatedPurchase": "Stejná objednávka dorazila znovu.",
        "stripeConnection": "Spojení se Stripe se nepovedlo.",
        "clientCreation": "Založení klienta se nepovedlo.",
        "notEnoughFacts": "Z veřejných zdrojů se sešlo málo faktů.",
        "temporary": "Spojení vypadlo, chyba vypadá dočasně.",
        "dossierImporting": "Import běží a zatím se neuzavřel.",
        "dossierStalled": "Import se nedokončil, běží už přes den.",
        "dossierFailed": "Import dossieru se nedokončil.",
        "dossierSuperseded": "Tuhle verzi nahradila novější.",
        "researchCanceled": "Běh byl zrušený.",
        "profileAccepted": "Převzatý ruční profil nahradil výzkum. Další sestavení není potřeba.",
        "researchAttemptReplaced": "Tento rozpracovaný podklad nahradil novější pokus.",
        "claimExpired": "Poslední pokus se neohlásil v časovém limitu. Před dalším spuštěním prověř běh automatizace.",
        "contextTooLarge": "Výzkum se nevešel do povolené velikosti vstupu.",
        "stalePartner": "Klient vznikl, ale výchozí parťák z nastavení už není aktivní. Přiřaď ho ručně a nastavení oprav.",
        "unknown": "Důvod se nepodařilo přečíst.",
        "metadataPayments": "launchpad_payments u produktu ve Stripe není 1 ani 0.",
        "staleSalesOnlyPartner": "Klient vznikl, ale parťák pro Jen prodej už není aktivní. Zkontroluj přiřazení a nastavení oprav."
      },
      "fix": {
        "addMapping": "Přidej produkt do mapování ve Stripe importu a nákup projde.",
        "enableSwitch": "Zapni hlavní vypínač ve Stripe importu.",
        "setPartner": "Vyber výchozího parťáka ve Stripe importu.",
        "checkStripe": "Zkontroluj klíč ke Stripe a zkus to znovu.",
        "fixMetadata": "Oprav metadata u produktu ve Stripe. Tenhle nákup pak dolož ručním importem ve Stripe importu.",
        "stalledImport": "Sestav profil znovu, vznikne nová verze podkladu.",
        "reduceContext": "Před dalším pokusem zmenši vstupní podklady a načítané instrukce. Stejný vstup opakovaným spuštěním neprojde."
      },
      "configSource": {
        "metadata": "Nastaveno metadaty produktu ve Stripe.",
        "mapping": "Nastaveno mapováním produktů v Launchpadu."
      },
      "created": {
        "kicker": "Hotovo",
        "title": "Klient je založený",
        "named": "Klient {client} je založený",
        "owner": "Vlastník",
        "partner": "Parťák",
        "noPartner": "Zatím bez parťáka",
        "automations": "Co se rozjelo",
        "open": "Otevřít klienta",
        "another": "Založit dalšího",
        "working": "Zakládám klienta...",
        "failed": "Klienta se nepodařilo založit. Formulář zůstal vyplněný, zkus odeslat znovu.",
        "duplicateOwner": "Tuhle adresu už má jiný klient. Otevři jeho kartu, nebo použij jinou adresu. Dva záznamy na jeden e-mail se tiše rozejdou: tým pracuje v jednom, klient vidí druhý.",
        "detailsUnavailable": "Klient vznikl. Detaily o jeho automatizacích se teď nenačetly, najdeš je v detailu klienta."
      },
      "automation": {
        "welcome_mail": "Uvítací e-mail s přihlášením",
        "first_step": "Pozvánka na první krok",
        "profile_research": "Sestavení profilu z veřejných zdrojů",
        "call_links": "Stálé odkazy na hovory",
        "knowhow_drive": "Složka na know-how"
      },
      "automationState": {
        "done": "Hotovo",
        "working": "Běží",
        "waiting": "Čeká",
        "failed": "Selhalo"
      }
    },
    "adminCalls": {
      "title": "Hovory",
      "hint": "Vypiš jeden termín nebo celou sérii a hned zkontroluj, co vzniklo.",
      "timezone": {
        "browser": "Čas podle tohoto zařízení"
      },
      "capacity": "Kapacita",
      "dateTime": {
        "choose": "Vyber",
        "day": "Den",
        "month": "Měsíc",
        "year": "Rok",
        "hour": "Hodina",
        "minute": "Minuta"
      },
      "repeat": {
        "label": "Opakování",
        "weekly": "Opakovat po týdnech",
        "interval": "Každých kolik týdnů",
        "count": "Počet termínů"
      },
      "creating": "Vypisuji termíny...",
      "create": "Vypsat termíny",
      "preview": {
        "kicker": "Před vytvořením",
        "title": "Náhled termínů",
        "empty": "Zvol datum a čas. Tady uvidíš přesné termíny ještě před vytvořením.",
        "seriesNote": "Každý termín dostane vlastní bezpečný kód.",
        "reason": {
          "invalid_date": "Takové datum neexistuje. Vyber jiný den nebo měsíc.",
          "past": "Tenhle termín už byl. Vyber čas v budoucnosti.",
          "invalid_series": "Opakování je mimo rozsah. Interval smí být 1 až 8 týdnů a počet termínů 2 až 16.",
          "missing_url": "Doplň odkaz na hovor. Bez něj nemá termín kam klienty pustit, a vypsat ho nejde."
        },
        "useNextHour": "Použít nejbližší celou hodinu"
      },
      "confirmation": {
        "kicker": "Hotovo",
        "created": "Termín je vypsaný",
        "seriesCreated": "Série termínů je vypsaná",
        "codeOnce": "Kódy se ukazují jen teď. Ulož je na bezpečné místo."
      },
      "links": {
        "kicker": "Odemykání klientů",
        "title": "Stálé odkazy k hovorům",
        "hint": "Vyhledej klienta, otevři jeho odkaz nebo ho jedním kliknutím zkopíruj.",
        "search": "Hledat jméno nebo e-mail",
        "client": "Klient",
        "onboarding": "Úvodní hovor",
        "marketing": "Marketingový hovor",
        "copy": "Zkopírovat odkaz",
        "copied": "Celý odkaz je zkopírovaný.",
        "created": "Oba stálé odkazy jsou vytvořené a připravené ke zkopírování.",
        "missing": "Odkaz ještě nevznikl",
        "empty": "Zatím tu není žádný klient.",
        "noResults": "Tomuto hledání neodpovídá žádný klient.",
        "create": "Vytvořit chybějící odkazy",
        "creating": "Vytvářím odkazy...",
        "error": "Odkazy se nepodařilo načíst nebo změnit. Zkus to znovu.",
        "loadError": "Odkazy se nepodařilo načíst. Zkus to znovu.",
        "saveError": "Chybějící odkazy se nepodařilo vytvořit. Nic se nezměnilo.",
        "copyError": "Odkaz se nepodařilo zkopírovat. Označ ho a zkopíruj ručně."
      },
      "overview": {
        "kicker": "Aktuální stav",
        "title": "Vypsané termíny"
      },
      "tabs": {
        "upcoming": "Nadcházející",
        "past": "Proběhlé"
      },
      "history": {
        "search": "Hledat podle data nebo druhu hovoru",
        "kind": "Druh hovoru",
        "allKinds": "Všechny hovory",
        "period": "Období",
        "last30": "Posledních 30 dní",
        "last90": "Posledních 90 dní",
        "allTime": "Celá historie",
        "loadMore": "Načíst starší termíny"
      },
      "empty": {
        "upcoming": "Není vypsaný žádný nadcházející termín.",
        "past": "Zatím tu není žádný proběhlý termín."
      },
      "enrollment": "Přihlášeno",
      "reservation": "Rezervovali si místo",
      "attended": "Zúčastnili se",
      "watched": "Viděli záznam",
      "noShow": "Bez potvrzené účasti",
      "cancelled": "Zrušeno",
      "full": "Plno",
      "metricsHint": "Rezervace počítají každého přihlášeného klienta i po účasti. Účast vychází z potvrzeného příchodu, použití kódu z historie kódu.",
      "code": {
        "label": "Kód",
        "missing": "Nevydán",
        "scheduled": "Čeká na otevření",
        "ready": "Vydán",
        "expired": "Platnost skončila",
        "inactive": "Neaktivní",
        "used": "Počet použití",
        "lastUsed": "Naposledy použit"
      },
      "series": {
        "label": "Opakování",
        "weekly": "Série",
        "single": "Jednorázově"
      },
      "actions": {
        "open": "Otevřít termín",
        "copyLink": "Zkopírovat odkaz",
        "linkCopied": "Odkaz zkopírován",
        "extend": "Prodloužit sérii",
        "cancelOne": "Zrušit tento termín",
        "cancelFuture": "Zrušit tento a budoucí",
        "createCode": "Vygenerovat kód",
        "revokeCode": "Zneplatnit kód",
        "renewCode": "Vydat nový kód"
      },
      "confirm": {
        "cancelOne": "Zrušit termín {date}? Rezervovaných klientů: {count}. Přihlášky a historie zůstanou uložené, klientům se tím automaticky nenabídne náhradní termín.",
        "cancelFuture": "Zrušit tento termín a všechny další termíny série?"
      },
      "actionDone": "Změna je uložená a seznam je aktuální.",
      "actionWorking": "Provádím změnu...",
      "feedback": {
        "callCancelled": "Termín je zrušený. Přihlášky a historie zůstaly uložené.",
        "futureCancelled": "Tento termín a všechny budoucí termíny série jsou zrušené.",
        "seriesExtended": "Nové termíny jsou přidané do série a zobrazené v seznamu.",
        "codeCreated": "Kód je vytvořený. Jeho hodnota je vidět v potvrzení výše.",
        "codeRevoked": "Kód je zneplatněný. Dosavadní použití zůstala v historii.",
        "codeRenewed": "Starý kód už neplatí. Nová hodnota je vidět v potvrzení výše."
      },
      "error": {
        "create": "Termíny se nepodařilo vytvořit. Zkontroluj údaje a zkus to znovu.",
        "load": "Termíny se nepodařilo načíst.",
        "copy": "Odkaz se nepodařilo zkopírovat. Otevři ho a zkopíruj ručně.",
        "action": "Změnu se nepodařilo uložit. Nic jsme potichu nezměnili."
      },
      "globalUnlock": {
        "kicker": "Odkazy pro klienty",
        "title": "Odkaz na krok hovoru",
        "hint": "Jeden odkaz na každý druh hovoru. Klienta dovede rovnou na jeho krok; ten se otevře až dokoukáním videa, odkaz sám neodemyká nic. Změna platí okamžitě a starý odkaz přestane fungovat.",
        "onboarding": "Úvodní hovor",
        "marketing": "Marketingový hovor",
        "slugLabel": "Heslo v odkazu",
        "slugHint": "Dvě až čtyři slova malými písmeny, oddělená pomlčkou, bez diakritiky a čísel. Třeba zlate-rano.",
        "save": "Uložit",
        "saving": "Ukládám",
        "saved": "Hotovo, platí nový odkaz. Ten starý od téhle chvíle nikam nevede.",
        "copy": "Zkopírovat odkaz",
        "copied": "Odkaz je ve schránce.",
        "lastChange": "Poslední změna",
        "history": "Historie změn",
        "historyEmpty": "Zatím se nic neměnilo.",
        "historyReplaced": "nahradilo",
        "loading": "Načítám odkazy",
        "errorInvalid": "Tohle heslo použít nejde. Dej dvě až čtyři slova malými písmeny, bez čísel a diakritiky.",
        "errorTaken": "Tohle heslo už patří druhému hovoru. Zvol jiné.",
        "errorSave": "Uložení se nepovedlo. Zkus to prosím znovu.",
        "errorLoad": "Odkazy se nepodařilo načíst.",
        "errorCopy": "Zkopírovat se to nepovedlo. Odkaz můžeš označit a zkopírovat ručně.",
        "errorOffline": "Uložení neodešlo. Zkontroluj připojení a zkus to znovu.",
        "neverChanged": "Odkaz se od založení neměnil.",
        "saveIdle": "Nejdřív uprav heslo v odkazu."
      }
    },
    "adminOps": {
      "title": "Živé výroby",
      "hint": "Co právě běží, co spadlo a co je potřeba znovu nakopnout. Každý řádek tě dovede ke klientovi.",
      "openClient": "Otevřít klienta",
      "eta": "Hotovo přibližně v {time}",
      "triggerOff": "Spouštěč výroby tady není nastavený, takže restart by teď nic nespustil.",
      "summary": {
        "running": "běží",
        "stalled": "bez hlášení",
        "failed": "spadlo",
        "awaiting": "čeká na první hlášení"
      },
      "phase": {
        "running": "Běží",
        "stalled": "Bez hlášení",
        "failed": "Spadlo",
        "awaiting_restart": "Znovu spuštěno",
        "restart_silent": "Po restartu ticho",
        "done": "Hotovo"
      },
      "runs": {
        "title": "Výroby, které někdo hlídá",
        "empty": "Nic neběží a nic nespadlo. Výroba je čistá.",
        "emptyFiltered": "Mezi viditelnými záznamy nic neběží ani nespadlo. Testovací klienti jsou skrytí, takže tohle není celý obraz."
      },
      "recent": {
        "title": "Doběhlo za posledních 24 hodin",
        "empty": "Za poslední den nedoběhla žádná výroba."
      },
      "calls": {
        "title": "Hovory kolem teď",
        "hint": "Poslední tři hodiny a nejbližších čtyřiadvacet.",
        "empty": "V tomhle okně není žádný termín.",
        "cancelled": "Zrušeno",
        "open": "Otevřít odkaz"
      },
      "restart": {
        "start": "Spustit výrobu znovu",
        "confirmTitle": "Potvrzení restartu",
        "confirmBody": "Spustím výrobu znovu: {client}, {material}. Hotová práce se nepřepíše, rozjede se nový běh.",
        "confirm": "Ano, spustit",
        "working": "Spouštím výrobu…",
        "resultKicker": "Výsledek",
        "launched": "Výroba znovu běží.",
        "at": "Spuštěno v {time}",
        "nextStep": "První hlášení dorazí do pár minut a řádek se přepne sám.",
        "waiting": "Znovu spuštěno v {time}. Čekáme na první hlášení z výroby.",
        "silent": "Od restartu se výroba neozvala. Spusť ji znovu, nebo se podívej ke klientovi.",
        "retryHint": "Načti přehled znovu a rozhodni se podle aktuálního stavu.",
        "skipped": {
          "deliverable_exists": "Nic jsem nespustil. Materiál už existuje, novou verzi si vyžádej revizí u klienta.",
          "run_active": "Nic jsem nespustil. Jiný běh té samé výroby je pořád aktivní.",
          "command_replayed": "Nic jsem nespustil. Tenhle restart už jednou proběhl."
        }
      },
      "blocked": {
        "running": "Výroba běží. Restart má smysl, až se odmlčí nebo spadne.",
        "awaiting_restart": "Restart už běží. Dej výrobě chvilku na první hlášení.",
        "finished": "Tahle výroba je hotová.",
        "unknown_gate": "Neznámý typ výroby. Restart odsud nespustím."
      },
      "refusal": {
        "run_moved": "Výroba se mezitím pohnula, tak jsem nic nespustil. Podívej se na nový stav.",
        "run_active": "Výroba mezitím naskočila. Restart by ji jen zdvojil.",
        "awaiting_restart": "Restart už běží. Počkej na první hlášení.",
        "finished": "Výroba je hotová, restart tady nedává smysl.",
        "unknown_gate": "Neznámý typ výroby. Restart odsud nespustím.",
        "not_ready": "Klient ještě není v prodejní fázi, výroba nemá z čeho stavět.",
        "prerequisite_missing": "Chybí schválený předchozí materiál. Nejdřív ho nech potvrdit.",
        "trigger_unavailable": "Spouštěč výroby není nastavený. Restart musí proběhnout přímo na stroji.",
        "unknown": "Restart se nepovedl. Načti přehled znovu a zkus to podle aktuálního stavu.",
        "offline": "Požadavek na restart neodešel. Zkontroluj připojení a zkus to znovu; výroba se zatím nezměnila."
      },
      "error": {
        "load": "Provozní přehled se nepodařilo načíst.",
        "stale": "Co vidíš, je poslední úspěšné načtení, ne aktuální stav. Načti přehled znovu, než podle něj něco spustíš.",
        "retry": "Zkus načíst přehled znovu tlačítkem v hlavičce."
      }
    },
    "adminZone": {
      "title": "Správa Launchpadu",
      "lead": "Provoz, klienti, automatiky a lidé. Nástroje, které platí pro celý Launchpad, ne pro jednoho klienta."
    },
    "adminGroup": {
      "operations": {
        "title": "Provoz",
        "lead": "Běží to? Živé výroby, fronta zpráv a přepisy, které se zasekly."
      },
      "clients": {
        "title": "Klienti",
        "lead": "Jak se sem klienti dostávají: ručně, ze Stripu, z importu."
      },
      "automations": {
        "title": "Automatiky",
        "lead": "Co běží samo. Hlavní vypínače, fronty a výchozí obsah."
      },
      "people": {
        "title": "Lidé a historie",
        "lead": "Kdo a co udělal. Tým, jeho přístupy a časová osa změn."
      }
    },
    "openFeedback": "Otevřít podněty klienta",
    "walk": {
      "title": "Mluv a ukazuj",
      "explain": "Nahraj hlasovou připomínku a ukazuj přitom kurzorem (na telefonu prstem) na místa ve stránce. Uloží se do seznamu výše.",
      "start": "Spustit nahrávání",
      "stop": "Zastavit a uložit",
      "cancel": "Zrušit",
      "recInstruction": "Ukazuj, o čem mluvíš. Mikrofon uloží.",
      "sendingNote": "Ukládám připomínku...",
      "sentTitle": "Uloženo",
      "sent": "Připomínka je v seznamu výše. Zaškrtni ji a pošli Alexovi, až budeš mít vybráno.",
      "another": "Nahrát další",
      "error": "Nahrávání se nepovedlo. Zkontroluj mikrofon a zkus to znovu.",
      "empty": "V nahrávce nebyla slyšet žádná řeč. Zkus to znovu.",
      "status": {
        "uploading": "Odesílá se...",
        "transcribing": "Přepisuje se...",
        "done": "Hotovo."
      }
    },
    "daysCount": {
      "one": "{count} den",
      "few": "{count} dny",
      "other": "{count} dní"
    },
    "feedbackCount": {
      "one": "{count} podnět",
      "few": "{count} podněty",
      "other": "{count} podnětů"
    },
    "answerLegacy": "Otázka ze starší verze dotazníku",
    "answers": {
      "kicker": "Výstupy dotazníku",
      "title": "Odpovědi klienta",
      "lead": "{answers} odpovědí, z toho {voice} s nahrávkou. Přepis je hlavní text, nahrávka pod ním je kontrola tónu.",
      "searchLabel": "Hledat v odpovědích",
      "searchPlaceholder": "Hledat v odpovědích",
      "filterLabel": "Výběr odpovědí",
      "filterAll": "Všechny",
      "filterVoice": "Jen hlasové",
      "visible": "Zobrazeno {shown} z {total}",
      "tocLabel": "Obsah odpovědí",
      "noMatch": "Tomuhle hledání a filtru neodpovídá žádná odpověď.",
      "clearFilters": "Zrušit hledání i filtr",
      "unansweredTitle": "Nezodpovězené",
      "unansweredHint": "Tyhle otázky klient nechal prázdné.",
      "legacyChapter": "Ze starší verze dotazníku",
      "voiceTranscribing": "Odpověď je nadiktovaná, přepis ještě běží. Poslechni si nahrávku.",
      "voiceNoSpeech": "V nahrávce jsme nerozpoznali žádnou řeč. Poslechni si ji.",
      "voiceFailed": "Přepis nahrávky se nepovedl. Poslechni si ji.",
      "followUpLabel": "Nahrávka k doplňující otázce",
      "playLabel": "Přehrát nahrávku odpovědi"
    },
    "appWizard": "Podklady pro aplikaci",
    "appWizardSubmitted": "Podklady pro aplikaci odeslané",
    "appWizardProgress": "Rozpracováno, {percent} % hotovo",
    "appWizardEmpty": "Klient zatím nezačal",
    "stepProgressAria": "Postup v {count} krocích",
    "copy": "Zkopírovat",
    "copied": "Zkopírováno",
    "callPhase": {
      "onboarding": "Úvodní video",
      "marketing": "Marketingové video",
      "hint": "Krok se klientovi otevírá videem: v čase odemčení se mu zpřístupní dotazník.",
      "link": "Odkaz na hovor",
      "linkMissing": "Odkaz ještě není připravený",
      "date": "Termín",
      "noDate": "Klient se zatím nepřihlásil",
      "doneNoDate": "Krok je uzavřený bez zapsaného termínu",
      "attendance": "Účast",
      "doneNoEnrollment": "Hovor je uzavřený, zápis přes Launchpad neproběhl"
    },
    "trainingPhase": {
      "reviewStep1": "Otevři si Buddyho a zkus s ním konverzaci jako klient.",
      "reviewStep2": "Projdi, jestli odpovídá věcně a mluví jazykem klienta.",
      "reviewStep3": "Schval krok. Tím se klientovi otevře beta testování a pozvánky pro testery.",
      "reviewBot": "Vyzkoušet Buddyho",
      "approvalByAdmin": "Buddyho zkontroluj a dej vědět týmu. Poslední potvrzení, kterým se klientovi otevře beta, dnes dělá admin.",
      "title": "Trénink Buddyho",
      "running": "Alex trénuje Buddyho z know-how klienta. Trvá to dva až tři pracovní dny, klient dostane e-mail.",
      "blocked": "Trénink neběží. Krok je uzavřený, ale chybí odkaz na bota, takže klient čeká zbytečně.",
      "ready": "Buddy je vytrénovaný a čeká na tvoji kontrolu. Až ho schválíš, otevře se klientovi beta testování.",
      "doneNoBot": "Trénink je uzavřený, odkaz na bota se ale zatím nepropsal.",
      "completionProblem": "Krok je označený jako hotový, ale chybí dohledatelný odkaz na bota. Dokud odkaz nepřibude, krok zůstane zablokovaný.",
      "openBot": "Otevřít bota",
      "locked": "Trénink začne, až klient odešle know-how.",
      "bot": "Bot",
      "systemPrompt": "System prompt",
      "openSystemPrompt": "Otevřít system prompt",
      "openSystemPromptInDetail": "Zobrazit v detailu instance",
      "approveHint": "Až si Buddyho projdeš a budeš s ním spokojený, schval ho. Klientovi se tím otevře beta testování.",
      "approve": "Zkontroloval jsem Buddyho, schválit",
      "approveConfirm": "Schválit a zpřístupnit klientovi",
      "approving": "Schvaluji...",
      "approved": "Schváleno. Klientovi se otevřela beta.",
      "approveReason": "Parťák zkontroloval Buddyho a schválil ho klientovi."
    },
    "trainingRun": {
      "stepOf": "Krok {phase} z {total}: {name}",
      "elapsed": "běží {duration}",
      "runElapsed": "celkem {duration}",
      "lastReport": "poslední zpráva před {duration}",
      "attempt": "{count}. pokus",
      "typical": "obvykle ~{minutes} min",
      "queued": "Stroj se zatím neohlásil. Jakmile začne hlásit průběh, uvidíš tady každý krok tréninku.",
      "timeline": "Průběh tréninku",
      "activity": "Poslední aktivita",
      "doneIn": "Trénink doběhl za {duration}.",
      "phaseFailed": "Krok selhal.",
      "staleTitle": "Trénink se odmlčel.",
      "staleBody": "Poslední zpráva přišla před {minutes} min. Stroj mohl spadnout nebo ztratit spojení.",
      "staleAdvice": "Zkus trénink obnovit. Když se do pár minut neozve, otevři detail instance a podívej se, co se děje.",
      "failedTitle": "Trénink skončil chybou.",
      "failedPhase": "Chyba v kroku {phase}: {name}.",
      "stopped": "Trénink někdo zastavil přímo na stroji. Můžeš ho obnovit, naváže tam, kde skončil.",
      "waitingTitle": "Stroj čeká na vstup.",
      "waitingHint": "Doplnění se dělá v detailu instance, odkaz najdeš na kartě vedle.",
      "resume": "Pokračovat v tréninku",
      "resuming": "Odesílám...",
      "resumeConfirm": "Trénink naváže od kroku, kde skončil. Nic se nemaže ani nezačíná znovu.",
      "resumeGo": "Ano, pokračovat",
      "resumeBack": "Zpět",
      "resumeRequested": "Požadavek odeslán. Čekám, až se stroj ohlásí, obvykle do pár minut.",
      "resumeSilent": "Stroj na poslední požadavek neodpověděl. Zkus to znovu, nebo otevři detail instance.",
      "refusalRunActive": "Trénink právě běží, není co obnovovat.",
      "refusalNotReady": "Trénink teď není ve stavu, kdy by šel obnovit."
    },
    "betaPhase": {
      "title": "Beta testování",
      "transfer": "Vlastnictví bota",
      "transferDone": "Převedeno na klienta",
      "transferPending": "Převod běží",
      "transferNotStarted": "Zatím u nás",
      "transferFailed": "Převod skončil chybou, bot je pořád náš",
      "transferReturned": "Převod selhal, vrácený klientovi k opravě",
      "transferClientFix": "Čeká na opravu u klienta",
      "invites": "Pozvánky pro testery",
      "inviteLimit": "{count} pozvánek",
      "noInvites": "Zatím žádné",
      "completionProblem": "Krok je označený jako hotový, ale chybí převod bota nebo pozvánky testerům. Dokud nepřibudou, krok zůstane zablokovaný."
    },
    "publicationPhase": {
      "title": "Publikace prodejní stránky",
      "hint": "Stránku publikuje klient ze svého účtu. Ty hlídáš, že má co publikovat a že mu chodí platby.",
      "page": "Prodejní stránka",
      "pagePublished": "Klient ji vidí a může publikovat",
      "pagePublishedLocked": "Klient ji vidí, stažení a publikace se odemknou s krokem",
      "pageReady": "Hotová, čeká na tvoje zveřejnění",
      "pageMissing": "Zatím není vyrobená",
      "stripe": "Příjem plateb",
      "stripeDone": "Stripe potvrzený, stažení i publikace jsou odemčené",
      "stripeBlocking": "Dokud Stripe nepotvrdíš, stažení a publikace zůstávají zamčené",
      "lockedHint": "Krok je zatím zamčený. Stránku klient publikuje až po odemčení; ty hlídáš, že bude mít co publikovat.",
      "pageReadyLocked": "Hotová, ale krok je zamčený, klient ji zatím nedostane",
      "stripeDoneLocked": "Stripe potvrzený, stažení a publikace se odemknou s krokem"
    },
    "handoverPhase": {
      "title": "Předání klientovi",
      "hint": "Klient přebírá instanci. Bez jeho Telegram ID a potvrzeného Owner Dashboardu předání nejde dokončit.",
      "telegram": "Telegram klienta",
      "telegramMissing": "Klient ho ještě nevyplnil",
      "myId": "Číslo z /myid",
      "myIdMissing": "Zatím chybí",
      "botOwner": "Bot",
      "botOwnerClient": "Vlastní klient",
      "botOwnerUs": "Zatím u nás",
      "dashboard": "Owner Dashboard",
      "dashboardConfirmed": "Klient potvrdil, že se mu otevřel",
      "dashboardMissing": "Klient ho zatím nepotvrdil",
      "ownerRole": "Role majitele",
      "ownerRoleSet": "Nastavená {date}",
      "ownerRoleMissing": "Zatím nenastavená",
      "ownerRoleHint": "Roli nastavuje automatika hned po odeslání ID. Tohle tlačítko je nouzová ruční cesta pro případ, kdy automatika selže a roli je potřeba nastavit ručně příkazem /setProOwner:ID#bot. Pozor, ten příkaz je převod vlastnictví, náš účet o instanci přijde.",
      "ownerRoleAction": "Potvrdit, že role je nastavená",
      "ownerRoleSending": "Ukládám...",
      "ownerRoleDone": "Potvrzeno. Klientovi se odemkl krok 3 a dostal zprávu.",
      "ownerRoleError": "Potvrzení se nepodařilo uložit. Zkus to prosím znovu.",
      "ownerRoleNeedsId": "Nejdřív potřebujeme Telegram ID od klienta. Bez něj není podle čeho roli nastavit.",
      "ownerRoleJob": {
        "title": "Automatika",
        "pending": "Ve frontě",
        "running": "Probíhá",
        "done": "Hotovo",
        "failed": "Selhalo",
        "attempts": "Pokusů",
        "reason": "Důvod",
        "quote": "Odpověď instance",
        "faultClient": "Vrátili jsme to klientovi k opravě",
        "faultTeam": "Řešíme my"
      }
    },
    "appPhase": {
      "apple": {
        "title": "První kroky k aplikaci",
        "waiting": "Klient ještě nezačal s Apple účtem.",
        "submitted": "Apple účet je odeslaný ke kontrole.",
        "active": "Apple účet je aktivní.",
        "confirmed": "Klient účet potvrdil, Team ID i e-mail máme."
      },
      "questionnaire": {
        "title": "Podklady k aplikaci",
        "waiting": "Klient dotazník k aplikaci ještě nezačal.",
        "progress": "Klient má rozpracované podklady:",
        "submitted": "Klient odeslal všechny podklady k aplikaci.",
        "prefill": {
          "waiting": "Předvyplňujeme podklady z odpovědí klienta.",
          "late": "Předvyplnění podkladů trvá déle než hodinu. Tohle je na nás, klient s tím nic neudělá."
        }
      },
      "release": {
        "title": "Vydání aplikace",
        "waiting": "Vydání čeká na dokončení předchozích kroků a odkazy z obchodů.",
        "live": "Aplikace je vydaná a odkazy jsou dostupné."
      }
    },
    "onDeck": "Na tahu",
    "onDeckWho": {
      "partner": "Já",
      "client": "Klient",
      "alex": "Alex",
      "team": "Tým",
      "assigned": "Tým: {name}"
    },
    "buildRetry": {
      "action": "Spustit výrobu znovu",
      "sent": "Spuštěno, naváže tam, kde skončila",
      "error": "Spuštění se nepodařilo, zkus to za chvíli."
    },
    "adminTeam": {
      "hint": "Vyber člena a uvidíš jeho roli, profil, klienty, poslední práci i přístup na jednom místě.",
      "selectMember": "Vyber člena v seznamu a otevřeš jeho detail.",
      "loadError": "Detail člena se nepodařilo načíst.",
      "error": "Akci se nepodařilo dokončit. Zkus to prosím znovu.",
      "working": "Pracuji na tom.",
      "memberSince": "V týmu od",
      "roleTitle": "Role a stav účtu",
      "selfNote": "Vlastní účet deaktivovat nejde. Požádej jiného administrátora.",
      "heirHint": "Tenhle člen má klientů: {count}. Vyber, kdo je převezme. Bez toho ho deaktivovat nejde.",
      "clientsTitle": "Klienti",
      "clientsEmpty": "Zatím nemá přiřazeného žádného klienta.",
      "openClient": "Otevřít klienta",
      "activityTitle": "Poslední aktivita",
      "activityEmpty": "Zatím žádná zaznamenaná aktivita.",
      "activityNoClient": "bez klienta",
      "accessTitle": "Přístup",
      "activeSessions": "Aktivní přihlášení",
      "revokeSessions": "Odhlásit ze všech zařízení",
      "profileMissingFields": "Klientům se zatím neukáže: {fields}. Doplň to rovnou tady.",
      "profileInvalid": "Některé pole má špatný formát. Odkazy musí začínat https, Telegram ID je jen číslo.",
      "googleAccount": "Google účet",
      "googleAccountHint": "Na tenhle účet sdílíme klientské složky na Disku. Když zůstane prázdný, použije se veřejný e-mail.",
      "telegramUsername": "Telegram jméno",
      "telegramId": "Telegram ID",
      "telegramHint": "ID zjistíš v Telegramu příkazem /myid. Bez něj nejde parťáka přidat do instance klienta.",
      "profileField": {
        "photo": "fotka",
        "calendly": "odkaz na kalendář",
        "publicEmail": "veřejný e-mail"
      },
      "done": {
        "roleAdmin": "{name} je teď administrátor. Vidí celý tým, servis i všechny klienty.",
        "rolePartner": "{name} je teď parťák. Vidí a spravuje jen své klienty.",
        "deactivated": "Účet {name} je deaktivovaný a odhlášený ze všech zařízení. Znovu ho aktivuješ tlačítkem Obnovit.",
        "deactivatedWithHeir": "Účet {name} je deaktivovaný, klienty přebírá {heir}. Zkontroluj u nich rozdělenou práci.",
        "reactivated": "Účet {name} je zase aktivní. Pošli přihlašovací odkaz, ať se dostane dovnitř.",
        "linkSent": "Přihlašovací odkaz pro {name} míří na {email}. Doručení zkontroluješ ve frontě notifikací.",
        "sessionsRevoked": "Všechna přihlášení účtu {name} jsou zrušená. K dalšímu vstupu potřebuje nový odkaz.",
        "profileSaved": "Profil {name} je uložený. Přesně takhle ho uvidí klienti na kartě parťáka.",
        "memberAdded": "{name} je v týmu. Přihlašovací odkaz pošli tlačítkem v detailu.",
        "memberInvited": "{name} je v týmu a přihlašovací odkaz míří na {email}."
      },
      "profileMoved": "Neuloženo. Profil mezitím uložil někdo jiný ({editor}), takže by ho tvoje verze přepsala. Nic se nezměnilo.",
      "profileConflictTitle": "Novější verze profilu",
      "profileConflictBody": "Takhle profil vypadá teď. Načti si ho do formuláře a svoje úpravy do něj dopiš znovu.",
      "profileTakeNewer": "Načíst novější verzi",
      "profileFieldEmpty": "prázdné"
    },
    "adminNotifications": {
      "title": "Notifikační fronta",
      "hint": "Uvidíš, co odešlo, co čeká a co selhalo. U každé zprávy najdeš pokusy o doručení i událost, která ji vyvolala.",
      "working": "Pracuji na tom.",
      "error": "Akci se nepodařilo dokončit. Zkus to prosím znovu.",
      "loadError": "Frontu se nepodařilo načíst.",
      "empty": "V tomhle stavu teď nic není.",
      "allFiltered": "Všechny zprávy v tomhle stavu patří testovacím klientům. Vypni filtr, ať je uvidíš.",
      "selectRow": "Vyber zprávu a uvidíš její pokusy o doručení.",
      "drain": "Odeslat čekající",
      "filterLabel": "Filtr podle stavu",
      "noClient": "bez klienta",
      "noStatus": "bez kódu",
      "noAttempts": "Zatím žádný pokus o doručení.",
      "attemptOk": "bez chyby",
      "attemptCount": "pokusů: {count}",
      "rowScheduled": "odejde {when}",
      "scheduled": "Naplánováno na později: {count}",
      "channel": "Kanál",
      "created": "Vytvořeno",
      "attempts": "Pokusů",
      "sendAt": "Odeslat v",
      "sentAt": "Odesláno",
      "attemptsTitle": "Pokusy o doručení",
      "eventTitle": "Vyvolala událost",
      "eventMissing": "K téhle zprávě se nepodařilo dohledat událost.",
      "retry": "Zkusit odeslat znovu",
      "retryConflict": "Tahle zpráva už není ve stavu selhání. Načti frontu znovu.",
      "skippedHint": "Zprávu zastavilo nastavení příjemce. Opakování ji nepošle, nejdřív se musí změnit předvolby.",
      "filter": {
        "all": "Vše",
        "failed": "Selhalo",
        "queued": "Čeká",
        "sent": "Odesláno",
        "dev_logged": "Testovací schránka",
        "skipped": "Přeskočeno"
      },
      "status": {
        "queued": "Čeká",
        "dev_logged": "Testovací schránka",
        "sent": "Odesláno",
        "failed": "Selhalo",
        "skipped": "Přeskočeno"
      },
      "channelName": {
        "email": "E-mail",
        "push": "Push",
        "both": "E-mail i push"
      },
      "done": {
        "retried": "Zpráva je zpátky ve frontě. Její stav sleduj v seznamu.",
        "drained": "Zpracováno zpráv: {count}. Výsledek uvidíš v seznamu."
      },
      "test": {
        "kicker": "Test doručení",
        "hint": "Zkušební zpráva jde vždycky na tvůj vlastní e-mail. Klienta se nedotkne.",
        "send": "Poslat test",
        "delivered": "Test doručený na {recipient}. Zkontroluj schránku.",
        "skipped": "Test zastavilo tvoje nastavení notifikací. Zapni si kanál v předvolbách a zkus to znovu.",
        "queued": "Test čeká ve frontě. Odešle ho nejbližší běh fronty.",
        "failed": "Test selhal. Detail chyby najdeš u zprávy v seznamu.",
        "sink": "Zpráva skončila ve zkušební schránce, do e-mailu neodešla. Tohle doručení neověřuje; v ostrém provozu ji najdeš u poskytovatele."
      },
      "attemptWhen": "Kdy",
      "attemptChannel": "Kudy",
      "attemptResponse": "Odpověď",
      "attemptResult": "Výsledek",
      "provider": {
        "test_sink": "Zkušební schránka",
        "resend": "Resend",
        "cf_email": "Cloudflare e-mail",
        "web_push": "Push do prohlížeče"
      },
      "recipientLabel": "Příjemce",
      "queueScope": "Celá fronta",
      "pageNote": "Ze seznamu je načteno prvních {loaded} zpráv z {total}. Počítadla nad ním sčítají celou frontu.",
      "reasonLabel": "Důvod",
      "reason": {
        "inbox_only": "Příjemce má nastavené jen upozornění v aplikaci.",
        "channel_off": "Příjemce má tenhle kanál vypnutý.",
        "category_off": "Příjemce má vypnutý tenhle druh zpráv.",
        "no_subscription": "Příjemce nemá zaregistrované žádné zařízení pro push.",
        "no_recipient": "Ke zprávě chybí příjemce.",
        "unsubscribed": "Příjemce se z odběru odhlásil."
      },
      "typeName": {
        "action_required": "Něco čeká na tým",
        "admin_delivery_test": "Test doručení",
        "app_prefill_ready": "Dotazník k aplikaci je předvyplněný",
        "app_wizard_submitted": "Odeslaný průvodce aplikací",
        "bot_transfer_client_fix": "Převod bota: na řadě je klient",
        "bot_transfer_done": "Bot je převedený",
        "bot_transfer_ready": "Převod bota je připravený",
        "bot_transfer_staff_failed": "Převod bota selhal",
        "call_no_show": "Zmeškaný hovor",
        "call_reminder_15m": "Připomínka hovoru: 15 minut předem",
        "call_reminder_3h": "Připomínka hovoru: 3 hodiny předem",
        "call_reminder_day": "Připomínka hovoru: den předem",
        "call_reminder_live": "Hovor právě začíná",
        "deliverable_build_failed": "Výroba materiálu selhala",
        "deliverable_client_note": "Podnět od klienta",
        "client_partner_message": "Zpráva od klienta parťákovi",
        "deliverable_edit_failed": "Úprava materiálu selhala",
        "deliverable_feedback_resolved": "Podnět je zapracovaný",
        "deliverable_partner_review": "Materiál ke kontrole parťákem",
        "deliverable_review": "Materiál ke kontrole klientem",
        "dfy_q2_ready": "Prodejní dotazník je hotový",
        "sales_only_import_summary": "Import klienta dokončen",
        "gate_approved": "Schválený materiál",
        "handover_owner_role": "Správcovství instance",
        "instance_team": "Připojení k týmu instance",
        "knowhow_shared": "Sdílená složka na know-how",
        "order_links_integrated": "Odkazy na objednávku jsou v stránce",
        "owner_role_client_fix": "Správcovství: na řadě je klient",
        "owner_role_staff_failed": "Nastavení správcovství selhalo",
        "partner_assigned": "Parťák je přiřazený",
        "partner_assigned_staff": "Nový klient pro parťáka",
        "partner_message": "Zpráva od parťáka",
        "profile_map_applied": "Změny v profilu jsou zapracované",
        "questionnaire_nudge": "Připomenutí dotazníku",
        "return_magic_link": "Přihlašovací odkaz",
        "login_no_account": "Adresa bez účtu",
        "section_unlocked": "Otevřený krok",
        "staff_override": "Zásah týmu do kroku",
        "system_test": "Systémový test",
        "team_invite": "Pozvánka do týmu klienta",
        "training_failed": "Trénink selhal",
        "training_result": "Výsledek tréninku",
        "training_started": "Trénink začal",
        "transcript_failed": "Přepis selhal",
        "welcome_magic_link": "Uvítací přihlašovací odkaz"
      },
      "typeUnknown": "Neznámý typ zprávy",
      "statusUnknown": "Neznámý stav",
      "filterClient": "Klient",
      "allClients": "Všichni klienti",
      "loadMore": "Načíst starší",
      "loadingMore": "Načítám starší zprávy"
    },
    "activityLog": {
      "title": "Časová osa",
      "hint": "Vyber nástroj, druh události a období. Každý řádek říká, co se stalo, koho se to týká a kudy se k tomu dostaneš.",
      "filterTool": "Nástroj",
      "filterOutcome": "Druh události",
      "filterPeriod": "Období",
      "filterClient": "Klient",
      "allClients": "Všichni klienti",
      "empty": "Pro tenhle filtr tu nic není. Zkus delší období nebo jiný nástroj.",
      "loadError": "Časovou osu se nepodařilo načíst.",
      "loadMore": "Načíst starší",
      "loadingMore": "Načítám starší...",
      "end": "Konec seznamu. Nejstarší zobrazený záznam je z {date}.",
      "tool": {
        "all": "Všechny nástroje",
        "calls": "Hovory a odemykání",
        "team": "Tým",
        "clients": "Klienti a jejich kroky",
        "materials": "Prodejní materiály",
        "profile": "Profil a přepisy",
        "messaging": "Notifikace",
        "imports": "Importy",
        "access": "Přístupy",
        "system": "Systém"
      },
      "outcome": {
        "all": "Vše",
        "error": "Chyby",
        "intervention": "Ruční zásahy",
        "progress": "Běžný postup"
      },
      "period": {
        "0": "Celá historie",
        "1": "Posledních 24 hodin",
        "7": "Posledních 7 dní",
        "30": "Posledních 30 dní"
      }
    },
    "settingsContent": {
      "hint": "Platí pro každého klienta, který nemá vlastní video. Nejdřív uvidíš, koho se změna dotkne.",
      "loadError": "Přehled výchozího obsahu se nepodařilo načíst.",
      "configured": "Nastaveno",
      "notConfigured": "Nenastaveno",
      "updatedAt": "Naposledy změněno",
      "durationUnknown": "Neuvedeno",
      "durationSeconds": "{count} s",
      "durationMinutes": "{count} min",
      "usage": "Uvidí ho klienti bez vlastního videa: {default}. Vlastní video má: {own}. Dokoukalo ho: {done}.",
      "usageNoDefault": "Výchozí video zatím chybí. Vlastní video má {own} z {clients} klientů, ostatní nemají co pustit.",
      "saving": "Ukládám...",
      "savedTitle": "{video} je nastavené: {title}",
      "savedReach": "Uvidí ho klienti bez vlastního videa: {count}.",
      "savedNext": "V detailu klienta na kartě Videa uvidíš, kdo kolik zhlédl.",
      "clearedTitle": "Výchozí video je odebrané.",
      "clearedNext": "Klientům s vlastním videem zůstává jejich. Ostatním se video přestane nabízet.",
      "saveError": "Uložení neprošlo.",
      "saveErrorHint": "Hodnoty zůstaly ve formuláři. Zkontroluj adresu videa a zkus to znovu.",
      "where": {
        "onboarding_video": "Klient ho vidí v kroku Úvodní video. Je to jediná cesta krokem: v čase odemčení otevře dotazník k přípravě Buddyho.",
        "marketing_video": "Klient ho vidí v kroku Marketingové video. Je to jediná cesta krokem: v čase odemčení otevře prodejní dotazník."
      },
      "unlockAtInvalid": "Čas odemčení musí být uvnitř videa a potřebuje vyplněnou délku.",
      "saveNeeds": "Doplň název i odkaz na video, jinak uložit nejde."
    },
    "diagnostics": {
      "loadError": "Diagnostiku se nepodařilo načíst.",
      "transcripts": {
        "title": "Zaseklé přepisy",
        "hint": "Seznam začíná u chyby: čí je soubor, co hlásí přepisovací služba a kolik pokusů proběhlo. Opakování spustíš přímo na řádku.",
        "empty": "Žádný přepis nezůstal viset.",
        "emptyHint": "Až se něco zasekne, objeví se to tady i s důvodem.",
        "state": {
          "error": "Chyba",
          "stalled": "Vypršel zámek"
        },
        "reason": "Důvod: {reason}",
        "reasonUnknown": "Služba důvod nevrátila. Podrobnosti jsou v provozním logu.",
        "attempts": "Pokusů: {count}",
        "retry": "Spustit přepis znovu",
        "retrying": "Spouštím...",
        "doneTitle": "Přepis je zpátky ve frontě.",
        "doneNext": "Hotový text se objeví v profilu klienta. Když spadne znovu, řádek se sem vrátí i s novým důvodem.",
        "failedTitle": "Opakování neprošlo.",
        "failedNext": "Nic se nezměnilo. Načti seznam znovu, stav se mohl mezitím posunout.",
        "stalledHint": "Zámek vypršel, plánovač si soubor vezme sám. Ruční zásah teď nepomůže.",
        "notRetryable": "Soubor se nedostal do úložiště, přepis nemá z čeho vyjít. Klient ho musí nahrát znovu.",
        "offlineTitle": "Spuštění neodešlo",
        "count": "Zaseklých přepisů: {count}",
        "confirmTitle": "Potvrzení opakování",
        "confirmBody": "Spustit přepis znovu: {client}, soubor {file}. Přepisovací služba dostane soubor ještě jednou.",
        "confirm": "Spustit znovu",
        "emptyFiltered": "Mezi viditelnými přepisy nic nevisí.",
        "emptyFilteredHint": "Testovací klienti jsou skrytí, takže tohle není celý obraz. Zobraz i testovací, než panel prohlásíš za čistý."
      },
      "scope": {
        "q1_voice": "Nahrávka k úvodnímu dotazníku",
        "q2_voice": "Nahrávka k marketingovému dotazníku",
        "profile_voice": "Nahrávka k profilu",
        "feedback_audio": "Nahraný podnět",
        "app_voice": "Nahrávka k aplikaci",
        "knowhow_material": "Materiál ke know-how",
        "legacy_material": "Starší materiál",
        "feedback_screenshot": "Snímek k podnětu",
        "proof_screenshot": "Snímek s důkazem",
        "expert_photo": "Fotka experta",
        "ai_avatar": "Avatar",
        "app_asset": "Grafika do aplikace"
      }
    },
    "dossierWizard": {
      "title": "Import dossieru",
      "hint": "Vlož fakta a průvodce je zkontroluje dřív, než cokoli odejde na server. Import běží ve třech krocích, stejně jako z runneru.",
      "currentVersion": "Teď platí verze {version}, faktů {count}, dokončeno {date}.",
      "noVersion": "Klient zatím žádný hotový dossier nemá.",
      "payloadLabel": "Fakta ve formátu JSON",
      "payloadHint": "Čekám pole faktů, nebo objekt s klíčem facts. Každý fakt potřebuje factKey, category a text.",
      "pickFile": "Vybrat soubor",
      "fileUnreadable": "Soubor se nepodařilo přečíst. Vyber ho znovu, nebo jeho obsah vlož do pole výše.",
      "check": "Zkontrolovat data",
      "invalid": "Kontrola našla problémy: {count}",
      "invalidNext": "Nic se neodeslalo. Oprav data a spusť kontrolu znovu.",
      "valid": "Data jsou v pořádku. Faktů: {count}",
      "plan": "Vznikne verze {version}. Nahraje se {facts} {batches}, dosavadní verze zůstane v historii.",
      "import": "Nahrát dossier",
      "pickClientFirst": "Nejdřív vyber klienta.",
      "batchProgress": "Dávka {index} z {total}",
      "doneTitle": "Dossier je nahraný. Verze {version}, faktů {count}.",
      "doneNext": "Profil klienta už čte novou verzi. Zkontroluj ji a případně uprav jednotlivá fakta.",
      "failedSafe": "Nic se nepřepsalo, dosavadní dossier platí dál. Po opravě spusť import znovu, vznikne nová verze.",
      "issue": {
        "emptyInput": "Pole je prázdné. Vlož fakta nebo vyber soubor.",
        "notJson": "Text není platný JSON. Zkontroluj čárky a uvozovky.",
        "notFactList": "Čekám pole faktů, nebo objekt s klíčem facts.",
        "noFacts": "Seznam faktů je prázdný.",
        "notObject": "{position}. položka není objekt.",
        "missingFactKey": "{position}. fakt nemá factKey.",
        "duplicateFactKey": "{position}. fakt má stejný factKey jako dřívější: {value}",
        "badCategory": "{position}. fakt má neznámou kategorii. Povolené jsou: {categories}",
        "missingText": "{position}. fakt nemá text.",
        "badConfidence": "{position}. fakt má confidence v jiném tvaru než číslo.",
        "confidenceRange": "{position}. fakt má confidence mimo rozsah 0 až 1.",
        "badSupersedes": "{position}. fakt má supersedesFactId v jiném tvaru než text."
      },
      "category": {
        "identity": "Identita",
        "business": "Byznys",
        "audience": "Publikum",
        "offer": "Nabídka",
        "voice": "Hlas značky",
        "proof": "Důkazy",
        "other": "Ostatní"
      },
      "step": {
        "reserve": "Založení verze",
        "upload": "Nahrání faktů",
        "finalize": "Ověření a zveřejnění"
      },
      "stepState": {
        "waiting": "Čeká",
        "running": "Probíhá",
        "done": "Hotovo",
        "failed": "Selhalo"
      },
      "error": {
        "invalidRequest": "Server data odmítl jako neplatná.",
        "notFound": "Klient nebo verze neexistuje.",
        "forbidden": "Na tuhle operaci nemáš právo.",
        "stateConflict": "Stav se mezitím změnil, import neproběhl.",
        "idempotency": "Požadavek se rozešel s předchozím pokusem.",
        "batchMismatch": "Dávka nesouhlasí s manifestem.",
        "incomplete": "Server nedostal všechna fakta.",
        "unknown": "Import se nepovedl.",
        "offline": "Data neodešla. Zkontroluj připojení a spusť import znovu; na serveru se nic nezměnilo."
      },
      "checkNeedsFacts": "Vlož fakta, nebo vyber soubor. Prázdná data zkontrolovat nejde.",
      "planFacts": {
        "one": "{count} fakt",
        "few": "{count} fakta",
        "other": "{count} faktů"
      },
      "planBatches": {
        "one": "v {count} dávce",
        "few": "ve {count} dávkách",
        "other": "v {count} dávkách"
      }
    },
    "testFilter": {
      "summary": "Zobrazeno záznamů: {shown}. Skryto testovacích: {hidden}.",
      "showAll": "Zobrazit i testovací"
    },
    "testRowBadge": "testovací",
    "matrixShownTest": {
      "one": "{count} testovací mezi nimi",
      "few": "{count} testovací mezi nimi",
      "other": "{count} testovacích mezi nimi"
    },
    "mutationOffline": "Nepovedlo se to odeslat. Zkontroluj připojení a zkus to znovu.",
    "botTransfer": {
      "title": "Automatické předání bota",
      "enable": "Spouštět převody automaticky",
      "switchHint": "Když je vypínač vypnutý, klientova odeslání se řadí do fronty a Mac Mini je nedostane. Zapnutím se fronta začne zpracovávat.",
      "saved": "Uloženo.",
      "saveFailed": "Nastavení se nepodařilo uložit. Zkus to znovu.",
      "loadFailed": "Frontu převodů se nepodařilo načíst. Zkus to znovu.",
      "waiting": "Ve frontě:",
      "empty": "Žádné převody ve frontě.",
      "openClient": "Otevřít klienta",
      "status": {
        "pending": "Čeká",
        "running": "Probíhá",
        "done": "Hotovo",
        "failed": "Selhalo"
      }
    },
    "adminPanel": {
      "createClient": {
        "lead": "Klient založený ručně dostane vlastníka, parťáka a rozjede stejné automatiky jako nákup přes Stripe."
      },
      "stripe": {
        "lead": "Hlavní vypínač, mapování produktů, události ze Stripu a fronta sestavení profilů."
      },
      "botTransfer": {
        "lead": "Hlavní vypínač automatického předání Telegram bota a fronta převodů."
      },
      "ownerRole": {
        "lead": "Nastavení role majitele instance podle Telegram ID, které klient odeslal v Předání. Hlavní vypínač a posledních 20 běhů."
      }
    },
    "clientLocale": "Jazyk klienta",
    "override": {
      "title": "Klientský stav kroku",
      "hint": "Vrátit klientovi ke schválení, nebo schválit za klienta po společné domluvě na hovoru.",
      "stateApproved": "Potvrzeno klientem",
      "stateApprovedByStaff": "Schváleno parťákem za klienta",
      "stateAwaiting": "Čeká na klienta",
      "reopenButton": "Vrátit klientovi",
      "approveButton": "Schválit za klienta",
      "reopenConfirm": "Vrátit „{item}“ klientovi {client}? Zruší se schválení, klient uvidí důvod a materiál dostane znovu ke komentářům a schválení.",
      "approveConfirm": "Schválit „{item}“ za klienta {client}? V jeho rozhraní se to ukáže jako schválené s poznámkou, že to potvrdil parťák po domluvě.",
      "confirmReopen": "Ano, vrátit",
      "confirmApprove": "Ano, schválit za klienta",
      "reasonLabel": "Důvod (uvidí ho klient)",
      "reasonPlaceholder": "Např. Na hovoru jsme se domluvili na úpravě cen.",
      "reasonRequired": "Napiš důvod, bez něj akce neproběhne.",
      "reopenedNote": "Vráceno parťákem: {reason}",
      "approvedNote": "Schváleno za klienta po domluvě: {reason}",
      "lockedTitle": "Co tu vrátit nejde",
      "error": {
        "override_locked": "Tenhle stav je zamčený, vrátit ho nejde.",
        "override_unavailable": "Tenhle krok nemá klientské schválení, které by šlo vrátit.",
        "reason_required": "Napiš důvod, bez něj akce neproběhne.",
        "required_answers_missing": "Klientovi chybí povinné odpovědi, dotazník teď odeslat nejde.",
        "q1_training_started": "Trénink už běží nebo je hotový, tenhle krok vrátit nejde.",
        "q2_deliverable_exists": "Z prodejního zadání už vznikly materiály, odeslání vrátit nejde.",
        "q2_build_running": "Právě běží výroba materiálů, počkej na její konec.",
        "state_conflict": "Krok je v jiném stavu, než akce čeká. Obnov si detail klienta.",
        "generic": "Akce teď neprošla. Zkus to znovu, nebo obnov detail klienta."
      }
    },
    "botTransferCard": {
      "title": "Automatický převod bota",
      "state": {
        "pending": "Úloha čeká ve frontě, Mac Mini si ji vyzvedne.",
        "running": "Převod právě běží.",
        "done": "Převod proběhl, bota vlastní klient.",
        "failed": "Převod skončil chybou. Bot je pořád náš."
      },
      "bot": "Bot",
      "recipient": "Příjemce",
      "recipientIsBot": "Stejné jméno jako bot. Klient vyplnil jméno bota místo svého.",
      "queued": "Zařazeno",
      "attempts": "Pokusů",
      "finished": "Ukončeno",
      "reason": "Důvod",
      "faultClient": "Opravit to může klient.",
      "faultTeam": "Tohle je na nás.",
      "botfather": "Odpověď BotFathera",
      "transcript": "Zobrazit přepis dialogu",
      "returned": "Vráceno klientovi k opravě: {date}. Důvod: {reason}",
      "returnedClosed": "Vrátit znovu už nejde. Míč je u klienta: jakmile pošle opravený účet, spustí se nový převod.",
      "returnHint": "Klient uvidí pojmenovanou hlášku a znovu formulář na jméno. Jakmile jméno odešle, převod se spustí sám.",
      "returnButton": "Vrátit k opravě",
      "returnConfirm": "Vrátit převod bota klientovi k opravě? Klient: {client}",
      "reasonLabel": "Důvod pro klienta",
      "reasonPlaceholder": "Např. v poli je jméno bota, potřebujeme tvoje uživatelské jméno.",
      "reasonRequired": "Napiš důvod, klient ho uvidí.",
      "returning": "Vracím...",
      "confirmReturn": "Ano, vrátit klientovi",
      "returnDone": "Vráceno klientovi.",
      "error": {
        "generic": "Vrácení se nepovedlo. Zkus to znovu.",
        "no_failed_transfer": "Vrátit jde jen převod, který skončil chybou. Načti klienta znovu.",
        "already_returned": "Tenhle převod je klientovi vrácený už teď. Čeká se na jeho opravu.",
        "transfer_completed": "Bot už změnil majitele, vracet není co.",
        "reason_required": "Napiš důvod, klient ho uvidí.",
        "idempotency_mismatch": "Stejná akce už proběhla s jiným důvodem. Načti klienta znovu.",
        "invalid_request": "Požadavek se nepovedlo zpracovat. Načti klienta znovu.",
        "not_found": "Klient se nenašel. Načti konzoli znovu.",
        "forbidden": "Na tuhle akci nemáš právo.",
        "csrf_invalid": "Přihlášení vypršelo. Načti stránku znovu.",
        "origin_invalid": "Přihlášení vypršelo. Načti stránku znovu.",
        "impersonation_readonly": "V režimu nahlížení za jiného člověka se nedá zapisovat.",
        "state_conflict": "Klient má rozjeté ruční předání bota. Dokonči nebo zruš nejdřív to."
      }
    },
    "ownerRole": {
      "title": "Role majitele automaticky",
      "enable": "Spouštět nastavení role majitele automaticky",
      "switchHint": "Vypnuté: požadavky se dál řadí do fronty, ale runner si je nevyzvedne. Zapni až po zkušebním běhu na Mini.",
      "saved": "Uloženo.",
      "saveFailed": "Uložení se nepovedlo.",
      "loadFailed": "Přehled se nepodařilo načíst.",
      "empty": "Zatím tu žádný běh není.",
      "openClient": "Otevřít klienta",
      "bot": "Bot",
      "reason": "Důvod",
      "quote": "Odpověď instance",
      "attempts": "Pokusů",
      "counts": "Ve frontě {pending}, probíhá {running}, hotovo {done}, selhalo {failed}",
      "status": {
        "pending": "Ve frontě",
        "running": "Probíhá",
        "done": "Hotovo",
        "failed": "Selhalo"
      }
    },
    "appRelease": {
      "state": {
        "draft": "Klient nám dotazník k aplikaci ještě neodeslal.",
        "submitted_for_publishing": "Klient odeslal podklady. Připrav aplikaci do obchodů.",
        "in_publishing": "Aplikaci právě nahráváme do obchodů.",
        "live": "Aplikace je v obchodech. Krok se klientovi uzavřel.",
        "rejected": "Obchod si vyžádal změny. Klient má dotazník zase otevřený.",
        "archived": "Aplikaci jsme z obchodů stáhli."
      },
      "action": {
        "draft": "Vrátit klientovi k úpravám",
        "submitted_for_publishing": "Označit jako odeslané k publikaci",
        "in_publishing": "Začali jsme publikovat",
        "live": "Aplikace je v obchodech",
        "rejected": "Obchod vrátil změny",
        "archived": "Stáhnout z obchodů"
      },
      "error": {
        "release_transition_invalid": "Z tohohle stavu se takhle přejít nedá. Načti si klienta znovu, stav se mezitím posunul.",
        "store_links_required": "Bez odkazů do obchodů to na vydáno přepnout nejde. Doplň odkaz ke každému obchodu, do kterého klient vydává.",
        "app_not_included": "Tenhle klient aplikaci nekoupil, takže není co vydávat.",
        "generic": "Stav se nepovedlo změnit. Zkus to prosím znovu."
      },
      "terminal": "Dál už se tenhle stav nikam neposouvá.",
      "linksHint": "Až aplikace projde do obchodů, doplň odkazy. Stačí ty obchody, do kterých klient vydává.",
      "iosLabel": "Odkaz do App Store",
      "androidLabel": "Odkaz na Google Play",
      "working": "Přepínám..."
    },
    "phaseAge": "{phase}: {age}",
    "sectionAge": "Doba v sekci",
    "testClassification": {
      "title": "Testovací účet",
      "hint": "Označení určuje, zda se účet započítává mezi klienty v týmových přehledech.",
      "currentTest": "Účet se nyní zobrazuje mezi testovacími.",
      "currentReal": "Účet se nyní zobrazuje mezi běžnými klienty.",
      "label": "Zařazení účtu",
      "auto": "Automaticky podle jména a e-mailu",
      "test": "Testovací účet",
      "real": "Běžný klient",
      "filterHint": "Testovací účet najdeš po zapnutí zobrazení testů. Přístup k účtu i jeho historie zůstávají zachované.",
      "loadError": "Zařazení účtu se nepodařilo načíst.",
      "reload": "Načíst znovu",
      "save": "Uložit zařazení",
      "saving": "Ukládám…",
      "saved": "Zařazení je uložené.",
      "saveError": "Zařazení se nepodařilo uložit. Zkus to znovu."
    },
    "paymentsSetup": {
      "title": "Napojení plateb",
      "hint": "Platby nastavuje tým, klient nám dává jen přístup do Stripe. Odškrtávej body, jak je postupně hotové. Klientovi se krok uzavře, až klikneš na Hotovo.",
      "loading": "Načítám stav plateb.",
      "notIncluded": "Tento klient napojení plateb nekoupil. Administrátor ho může zapnout v nastavení klienta.",
      "lockedNote": "Klient krok uvidí po schválení prodejní stránky. Odškrtávat můžeš už teď.",
      "items": {
        "access": {
          "title": "Máme přístup do Stripe klienta",
          "hint": "Pozvánka jako administrátor nebo vývojář, nebo hovor, kde klient propojí Stripe přes /setupStripe."
        },
        "stripe_connected": {
          "title": "Stripe je propojený s Buddym",
          "hint": "Příkaz /setupStripe v Buddym klienta."
        },
        "tariffs": {
          "title": "Tarify podle schválené strategie",
          "hint": "Produkty ve Stripe s metadaty BuddyPro."
        },
        "subscription_url": {
          "title": "Odkaz na předplatné po zkušební době",
          "hint": "Příkaz /setDefaultSubscriptionUrl. client_reference_id se musí přenést až do platby."
        },
        "invites": {
          "title": "Pozvánky",
          "hint": "Příkaz /generateBuddyProInvite."
        },
        "order_links": {
          "title": "Objednávkové odkazy v prodejní stránce",
          "hint": "Každý tarif na prodejní stránce vede na svůj platební odkaz."
        },
        "test_purchase": {
          "title": "Testovací nákup spárovaný s uživatelem",
          "hint": "Nákup proběhl a v Buddym se přiřadil ke správnému uživateli."
        }
      },
      "complete": "Hotovo, platby jsou nastavené",
      "completeNeedsAll": "Nejdřív odškrtni všechny body.",
      "doneLine": "Hotovo: {name}, {date}.",
      "reopen": "Vrátit krok do práce",
      "flagTitle": "Napojení plateb",
      "flagHint": "Zapni, když klient koupil i nastavení plateb. Klientovi přibude krok Napojení plateb hned za prodejní stránkou. Nikomu se nic neposílá.",
      "flagOn": "Zapnuto: klient má krok Napojení plateb.",
      "flagOff": "Vypnuto: klient krok Napojení plateb nemá.",
      "errors": {
        "payments_setup_not_included": "Klient napojení plateb nemá zapnuté.",
        "payments_setup_completed": "Krok je hotový. Pro změnu ho nejdřív vrať do práce.",
        "payments_checklist_incomplete": "Nejdřív odškrtni všechny body.",
        "payments_step_locked": "Klient krok ještě nevidí, prodejní stránka zatím není schválená.",
        "unavailable": "Stav plateb se nepodařilo načíst ani uložit. Zkus to znovu."
      }
    }
  },
  "mail": {
    "loginSubject": "Tvůj přihlašovací odkaz do Launchpadu",
    "noAccountSubject": "K téhle adrese nemáš účet v Launchpadu",
    "noAccountIntro": "Někdo, nejspíš ty, chtěl přihlašovací odkaz do BuddyPro Launchpadu pro tuhle e-mailovou adresu. Žádný účet k ní ale nemáme. Zkus adresu, na kterou ti přišla první pozvánka do Launchpadu. Pokud o odkaz nikdo z vás nežádal, tenhle e-mail klidně ignoruj.",
    "noAccountCta": "Zkusit jiný e-mail",
    "loginIntro": "Klikni na tlačítko a jsi rovnou uvnitř. Odkaz je jen pro tebe, nikomu ho neposílej dál.",
    "loginIntroStart": "Klikni na tlačítko a jsi rovnou uvnitř. Balíček Start je zaplacený a tímhle odkazem se dostaneš do Launchpadu, kde krok za krokem vzniká tvůj Buddy. Odkaz je jen pro tebe, nikomu ho neposílej dál.",
    "loginIntroEmpire": "Klikni na tlačítko a jsi rovnou uvnitř. Balíček Empire je zaplacený a tímhle odkazem se dostaneš do Launchpadu, kde krok za krokem vzniká tvůj Buddy. Odkaz je jen pro tebe, nikomu ho neposílej dál. K Empire patří i přímé telefonní číslo na Davida Říhu: {phone}.",
    "loginCta": "Otevřít Launchpad",
    "inviteSubject": "Máš pozvánku do BuddyPro Launchpadu",
    "inviteIntro": "{name} tě zve do svého Launchpadu ke stavbě Buddyho. Uvidíš rozpracované kroky i hotové materiály a budeš je moct komentovat. Přijmi pozvánku a podívej se, kde to stojí.",
    "inviteIntroNoName": "Máš pozvánku do Launchpadu ke stavbě Buddyho. Uvidíš rozpracované kroky i hotové materiály a budeš je moct komentovat. Přijmi pozvánku a podívej se, kde to stojí.",
    "inviteCta": "Přijmout pozvánku",
    "expires": "Odkaz platí 7 dní. Až vyprší, řekni si o nový na přihlašovací stránce.",
    "sectionSubject": "V Launchpadu se ti otevřel další krok",
    "sectionIntro": "Předchozí část máš za sebou, takže se odemkl další krok. Otevři si ho, najdeš v něm zadání i to, na co navazuje. Dál se bez tebe nepohneme, takže čím dřív se do něj pustíš, tím dřív bude Buddy hotový.",
    "callSubject": "Termín společného hovoru je potvrzený",
    "callIntro": "Máme tě na seznamu. Připomeneme se ráno v den hovoru, tři hodiny předem a pak ještě těsně před startem, takže ti termín neuteče. Připojíš se jedním kliknutím přímo z Launchpadu, nic instalovat nemusíš.",
    "actionSubject": "{client}: čeká úkol pro tým",
    "actionIntro": "Klient udělal svůj krok a teď je řada na nás. Otevři si ho v konzoli, uvidíš, u kterého kroku to stojí a co je potřeba dodělat. Dokud to nikdo nevezme, klient čeká.",
    "transcriptSubject": "{client}: přepis nahrávky potřebuje člověka",
    "transcriptIntro": "Automatický přepis nahrávky neprošel, takže z ní zatím nemáme text. Nahrávku najdeš u klienta v konzoli: pusť si ji, přepiš ji ručně, nebo přepis spusť znovu. Klient o tom neví a počítá s tím, že se s jeho nahrávkou pracuje.",
    "knowhowSharedSubject": "Složka na know-how je připravená",
    "knowhowSharedIntro": "Sdílíme ji s účtem {email}, takže do ní můžeš rovnou nahrávat. Dej do ní všechno, z čeho se má tvůj Buddy učit: PDF, prezentace, přepisy hovorů, odkazy. Čím víc materiálu tam bude, tím přesněji bude odpovídat.",
    "knowhowSharedCta": "Otevřít know-how",
    "brandTag": "Launchpad · upozornění",
    "footer": "BuddyPro Launchpad. Upozornění si nastavíš v Launchpadu v sekci Můj účet.",
    "qNudgeSubject": "Bez tvého dotazníku se nepohneme",
    "qNudgeIntro": "Krok {step} na tebe čeká už pár dní. Z tvých odpovědí stavíme všechno, co přijde potom, takže do té doby stojíme. Nemusíš to stihnout naráz, odpovědi se ukládají průběžně. Kdyby tě něco zaseklo, domluv si s parťákem hovor a projděte to spolu.",
    "qNudgeCta": "Otevřít dotazník",
    "noShowSubject": "Na hovoru jsme se tentokrát minuli",
    "noShowIntro": "Hovor proběhl a tebe jsme tam nezastihli. Nic tím nekončí: záznam ti dáme, jakmile bude hotový, a když potřebuješ probrat něco svého, domluv si s parťákem vlastní termín. Hlavně se pusť do dalšího kroku, ať se tvůj Buddy posune dál.",
    "noShowCta": "Pokračovat dál",
    "dfyQ2ReadyTitle": "{client}: prodejní dotazník je odeslaný",
    "salesImportSummaryTitle": "{client}: import je hotový, klient je v konzoli",
    "salesImportSummaryBody": "Klienta ti do konzole vložil import, takže první kroky jsou hotové bez tebe a jednotlivé zprávy k nim ti schválně nechodily. {summary} Otevři si ho a projdi, co na tebe čeká.",
    "salesImportSummaryDone": "Hotovo: {items}.",
    "salesImportSummaryNothing": "Ke kontrole po něm zatím nic nezůstalo.",
    "salesImportSummaryMaterials": {
      "one": "{count} materiál ke kontrole",
      "few": "{count} materiály ke kontrole",
      "other": "{count} materiálů ke kontrole"
    },
    "salesImportSummaryQuestionnaire": "odeslaný prodejní dotazník",
    "salesImportSummaryStrategy": "schválená strategie",
    "dfyQ2ReadyBody": "Výroba návrhu prodejní strategie se spustila sama, nemusíš nic pouštět. Napíšeme ti, jakmile bude první verze hotová a připravená ke kontrole. Zatím se můžeš podívat, co klient v dotazníku napsal, ať tě obsah nepřekvapí.",
    "dfyDeliverableReadyTitle": "{client}: nový materiál ke kontrole, {deliverableTitle}",
    "dfyDeliverableReadyBody": "Ke kontrole je tenhle materiál: {deliverableTitle}. Projdi ho a buď ho zveřejni klientovi, nebo ho pošli Alexovi na přepracování. Dokud ho nezveřejníš, klient ho nevidí.",
    "dfyOpenClient": "Otevřít podklady klienta",
    "brandTagPlain": "Launchpad",
    "footerPlain": "BuddyPro Launchpad.",
    "clientNoteTitle": "{client}: nové připomínky od klienta, {material}",
    "clientNoteBody": "Klient napsal poznámky k tomuhle materiálu: {material}. Projdi je a pošli je Alexovi k zapracování, ať se to nezastaví. Klient zatím čeká na novou verzi.",
    "clientMessageTitle": "{client} ti píše z Launchpadu",
    "clientMessageBody": "Klient ti poslal zprávu přes tlačítko u své karty parťáka. Stačí odpovědět na tento e-mail, odpověď půjde přímo klientovi na {email}.",
    "buildFailedTitle": "{client}: výroba se zastavila, {material}",
    "buildFailedBody": "Výroba spadla na chybě a materiál z ní nevzešel: {material}. Otevři klienta v konzoli a pusť výrobu znovu, většinou projde napodruhé. Klient o zádrhelu neví a čeká, takže čím dřív ji pustíš, tím líp.",
    "editFailedTitle": "{client}: úprava se nepovedla ({material})",
    "editFailedBody": "Úprava neproběhla: {material}. Materiál zůstal beze změny v poslední verzi. Otevři klienta a pošli tu samou úpravu znovu. Výrobu materiálu nespouštěj, hotovou verzi bys tím zahodil.",
    "orderLinksFailedTitle": "{client}: odkazy na objednávku se nevložily",
    "orderLinksFailedBody": "Vložení objednávkových odkazů do prodejní stránky neproběhlo. Stránka zůstala beze změny ve schválené verzi a odkazy jsou pořád uložené. Otevři klienta a pošli vložení odkazů znovu. Novou prodejní stránku nevyráběj, schválenou verzi bys tím zahodil.",
    "botTransferDoneSubject": "Bot je tvůj, pozvi testery",
    "botTransferDoneIntro": "Převod je hotový, bot od teď sedí na tvém Telegram účtu a nikdo jiný k němu nemá přístup. V Launchpadu se ti otevřel krok Pozvi testery: rozešli odkaz lidem, kterým může být Buddy užitečný, a nech si od nich napsat, co jim v odpovědích chybí. Jejich podněty jsou to nejcennější, co teď můžeš získat.",
    "botTransferDoneCta": "Otevřít beta testování",
    "botTransferFailedTitle": "{client}: převod bota se nepovedl",
    "botTransferFailedIntro": "Automatický převod Telegram bota neprošel z tohoto důvodu: {reason}. Klient o tom neví, dál vidí jen to, že na převodu pracujeme, takže se to samo nevyřeší. Otevři klienta v konzoli, přečti si přepis a rozhodni, jestli převod pustit znovu, nebo krok vrátit klientovi k opravě.",
    "partnerAssignedSubject": "Tvůj parťák je tu: {partner}",
    "partnerAssignedIntro": "{partner} tě provede celým procesem, od prvního kroku až po spuštění. Kdykoli budeš něco potřebovat, napiš nebo si rovnou rezervuj hovor. Kontakt najdeš v pravém sloupci dashboardu.",
    "partnerAssignedStaffTitle": "{client}: nový klient pro tebe",
    "partnerAssignedStaffBody": "{admin} ti právě přidělil tohoto klienta, takže od teď je na tobě. V konzoli najdeš profil klienta, koupený produkt i krok, ve kterém právě je. Klient dostal e-mail s tvým jménem, takže se ti může ozvat hned.",
    "partnerAssignedStaffAdminFallback": "Administrátor",
    "botTransferReason": {
      "recipient_not_started": "příjemce zatím botovi na Telegramu nenapsal",
      "recipient_not_found": "účet příjemce se na Telegramu nenašel",
      "recipient_bot_limit": "příjemce má na svém účtu plný počet botů a musí si uvolnit místo",
      "recipient_invalid_target": "zadané jméno nepatří osobnímu účtu, ale botovi nebo kanálu",
      "floodwait": "Telegram nás dočasně omezil (FloodWait)",
      "twofa_too_fresh": "dvoufázové ověření účtu je mladší než 7 dní",
      "gate_mismatch": "potvrzovací zpráva BotFathera neodpovídala botovi nebo příjemci",
      "bot_not_found": "bot se nenašel v /mybots",
      "session_unavailable": "Telegram session nebyla dostupná",
      "verification_unavailable": "potvrzení odešlo, ale nešlo ověřit, jestli bot opravdu změnil majitele. Zkontroluj /mybots našeho účtu ručně, než to pustíš znovu",
      "unknown": "neznámá chyba, detaily jsou v přepisu"
    },
    "dfyDeliverableRevisedTitle": "{client}: nová verze po připomínkách, {deliverableTitle}",
    "dfyDeliverableRevisedBody": "Alex zapracoval připomínky a verze {version} je hotová: {deliverableTitle}. Projdi ji a zveřejni ji klientovi, nebo pošli další kolo poznámek. Klient zatím pořád vidí předchozí verzi.",
    "gateApprovedTitle": "{client}: potvrzeno, výroba pokračuje, {material}",
    "gateApprovedBody": "Klient potvrdil verzi {version} tohoto materiálu: {material}. Další krok výroby se spustil sám, nemusíš nic dělat. Napíšeme ti, až z něj vypadne první verze.",
    "gateApprovedPush": "Verze {version} je potvrzená, další krok výroby už běží.",
    "trainingReadyTitle": "{client}: instance je vytrénovaná",
    "trainingReadyBody": "Instance Creator dotrénoval Buddyho{botSuffix} a instance je připravená. Prohodit s ním pár otázek trvá minutu a je to poslední kontrola, než ho uvidí klient. Až ji schválíš v konzoli, otevře se klientovi beta testování.",
    "trainingReadyBotSuffix": " (bot @{bot})",
    "trainingReadyPush": "Zkontroluj instanci a schval ji v konzoli.",
    "appWizardSubmittedTitle": "{client}: podklady pro mobilní aplikaci",
    "appWizardSubmittedBody": "Klient vyplnil a odeslal všechno, co aplikace potřebuje: texty, ikonu i obrázky do obchodu. Projdi je v konzoli, jestli obstojí u schvalování v Applu, a předej je do publikace. Když něco chybí, vrať to klientovi s poznámkou, co doplnit.",
    "appWizardSubmittedPush": "Podklady pro aplikaci jsou odeslané. Zkontroluj je v konzoli.",
    "appPrefillReadySubject": "Dotazník k aplikaci je předvyplněný",
    "appPrefillReadyIntro": "Prošli jsme tvoje odpovědi, schválenou strategii i prodejní stránku a vyplnili z nich většinu dotazníku k mobilní aplikaci. Zbývá to po nás přečíst, opravit, co sedí jinak, a doplnit obrázky do obchodu. Až nám dotazník odešleš, připravíme aplikaci k vydání.",
    "appPrefillReadyCta": "Otevřít dotazník k aplikaci",
    "instanceTeamDoneTitle": "{client}: jsi v týmu instance @{bot}",
    "instanceTeamDoneBody": "Přidali jsme tě do týmu instance @{bot} s právy správce. Můžeš rovnou upravovat systémový prompt, doplňovat know-how a zkoušet, jak Buddy odpovídá.",
    "instanceTeamDonePush": "Instance je připravená ke správě.",
    "instanceTeamFailedTitle": "{client}: přidání do týmu @{bot} se nepovedlo",
    "instanceTeamFailedBody": "Do týmu instance @{bot} se tě nepodařilo přidat{noteSuffix}. Nejčastější příčina je, že tvůj Telegram účet botovi zatím nenapsal: pošli mu jednu zprávu a zkus to znovu z konzole. Bez členství v týmu instanci nespravuješ.",
    "instanceTeamFailedPush": "Zkus to prosím znovu z konzole.",
    "instanceTeamNoteSuffix": " ({note})",
    "openClientConsole": "Otevřít klienta v konzoli",
    "callReminder": {
      "day": {
        "cta": "Otevřít Launchpad",
        "intro": "Dnes v {time} se potkáme na společném hovoru. Připojíš se jedním kliknutím z Launchpadu, nic instalovat nemusíš. Kdyby ti termín přestal vycházet, přesuň si ho tam na jiný.",
        "subject": "Dnes v {time} máš hovor s parťákem"
      },
      "h3": {
        "cta": "Otevřít Launchpad",
        "intro": "Sejdeme se dnes v {time}. Připrav si otázky, na které chceš odpovědi, ať z hovoru vytěžíš maximum. Kdyby ti termín přestal vycházet, přesuň si ho v Launchpadu na jiný.",
        "subject": "Za tři hodiny začíná hovor"
      },
      "m15": {
        "cta": "Otevřít Launchpad",
        "intro": "Začínáme v {time}, takže je čas se usadit. Otevři si Launchpad a připoj se jedním kliknutím, jakmile spustíme.",
        "subject": "Za chvíli začínáme, v {time}"
      },
      "live": {
        "cta": "Připojit se k hovoru",
        "intro": "Jsme uvnitř a čekáme na tebe. Připoj se jedním kliknutím, to podstatné teprve přijde.",
        "subject": "Hovor právě probíhá"
      }
    },
    "staffReopenedSubject": "Vráceno k dopracování: {material}",
    "staffReopenedBody": "Poznámka od parťáka zní takhle: {reason}. Krok je zase otevřený, takže můžeš doplnit, co chybí, přidat komentáře a potom to znovu schválit. Nic se neztratilo, všechny předchozí připomínky tam zůstaly.",
    "openLaunchpad": "Otevřít Launchpad",
    "staffApprovedSubject": "Schváleno po domluvě: {material}",
    "staffApprovedBody": "Parťák krok schválil za tebe, přesně jak jste se spolu domluvili, takže ho máš z krku. V poznámce k tomu stojí: {reason}. Dělat už nemusíš nic, materiál se posunul dál sám.",
    "botTransferFailedQuote": "BotFather odpověděl: „{message}“",
    "botTransferFixSubject": "Převod bota čeká na opravu jména",
    "botTransferFixIntro": "Převod se nepovedl z tohoto důvodu: {detail}. Otevři v Launchpadu krok Beta testování, oprav jméno účtu a odešli ho znovu. Převod pak spustíme sami a dáme ti vědět, jakmile bude bot tvůj.",
    "botTransferFixCta": "Otevřít beta testování",
    "sectionSubjectNamed": "Otevřel se ti krok {step}",
    "sectionIntroNamed": "Krok {step} je připravený a čeká jen na tebe. Najdeš v něm zadání i to, na co navazuje. Dál se bez tebe nepohneme, takže čím dřív se do něj pustíš, tím dřív bude Buddy hotový.",
    "sectionCta": "Otevřít krok",
    "callCta": "Otevřít Launchpad",
    "deliverableReviewSubject": "{material}: verze {version} je připravená ke kontrole",
    "deliverableReviewIntro": "Nová verze je v Launchpadu. Projdi si ji a buď ji potvrď, nebo rovnou do textu připiš, co chceš jinak. Připomínky čteme všechny a zapracujeme je do další verze.",
    "deliverableResolvedSubject": "{material}: všechny připomínky jsou zapracované",
    "deliverableResolvedIntro": "Nová verze obsahuje všechny tvoje připomínky, jednu po druhé. Projdi si ji a materiál odsouhlas, nebo přidej další poznámky, když ještě něco skřípe.",
    "deliverableOpenCta": "Otevřít materiál",
    "orderLinksSubject": "Odkazy na objednávku jsou v tvé prodejní stránce",
    "orderLinksIntro": "Tlačítka na stránce teď vedou na tvoje objednávkové odkazy, u každého tarifu ten jeho. Tím se odemklo stažení stránky i publikace, takže ji můžeš pustit ven, kdy budeš chtít. Než to uděláš, klikni si na každé tlačítko a zkontroluj, že vede tam, kam má.",
    "orderLinksCta": "Otevřít prodejní stránku",
    "orderLinksPush": "Stránku si teď můžeš stáhnout i publikovat.",
    "botTransferReadySubject": "Tvůj Telegram bot čeká na převzetí",
    "botTransferReadyIntro": "Bota máme připraveného k převodu, teď je řada na tobě. V Telegramu ti od BotFathera přijde potvrzení, které stačí odsouhlasit, a bot je tvůj. Pak se vrať do Launchpadu a potvrď to i tam, ať se ti otevřou testeři.",
    "botTransferReadyCta": "Otevřít beta testování",
    "trainingStartedTitle": "{client}: trénink Buddyho začal",
    "trainingStartedBody": "Klient odeslal know-how a Alex začal stavět jeho Buddyho. Trvá to dva až tři pracovní dny. Až bude hotový, ozvu se ti ke kontrole.",
    "trainingStartedPush": "Alex staví Buddyho. Ozvu se, až bude ke kontrole.",
    "trainingFailedTitle": "{client}: trénink Buddyho se zastavil",
    "trainingFailedBody": "Stavba Buddyho skončila chybou a sama už nepokračuje. Otevři klienta v konzoli a domluv se s týmem, jak dál.",
    "trainingFailedPush": "Stavba Buddyho skončila chybou a potřebuje člověka.",
    "handoverOwnerRoleSubject": "Roli majitele máš nastavenou",
    "handoverOwnerRoleBody": "Role majitele je nastavená, takže ti bot teď vydá propojovací kód. V Předání dokonči krok 3: pošli botovi /connectWeb, vlož kód do dashboardu a potvrď, že vidíš svou instanci.",
    "ownerRoleFixSubject": "Potřebujeme jiné Telegram ID",
    "ownerRoleFixIntro": "Roli majitele se nepodařilo nastavit: {detail}. V Předání to můžeš rovnou opravit.",
    "ownerRoleFixCta": "Otevřít předání",
    "ownerRoleFailedTitle": "{client}: role majitele se nenastavila",
    "ownerRoleFailedIntro": "Automatika roli majitele nenastavila. Důvod: {reason}.",
    "ownerRoleFailedQuote": "Instance odpověděla: „{message}“"
  },
  "impersonation": {
    "viewingAs": "Díváš se jako klient {client}",
    "role": {
      "partner": "Parťák",
      "admin": "Administrátor"
    },
    "mode": {
      "look": "Jen koukám",
      "act": "Můžu jednat"
    },
    "switchToAct": "Chci za klienta i jednat",
    "switchToLook": "Zpátky na jen koukám",
    "remaining": "Zbývá {minutes} min",
    "exit": "Zpět do konzole",
    "exiting": "Vracím se...",
    "modeFailed": "Režim se nepodařilo přepnout. Zkus to ještě jednou.",
    "endFailed": "Návrat do konzole se nepovedl. Zkus to prosím ještě jednou.",
    "consoleLost": "Hodina náhledu skončila a konzole se mezitím odhlásila. Přihlas se prosím znovu.",
    "refusal": {
      "looking": "Jsi v režimu jen koukám, takže se nic neuloží.",
      "handover": "Předání instance dělá klient sám: bot i jeho klíče opravdu mění majitele.",
      "publish": "Publikaci na svůj web spouští klient sám.",
      "payments": "Kolem plateb za klienta nejednáme.",
      "other": "Tenhle úkon je za klienta zavřený."
    }
  },
  "steps": {
    "eyebrow": "Začni tady",
    "title": "Co můžeš udělat hned",
    "step1Title": "Domluv si úvodní hovor",
    "step1Copy": "Ukážeme ti celý postup a řekneme, co od tebe budeme potřebovat.",
    "step2Title": "Upřesni, co o tobě víme",
    "step2Copy": "Podívej se na profil, který jsme připravili z veřejných zdrojů. Doplň, co chybí, a oprav, co nesedí.",
    "step3Title": "Založ si vývojářský účet Apple",
    "step3Copy": "Apple obvykle aktivuje účet do 48 hodin, proto začni hned. Návod tě provede celým postupem.",
    "step3Guide": "Otevřít návod k účtu",
    "step4Title": "Přizvi někoho z týmu",
    "step4Copy": "Chceš přípravu někomu předat? Zadej e-mail pozvané osoby. Pak s námi může komunikovat a převzít tvorbu tvého Buddyho.",
    "lead": "Tohle je na tobě. O všechno ostatní, bota, licenci, trénink i texty, se staráme my za tebe."
  },
  "appGuide": {
    "title": "Jak založit vývojářský účet Apple",
    "intro": "Účet musí založit jeho budoucí majitel. Apple si po registraci ověří firmu, obvykle za 1 až 2 pracovní dny.",
    "step1": "Na developer.apple.com se registruj jako organizace, aby aplikace vyšla pod jménem tvojí firmy. Jednotlivce zvol, jen když firmu nemáš.",
    "step2": "Přihlas se pomocí Apple ID se zapnutým dvoufaktorovým ověřováním. Použij právní jméno, skutečnou adresu bez P.O. boxu, e-mail a telefon.",
    "step3": "U firmy připrav platné D-U-N-S, právní název, pracovní e-mail na firemní doméně, funkční web a oprávnění podepisovat za firmu.",
    "step4": "Odešli žádost na developer.apple.com/programs/enroll nebo v aplikaci Apple Developer a sleduj e-mail od Apple. Někdy si detaily ověří telefonicky.",
    "step5": "Po schválení odsouhlas licenci a zaplať 99 USD za rok v místní měně. Potom se otevře App Store Connect.",
    "done": "Potvrdit podání žádosti"
  },
  "testbar": {
    "label": "Testovací režim",
    "prev": "Předchozí",
    "next": "Další",
    "exit": "Vypnout"
  },
  "homeSteps": {
    "beforeCall": "Toto můžeš udělat mezitím",
    "afterCall": "Další části, které máš k dispozici",
    "completedHistory": "Hotové kroky",
    "completedHistoryCount": {
      "one": "{count} hotový",
      "few": "{count} hotové",
      "other": "{count} hotových"
    },
    "call": {
      "title": "Přehraj si úvodní video",
      "videoCopy": "Než začneme, přehraj si úvodní video. Dozvíš se, jak bude spolupráce probíhat, a na konci se ti otevře další krok.",
      "completedCopy": "Úvod máš za sebou.",
      "nextAlreadyOpen": "Další krok už máš otevřený: {step}.",
      "connect": "Připojit se k hovoru",
      "calendar": "Uložit do kalendáře",
      "countdownLabel": "Do hovoru zbývá",
      "nextWeek": "Rezervovat místo na příštím termínu",
      "enrolledNext": "Náhradní termín máš rezervovaný."
    },
    "profile": {
      "title": "Pomoz nám poznat tě přesněji",
      "copy": "Z veřejných zdrojů jsme připravili tvůj profil a značku jako základ pro přípravu Buddyho. Některé informace ale můžou být zastaralé nebo se týkat jiných projektů. Potřebujeme proto vědět, co v kontextu Buddyho platí a co ne.",
      "cta": "Zobrazit a doplnit profil",
      "completedCopy": "Profil je potvrzený a parťák z něj vychází při přípravě.",
      "open": "Zobrazit potvrzený profil"
    },
    "apple": {
      "title": "Příprava pro publikování tvojí mobilní aplikace",
      "copy": "Zařiď to ještě tento týden. Účet si zakládáš jako firmu na developer.apple.com a stojí 99 USD ročně. Apple pak firmu ověřuje, obvykle 1 až 2 pracovní dny. Celým postupem tě provedeme krok za krokem, všechno ostatní uděláme za tebe.",
      "cta": "Otevřít návod k účtu",
      "short": "Mobilní aplikace"
    }
  },
  "invite": {
    "question": "Chceš přípravu Buddyho někomu předat? Zadej e-mail a pošli pozvánku do Launchpadu.",
    "accessTitle": "Přidej spolupracovníka",
    "accessCopy": "Pozvaný člověk uvidí profil, odpovědi a společné podklady. Může ti pomoct s přípravou, ale ty o svůj přístup nepřijdeš. Čekající pozvánku můžeš kdykoliv zrušit.",
    "accessPending": "Přístup zatím nemá. Pozvánku můžeš zrušit.",
    "accessAccepted": "Má přístup ke společným podkladům. Tvůj přístup zůstává beze změny.",
    "emailPlaceholder": "jmeno@firma.cz",
    "button": "Poslat pozvánku",
    "sent": "Pozvánku jsme odeslali.",
    "emailLabel": "E-mail pozvané osoby",
    "error": "Pozvánku se nepodařilo odeslat. Zkus to prosím znovu.",
    "pendingTitle": "Odeslané pozvánky",
    "statePending": "Čeká na přijetí",
    "stateAccepted": "Přijato",
    "revoke": "Zrušit pozvánku",
    "devLink": "Testovací prostředí: e-mail se neodesílá. Pošli pozvané osobě tento odkaz:"
  },
  "notifications": {
    "eyebrow": "Nastavení",
    "title": "Upozornění",
    "pushDeviceTitle": "Push na tomto zařízení",
    "pushOn": "Upozornění na tomto zařízení jsou zapnutá.",
    "pushOff": "Tohle zařízení zatím upozornění nedostává.",
    "pushDenied": "Prohlížeč má upozornění zablokovaná.",
    "pushDeniedHint": "Povol upozornění v nastavení prohlížeče a pak to zkus znovu.",
    "pushUnsupported": "Tenhle prohlížeč push upozornění nepodporuje.",
    "pushEnable": "Zapnout upozornění",
    "pushDisable": "Vypnout na tomto zařízení",
    "pushIosInstall": "Na iPhonu si nejdřív přidej Launchpad na plochu (Sdílet, Přidat na plochu). Upozornění pak zapneš tady.",
    "pushKindsLegend": "Co posílat na tohle zařízení",
    "emailTitle": "E-mailová upozornění",
    "emailMaster": "Posílat e-mailová upozornění",
    "emailKindsLegend": "Které e-maily chceš dostávat",
    "kind": {
      "call": "Hovory a termíny",
      "step": "Nové kroky",
      "delivery": "Dodávky a výstupy",
      "system": "Systémové zprávy"
    },
    "criticalNote": "Přihlašovací odkazy a pozvánky chodí vždy, ty vypnout nejdou.",
    "error": "Uložení se nepovedlo. Zkus to prosím znovu.",
    "inbox": {
      "open": "Otevřít upozornění",
      "eyebrow": "Aktuální přehled",
      "title": "Upozornění",
      "unreadCount": "Nepřečtená upozornění: {count}",
      "unread": "Nepřečteno",
      "readAll": "Označit vše jako přečtené",
      "close": "Zavřít upozornění",
      "toastLabel": "Nové upozornění",
      "toastClose": "Zavřít toto upozornění",
      "toastOpen": "Otevřít",
      "loading": "Načítám upozornění...",
      "empty": "Nic nového. Jakmile se něco pohne, najdeš to tady.",
      "error": "Upozornění se teď nepodařilo načíst.",
      "errorSeverity": "Chyba",
      "confirmSending": "Potvrzuji...",
      "confirmError": "Potvrzení se nepodařilo. Zkus to znovu.",
      "groupCount": "Sloučeno {count} stejných oznámení",
      "stepUnlocked": "Otevřel se ti nový krok",
      "stepUnlockedBody": "Můžeš pokračovat: {step}.",
      "reviewTitle": "{document} - verze {version} ke kontrole",
      "reviewTitleLegacy": "{document} ke kontrole",
      "staffReviewTitle": "{client}: {document} - verze {version} ke kontrole",
      "staffReviewTitleLegacy": "{client}: {document} ke kontrole",
      "reviewBody": "Projdi změny a dokument potvrď, nebo přidej připomínky.",
      "clientConfirmedTitle": "{client}: materiál je potvrzený",
      "clientConfirmedKindTitle": "{client}: potvrzeno, {document}",
      "clientConfirmedBody": "Materiál je potvrzený klientem. Navazující výroba se spustila automaticky.",
      "unknownMaterialTitle": "{client}: neznámý materiál potřebuje kontrolu",
      "unknownMaterialBody": "Notifikace nemá platný název materiálu. Otevři detail klienta a ověř zdroj, než cokoli zveřejníš.",
      "deliverable": {
        "strategy": "Návrh prodejní strategie",
        "salespage": "Prodejní stránka",
        "emails": "E-maily",
        "webinar": "Struktura webináře",
        "avatar": "Avatar"
      }
    },
    "confirm": {
      "apple": {
        "title": "Máš už Apple Developer účet?",
        "body": "Pokud už je účet založený, potvrď to tady. Přestaneme ti ho připomínat.",
        "primaryAction": "Založit účet",
        "action": "Už mám založeno"
      },
      "profile": {
        "title": "Potvrdíš nám svůj profil?",
        "body": "{{g:Nahrál|Nahrála}} jsi úpravy profilu. Projdi si výsledek a potvrď, že sedí.",
        "primaryAction": "Zkontrolovat profil",
        "action": "Profil je v pořádku"
      }
    },
    "testSubject": "Zkušební upozornění z Launchpadu",
    "testIntro": "Tohle je zkušební zpráva, žádná akce se od tebe nečeká. Když dorazila, doručování e-mailů i push notifikací funguje. Kdyby stejná zpráva nedorazila někomu dalšímu, začni u jeho nastavení upozornění v Launchpadu.",
    "testCta": "Otevřít Launchpad"
  },
  "phase": {
    "label": "Krok",
    "progress": "Krok {current} z {total}"
  },
  "appleReminder": {
    "question": "Založ si Apple Developer účet co nejdřív. Apple ho obvykle aktivuje do 48 hodin a bez něj aplikaci nevydáme.",
    "yes": "Potvrdit založení účtu",
    "later": "Připomenout později",
    "guide": "Jak účet založit",
    "fillQuestion": "Super, účet máš. Až ti ho Apple schválí, budeme potřebovat informace o aplikaci. Vyplň je klidně už teď.",
    "fillAction": "Vyplnit informace o aplikaci",
    "fillSummary": "Super, účet máš",
    "waitingDot": "Čeká na tvoje podklady"
  },
  "account": {
    "eyebrow": "Účet",
    "title": "Tvůj účet",
    "link": "Můj účet",
    "emailLabel": "Přihlášený e-mail",
    "language": {
      "title": "Jazyk aplikace",
      "copy": "Změna se uloží k tvému účtu a projeví se na všech klientských obrazovkách.",
      "saved": "Jazyk je změněný. Můžeš pokračovat tam, kde tvoje práce skončila.",
      "error": "Jazyk se nepodařilo uložit. Zkus to znovu."
    }
  },
  "countdown": {
    "day1": "den",
    "day2": "dny",
    "day5": "dní",
    "hours": "hod",
    "minutes": "min",
    "seconds": "sek"
  },
  "stripe": {
    "eyebrow": "Krok 15",
    "title": "Propoj Stripe a přijímej platby",
    "copy": "Předplatné Buddyho budou zákazníci platit přes Stripe přímo tobě a z něj vezmeme platební odkazy do tvé prodejní stránky. Krok je technický, ale krátký, a provedeme tě jím.",
    "inviteEyebrow": "Nastavení plateb",
    "inviteTitle": "Propoj svůj Stripe s Buddym",
    "waiting": "Čeká na tebe",
    "preparing": "Připravujeme",
    "done": "Propojeno",
    "doneCopy": "Platby jsou propojené a ověřené. Předplatné od zákazníků chodí přímo tobě.",
    "statusEyebrow": "Stav plateb",
    "statusTitle": "Kam jsme se dostali",
    "statusWaiting": "Čekáme na propojení tvého Stripe účtu.",
    "statusPreparingLink": "Propojovací odkaz do tvého Stripe se generuje automaticky. Dáme ti vědět, až bude připravený.",
    "statusReceiving": "Ověřeno: platby chodí na tvůj účet.",
    "partnerCall": "Domluv si mimořádný hovor s parťákem",
    "connectButton": "Připojit Stripe",
    "retryButton": "Zkusit propojení znovu",
    "connectNote": "Odkaz v BuddyPro nemá časový limit. Když Stripe ukáže chybu, vrať se sem a spusť stejné propojení znovu.",
    "stepConnect": "Klikni na Připojit Stripe a projdi propojením. Přihlásíš se ke svému Stripe účtu, nebo si ho tam založíš.",
    "waitingForLink": "Propojovací odkaz se generuje automaticky. Jakmile tu bude, jedním kliknutím propojíš svůj Stripe s Buddym. Dáme ti vědět."
  },
  "payments": {
    "eyebrow": "Napojení plateb",
    "copy": "Platby za Buddyho ti nastavíme my: propojíme tvůj Stripe s Buddym, vytvoříme tarify podle schválené strategie a doplníme objednávkové odkazy do prodejní stránky. Od tebe potřebujeme jen přístup do Stripe.",
    "statusEyebrow": "Stav plateb",
    "statusTitle": "Kde teď jsme",
    "status": {
      "locked": "Krok se otevře po schválení prodejní stránky.",
      "next": "Čekáme na přístup do tvého Stripe účtu. Jakmile ho budeme mít, pustíme se do nastavení.",
      "working": "Přístup máme a platby nastavujeme. Až bude všechno ověřené, uvidíš to tady.",
      "done": "Platby jsou nastavené a ověřené testovacím nákupem. Předplatné od zákazníků chodí přímo na tvůj Stripe."
    },
    "pill": {
      "locked": "Zatím zavřeno",
      "next": "Čeká na tebe",
      "working": "Pracujeme na tom",
      "done": "Hotovo"
    },
    "accessEyebrow": "Co od tebe potřebujeme",
    "accessTitle": "Přístup do tvého Stripe účtu",
    "accessInvite": "Pozvi nás do svého Stripe jako administrátora nebo vývojáře. Ve Stripe otevři Nastavení, pak Tým a zabezpečení, klikni na Pozvat a zadej e-mail {email}.",
    "accessInviteNoEmail": "Pozvi nás do svého Stripe jako administrátora nebo vývojáře. Ve Stripe otevři Nastavení, pak Tým a zabezpečení a klikni na Pozvat. Adresu, na kterou pozvánku pošleš, ti dá tvůj parťák.",
    "accessCall": "Nebo si domluv krátký hovor s parťákem a Stripe s Buddym propojíme spolu přímo během hovoru.",
    "bookCall": "Domluvit hovor s parťákem",
    "workEyebrow": "Co nastavíme",
    "workTitle": "Platby od propojení po první nákup",
    "work": {
      "1": "Propojíme tvůj Stripe účet s Buddym.",
      "2": "Vytvoříme tarify podle schválené prodejní strategie.",
      "3": "Nastavíme odkaz na předplatné, který navazuje na zkušební dobu.",
      "4": "Připravíme pozvánky a doplníme objednávkové odkazy do prodejní stránky.",
      "5": "Všechno ověříme testovacím nákupem."
    }
  },
  "errors": {
    "crashTitle": "Něco se nepovedlo",
    "crashBody": "Zkus prosím načíst stránku znovu. Tvoje data jsou v bezpečí.",
    "reload": "Načíst znovu"
  },
  "reader": {
    "panelPin": "Připnout k okraji",
    "panelFloat": "Uvolnit jako plovoucí okno",
    "panelHide": "Skrýt panel",
    "printPdf": "Uložit jako PDF",
    "chapters": "Kapitoly",
    "printingPdf": "Připravuji PDF..."
  },
  "appWizard": {
    "title": "Průvodce mobilní aplikací",
    "navLabel": "Kroky průvodce",
    "progressLabel": "Hotovo {done} z {total} kroků:",
    "save": {
      "saving": "Ukládám...",
      "saved": "Uloženo",
      "error": "Uložení se nepovedlo"
    },
    "loadError": {
      "salespageApprovalRequired": "Dotazník k appce zatím nejde otevřít, protože prodejní stránka ještě není schválená.",
      "generic": "Dotazník k appce se nepodařilo načíst.",
      "retry": "Načíst znovu",
      "partnerCall": "Domluv si mimořádný hovor s parťákem",
      "partnerFallback": "Domluv si mimořádný hovor s parťákem"
    },
    "steps": {
      "overview": "Vítej",
      "basics": "Základy aplikace",
      "branding": "Vzhled aplikace",
      "apple_developer": "Apple Developer účet",
      "apple_copy": "Texty pro App Store",
      "google_copy": "Texty pro Google Play",
      "screenshots": "Grafika pro obchody",
      "subscriptions": "Předplatná a ceny",
      "legal": "Právní údaje",
      "review": "Kontrola a odeslání"
    },
    "stepState": {
      "todo": "Čeká",
      "in_progress": "Rozpracováno",
      "done": "Hotovo"
    },
    "overview": {
      "title": "Tvoje mobilní aplikace v App Store a Google Play",
      "copy": "Tady připravíš všechno, co obchody potřebují ke zveřejnění tvé aplikace. Každý krok se ukládá sám, můžeš kdykoliv odejít a vrátit se.",
      "stores": "Vybereš obchody, jazyk a název aplikace",
      "brand": "Nastavíš barvy a ikonu, ať aplikace vypadá jako tvoje značka",
      "graphics": "Doplníš texty a obrázky do obchodů",
      "pricing": "Určíš předplatná a ceny",
      "parallel": "Nemusíš čekat na schválení Apple účtu. Všechno tu vyplníš mezitím.",
      "start": "Začít",
      "continue": "Pokračovat"
    },
    "basics": {
      "title": "Základy aplikace",
      "copy": "Název, jazyky a trhy, kde bude tvoje aplikace k dostání.",
      "storesLabel": "Obchody s aplikacemi",
      "storesHint": "Vyber, kde se má aplikace zveřejnit. Do odeslání to můžeš kdykoliv změnit.",
      "storesRule": "Aspoň jeden obchod musí zůstat vybraný.",
      "nameLabel": "Název aplikace",
      "nameHint": "Jméno, které lidé uvidí pod ikonou i v obou obchodech. Nejvýš 30 znaků.",
      "primaryLanguageLabel": "Hlavní jazyk",
      "primaryLanguageHint": "Jazyk, ve kterém aplikace běží a kterým začíná její stránka v obchodě.",
      "primaryLanguagePlaceholder": "Vyber jazyk",
      "moreLanguagesLabel": "Další jazyky",
      "moreLanguagesHint": "Volitelné. Každý jazyk navíc znamená další texty k vyplnění, přidej jen ty, které budeš opravdu udržovat.",
      "currencyLabel": "Měna cen",
      "currencyHint": "Měna, ve které nastavíš ceny předplatných.",
      "currencyPlaceholder": "Vyber měnu",
      "categoryLabel": "Kategorie",
      "categoryHint": "Kde tě lidé v obchodech najdou. Pro mentoring a kurzy bývá nejlepší Vzdělávání.",
      "categoryPlaceholder": "Vyber kategorii",
      "countriesLabel": "Země, kde bude aplikace dostupná",
      "countriesHint": "Vyber trhy, kde půjde aplikace stáhnout. Klidně označ všechno, nic to nestojí.",
      "regionAll": "Vybrat vše",
      "regionNone": "Zrušit výběr"
    },
    "regions": {
      "europe": "Evropa",
      "americas": "Amerika",
      "asiaPacific": "Asie a Pacifik",
      "middleEastAfrica": "Blízký východ a Afrika"
    },
    "categories": {
      "books": "Knihy",
      "business": "Byznys",
      "education": "Vzdělávání",
      "entertainment": "Zábava",
      "finance": "Finance",
      "food_drink": "Jídlo a pití",
      "graphics_design": "Grafika a design",
      "health_fitness": "Zdraví a fitness",
      "lifestyle": "Životní styl",
      "medical": "Medicína",
      "music": "Hudba",
      "navigation": "Navigace",
      "news": "Zprávy",
      "photo_video": "Foto a video",
      "productivity": "Produktivita",
      "reference": "Příručky",
      "shopping": "Nakupování",
      "social_networking": "Sociální sítě",
      "sports": "Sport",
      "travel": "Cestování",
      "utilities": "Nástroje",
      "weather": "Počasí"
    },
    "branding": {
      "title": "Vzhled aplikace",
      "copy": "Tvoje barvy a ikona. Náhledy dole se hned překreslí.",
      "colorsLabel": "Barvy značky",
      "colorsHint": "Klikni na barvu, nebo vlož hex kód z brand manuálu.",
      "color": {
        "primary": "Hlavní barva",
        "secondary": "Doplňková barva",
        "accent": "Akcentová barva",
        "background": "Barva pozadí"
      },
      "colorHint": {
        "primary": "Tlačítka, odkazy a zvýrazněné prvky.",
        "secondary": "Přechody a podpůrné prvky.",
        "accent": "Drobné detaily a notifikace.",
        "background": "Pozadí obrazovek aplikace."
      },
      "iconLabel": "Ikona aplikace",
      "iconHint": "Čtverec 1024 x 1024 px, PNG bez průhlednosti. Rohy nezaobluj, to udělají obchody samy.",
      "previewLabel": "Živý náhled",
      "previewHint": "Skutečné obrazovky tvé aplikace vykreslené ve tvých barvách.",
      "previewAppName": "Tvoje aplikace",
      "previewSignupTitle": "Vytvořit účet",
      "previewLoginSub": "Přihlas se ke svému účtu",
      "previewSignupSub": "Zabere to minutku",
      "previewLoginCta": "Přihlásit se",
      "previewSignupCta": "Zaregistrovat se",
      "previewLink": "Zapomenuté heslo?",
      "previewOnline": "Online",
      "previewChatBot": "Ahoj! Jsem tvůj průvodce. S čím ti dnes pomůžu?",
      "previewChatUser": "Chci se posunout dál.",
      "previewChatBot2": "Super. Začneme krátkou otázkou...",
      "previewCaption": {
        "login": "Přihlášení",
        "signup": "Registrace",
        "chat": "Chat"
      }
    },
    "appleDev": {
      "title": "Apple Developer účet",
      "copy": "Bez vlastního vývojářského účtu Apple aplikaci nezveřejníme. Apple si po registraci ověří firmu, obvykle za 1 až 2 pracovní dny, proto je to první věc k vyřízení.",
      "confirmed": "Účet máš potvrzený. Až ti Apple registraci schválí, nic dalšího tu nemusíš řešit.",
      "teamIdLabel": "Team ID",
      "teamIdHint": "Najdeš ho po přihlášení na developer.apple.com v sekci Membership. Klidně doplň později.",
      "emailLabel": "E-mail k App Store Connect",
      "emailHint": "E-mail, kterým se hlásíš do Apple účtu. Pomůže nám s pozvánkou pro sestavení aplikace.",
      "teamIdPlaceholder": "např. A1BC23DEF4",
      "emailPlaceholder": "jmeno@firma.cz"
    },
    "appleCopy": {
      "title": "Texty pro App Store",
      "copy": "Texty, které uvidí lidé na stránce tvé aplikace. Delší texty klidně namluv, mikrofon je u pole.",
      "subtitleLabel": "Podtitulek",
      "subtitleHint": "Krátká věta pod názvem. Nejvýš 30 znaků.",
      "descriptionLabel": "Popis aplikace",
      "descriptionHint": "Hlavní text stránky v obchodě. Popiš, co aplikace umí a komu pomáhá. Až 4000 znaků.",
      "keywordsLabel": "Klíčová slova",
      "keywordsHint": "Slova oddělená čárkou, podle kterých aplikaci lidé najdou. Nejvýš 100 znaků.",
      "promoLabel": "Promo text",
      "promoHint": "Volitelný. Zobrazuje se nad popisem a dá se měnit bez nové verze aplikace. Nejvýš 170 znaků."
    },
    "copy": {
      "needLanguages": "Nejdřív v Základech aplikace vyber hlavní jazyk, ať víme, v jakých jazycích texty sbírat.",
      "goBasics": "Otevřít Základy aplikace"
    },
    "googleCopy": {
      "title": "Texty pro Google Play",
      "copy": "Krátké texty pro stránku aplikace na Google Play.",
      "shortLabel": "Krátký popis",
      "shortHint": "Jedna věta, která prodá. Nejvýš 80 znaků.",
      "descriptionShared": "Dlouhý popis se přebírá z kroku Texty pro App Store, tady stačí jen krátká věta.",
      "descriptionLabel": "Popis aplikace",
      "descriptionHint": "Hlavní text stránky na Google Play. Až 4000 znaků."
    },
    "screenshots": {
      "title": "Grafika pro obchody",
      "copy": "Snímky obrazovek a grafika, které obchody vyžadují. Přesné rozměry jsou u každého políčka.",
      "helpNote": "Nemáš snímky po ruce? Nech to prázdné a domluv se s parťákem, připravíme je s tebou.",
      "shotLabel": "Snímek",
      "group": {
        "appleIphone": "iPhone snímky",
        "appleIpad": "iPad snímky",
        "googleFeature": "Úvodní grafika Google Play",
        "googlePhone": "Telefonní snímky Google Play"
      },
      "groupHint": {
        "appleIphone": "4 snímky, 1290 x 2796 px. Stačí největší formát, menší velikosti si Apple vytvoří sám.",
        "appleIpad": "4 snímky, 2048 x 2732 px. Stejný obsah jako iPhone, jen na širším plátně.",
        "googleFeature": "1 obrázek, 1024 x 500 px. Široký banner nahoře na tvé stránce, texty a loga drž dál od okrajů.",
        "googlePhone": "4 snímky, 1080 x 1920 px. Skvěle poslouží iPhone vizuály převedené na poměr 9:16."
      }
    },
    "subscriptions": {
      "title": "Předplatná a ceny",
      "copy": "Tarify, které si lidé v aplikaci koupí. Stačí jeden, přidat můžeš až šest.",
      "empty": "Zatím tu není žádný tarif. Přidej první.",
      "tierLabel": "Tarif",
      "removeTier": "Odebrat",
      "draftNote": "Rozpracovaný tarif. Uloží se, jakmile vybereš cenu.",
      "priceLabel": "Cena",
      "pricePlaceholder": "Vyber cenu",
      "priceHint": "Ceny vychází z ceníku Apple. V obchodě se zákazníkům přepočtou do jejich měny.",
      "periodLabel": "Období",
      "trialLabel": "Zkušební období zdarma",
      "trialNone": "Bez zkušebního období",
      "trialDays": "dní",
      "nameLabel": "Název tarifu",
      "nameHint": "Např. Měsíční nebo Roční. Nejvýš 30 znaků.",
      "descLabel": "Popis tarifu",
      "descHint": "Volitelná věta k tarifu. Nejvýš 45 znaků.",
      "addTier": "Přidat tarif"
    },
    "periods": {
      "weekly": "Týdně",
      "monthly": "Měsíčně",
      "two_months": "Každé 2 měsíce",
      "three_months": "Čtvrtletně",
      "six_months": "Pololetně",
      "yearly": "Ročně"
    },
    "legal": {
      "title": "Právní údaje",
      "copy": "Údaje, které obchody povinně zobrazují u tvé aplikace.",
      "legalEntityNameLabel": "Obchodní jméno firmy",
      "legalEntityNameHint": "Oficiální název přesně podle rejstříku. Zobrazí se jako prodejce v obou obchodech.",
      "legalEntityAddressLabel": "Sídlo",
      "legalEntityAddressHint": "Úplná adresa sídla firmy: ulice, město, PSČ a země.",
      "businessPhoneLabel": "Telefon",
      "businessPhoneHint": "Povinný kontakt podle evropského nařízení DSA. Zobrazuje se u aplikace v EU.",
      "supportEmailLabel": "E-mail podpory",
      "supportEmailHint": "Kam ti uživatelé aplikace napíšou o pomoc.",
      "supportUrlLabel": "Web podpory",
      "supportUrlHint": "Volitelné. Stránka s nápovědou nebo kontaktem.",
      "marketingUrlLabel": "Web aplikace",
      "marketingUrlHint": "Volitelné. Stránka, kde aplikaci představuješ.",
      "privacyPolicyUrlLabel": "Zásady ochrany soukromí",
      "privacyPolicyUrlHint": "Povinný pro oba obchody. Musí být veřejně dostupný na tvém webu.",
      "termsOfServiceUrlLabel": "Obchodní podmínky",
      "termsOfServiceUrlHint": "Povinné pro aplikace s předplatným."
    },
    "review": {
      "title": "Kontrola a odeslání",
      "copy": "Projdi si, co je hotové. Jakmile bude všechno zelené, pošli nám podklady jedním tlačítkem.",
      "submittedCopy": "Podklady jsou odeslané. Tady je máš kdykoliv k nahlédnutí.",
      "finishStep": "Dokončit",
      "incomplete": "Ještě tu něco chybí. Doplň kroky výše a tlačítko se odemkne.",
      "submit": "Odeslat BuddyPro týmu",
      "submitting": "Odesílám...",
      "submittedNote": "Podklady jsme předali týmu. O dalším postupu tě budeme informovat."
    },
    "assets": {
      "errorUnknown": "Tenhle typ souboru sem nepatří.",
      "errorType": "Špatný formát souboru. Nahraj PNG, případně JPG tam, kde je povolený.",
      "errorSize": "Soubor je moc velký.",
      "errorDimensions": "Obrázek nemá přesné rozměry. Zkontroluj velikost u políčka a nahraj ho znovu.",
      "errorTransparent": "Ikona nesmí mít průhledné pozadí. Ulož ji bez průhlednosti a nahraj znovu.",
      "errorUpload": "Nahrání se nepovedlo. Zkus to prosím znovu.",
      "uploading": "Nahrávám...",
      "choose": "Vybrat soubor",
      "replace": "Nahradit",
      "remove": "Odebrat"
    }
  },
  "dfyEta": {
    "step": "Krok {current} z {total} · {label}",
    "remainingRange": "Obvykle ještě {from}-{to} min",
    "readyAt": "Hotovo přibližně v {time}",
    "sample": "Odhad z {count} dokončených výrob. Zpřesní se po každém kroku.",
    "learning": "Odhad se zatím učí. Výroba pokračuje.",
    "finishing": "Dokončujeme",
    "durationSeconds": "{seconds} s",
    "durationMinutes": "{minutes} min",
    "durationHours": "{hours} h",
    "durationHoursMinutes": "{hours} h {minutes} min",
    "doneOf": "Hotovo {done} z {total} kroků",
    "onStep": "na tomhle kroku {duration}",
    "usually": "obvykle ~{duration}",
    "runningFor": "běží {duration}",
    "runningTotal": "Celkem běží {duration}",
    "learningFirst": "Odhad se zatím učí, tohle je vůbec první výroba tohohle materiálu.",
    "learningRun": "Odhad se zatím učí, tohle je teprve {number}. výroba tohohle materiálu.",
    "stages": {
      "prep": "Příprava podkladů",
      "generate": "Psaní",
      "critique": "Kritika a přepis",
      "qa": "Kontrola",
      "assembly": "Sestavení",
      "delivery": "Doručení"
    },
    "stageStepsOne": "1 krok",
    "stageStepsFew": "{count} kroky",
    "stageStepsMany": "{count} kroků",
    "skipped": "tenhle krok se přeskočil"
  },
  "automationTiming": {
    "typical": "Obvykle ~{minutes} min (z {count} běhů)"
  },
  "partnerOS": {
    "navigation": {
      "label": "Hlavní navigace Partner OS",
      "today": "Dnes",
      "clients": "Klienti",
      "detail": "Detail",
      "admin": "Správa",
      "detailLocked": "Detail se otevře, až vybereš klienta. Klikni a vyber ho v Klientech."
    },
    "trainingRun": {
      "phase": {
        "1": "Průzkum experta",
        "2": "Sběr obsahu",
        "3": "Telegram bot",
        "4": "Licence",
        "5": "Google Drive",
        "6": "Znalostní báze",
        "7": "Systémový prompt",
        "8": "Ladění hlasu a chování",
        "9": "Dokončení"
      }
    },
    "today": {
      "kicker": "Partner OS",
      "title": "Dnešní práce",
      "intro": "Jedno místo pro úkoly, které dnes potřebují tvoje rozhodnutí.",
      "openClients": "Otevřít klienty",
      "refresh": "Obnovit",
      "error": "Dnešní frontu se nepodařilo načíst.",
      "refreshFailed": "Frontu se nepodařilo obnovit. Ukazujeme stav z {time}.",
      "open": "Otevřít",
      "joinCall": "Připojit se",
      "emptyTitle": "Dnes je fronta čistá",
      "emptyBody": "Žádná revize, čekání ani riziko teď nepotřebují tvoji pozornost.",
      "stream": {
        "mine": "Na tahu já",
        "calls": "Dnešní hovory",
        "automation": "Běží výroba",
        "waiting": "Čeká na klienta",
        "risks": "Zablokované a rizika",
        "team": "Na tahu tým"
      },
      "summary": "{count} věcí k vyřízení",
      "hiddenTest": "{count} testovacích skryto",
      "alsoPhases": "a {count} další fáze",
      "etaSoon": "hotovo každou chvíli",
      "etaMinutes": "hotovo za {count} min",
      "etaAt": "hotovo kolem {time}",
      "newerBuilding": "Právě se vyrábí novější verze, počkej na ni",
      "shownTest": {
        "one": "{count} testovací mezi nimi",
        "few": "{count} testovací mezi nimi",
        "other": "{count} testovacích mezi nimi"
      }
    },
    "rail": {
      "label": "Cesta klienta"
    },
    "clientHero": {
      "kicker": "Další nejlepší krok",
      "localKicker": "Stav vybraného kroku",
      "review": "Zkontroluj a zveřejni připravený materiál",
      "failed": "Vyřeš selhání automatizace",
      "stepBlocked": "Odblokuj krok, chybí povinný výstup",
      "automation": "Automatizace právě pracuje",
      "service": "Doplň servisní nastavení",
      "stripeLink": "Doplň klientovi Stripe connect odkaz",
      "addStripeLink": "Doplnit Stripe odkaz",
      "waiting": "Čekáme na klienta",
      "waitingOnboarding": "Klient si zatím nevybral úvodní hovor",
      "waitingOnboardingNext": "Odkaz je připravený níže. Když se klient neozve, pošli mu ho znovu.",
      "waitingMarketing": "Klient si zatím nevybral marketingový hovor",
      "waitingMarketingNext": "Odkaz je připravený níže. Když se klient neozve, pošli mu ho znovu.",
      "complete": "Klient má vše hotové",
      "open": "Otevřít krok",
      "here": "Vybraný krok",
      "local": {
        "partner_action": "Vybraný krok čeká na tvoje rozhodnutí",
        "automation": "Na vybraném kroku pracuje Alex",
        "waiting_client": "Vybraný krok čeká na klienta",
        "blocked": "Vybraný krok je zablokovaný",
        "locked": "Vybraný krok je zamčený",
        "complete": "Vybraný krok je hotový"
      },
      "elsewhereLead": "Jinde u klienta",
      "elsewhereState": {
        "partner_action": "čeká na tvoje rozhodnutí",
        "automation": "pracuje Alex",
        "waiting_client": "čekáme na klienta",
        "blockedTeam": "tým dodělává výstup",
        "blockedAlex": "automatizace selhala"
      },
      "production": {
        "ready": "Tým připraví materiál",
        "draft": "Tým dokončí rozpracovaný materiál",
        "missing": "Čeká na materiál: {prerequisite}",
        "approval": "Čeká na schválení a zpřístupnění: {prerequisite}",
        "working": "Čeká na dokončení výroby: {prerequisite}",
        "failed": "Blokuje jej selhaná výroba: {prerequisite}",
        "body": "Další práce je na týmu. Klient teď tento materiál nemůže posunout.",
        "open": "Otevřít předchozí materiál"
      }
    },
    "clientContext": {
      "kicker": "Kontext",
      "partner": "Parťák",
      "partnerNone": "zatím nikdo",
      "partnerAssign": "Přiřadit",
      "partnerChange": "Změnit",
      "title": "Klient",
      "email": "E-mail",
      "nextCall": "Další hovor",
      "write": "Napsat",
      "open": "Otevřít jako klient",
      "opening": "Otevírám...",
      "openHint": "Na hodinu se v tomhle prohlížeči přepneš do role klienta. Zpátky tě vrátí lišta nahoře.",
      "openFailed": "Otevřít jako klient se teď nepodařilo.",
      "openNotYours": "Tenhle klient není tvůj, takže ho otevřít nejde.",
      "openForbidden": "Na otevření jako klient nemáš právo.",
      "openConflict": "Náhled se nepodařilo založit. Zkus to ještě jednou.",
      "openOffline": "Spojení se serverem selhalo. Zkontroluj připojení a zkus to znovu.",
      "bot": "Buddy",
      "instance": "Instance",
      "instanceOpen": "Otevřít v hubu",
      "drive": "Know-how",
      "driveOpen": "Složka na Disku",
      "profile": "Kdo klient je",
      "profileFacts": "{count} faktů v profilu",
      "profileEmpty": "Profil zatím prázdný"
    },
    "workState": {
      "partner_action": "Na tahu ty",
      "automation": "Běží automaticky",
      "waiting_client": "Čeká na klienta",
      "blocked": "Zablokované",
      "complete": "Hotovo",
      "locked": "Zamčeno",
      "done_ahead": "Hotové napřed"
    },
    "workspace": {
      "kicker": "Pracovní plocha fáze",
      "reviewCard": "Revizní karta",
      "visibleToClient": "Klient vidí tuto verzi",
      "clientSeesVersion": "Klient zatím vidí verzi {version}",
      "notVisibleToClient": "Klient zatím materiál nevidí",
      "newerVersionBuilding": "Vyrábí se novější verze. Počkej na ni, tuhle už výroba přepisuje.",
      "buildFailed": "Výroba skončila chybou.",
      "openReview": "Otevřít revizní místnost",
      "feedback": "Připomínky klienta",
      "feedbackTeam": "Připomínky týmu",
      "feedbackMixed": "Připomínky",
      "noOpenFeedback": "Žádná otevřená připomínka.",
      "voiceNote": "Hlasová připomínka",
      "waitingForBuild": "Materiál se právě vyrábí.",
      "noMaterial": "Pro tuto fázi zatím není připravený materiál.",
      "aheadOfUnlock": "Hotové napřed: výstup vznikl dřív, než se krok odemkl. Ověř, že ho klient měl dostat."
    },
    "states": {
      "matrixLoadingTitle": "Načítám klienty",
      "matrixLoadingBody": "Skládám aktuální stav portfolia.",
      "detailLoadingTitle": "Načítám klientský cockpit",
      "detailLoadingBody": "Ověřuji kroky, materiály a poslední aktivitu.",
      "matrixEmptyTitle": "Žádný klient neodpovídá filtru",
      "errorTitle": "Aktuální stav se nepodařilo načíst",
      "errorBody": "Zkus načtení zopakovat. Uložená data jsem nezměnil.",
      "conflictTitle": "Data se mezitím změnila",
      "conflictBody": "Načti čerstvý stav a zopakuj rozhodnutí nad aktuální verzí.",
      "offlineTitle": "Zprávu se nepodařilo odeslat",
      "offlineBody": "Vypadá to na výpadek připojení. Zkontroluj síť a akci zopakuj. Nic se neuložilo."
    },
    "queue": {
      "materialReview": "Zkontroluj a zveřejni: {material}",
      "materialFeedback": "{material}: otevřené připomínky ({count})",
      "waitingOnClient": "Klient čeká ve fázi {phase}",
      "clientBlocked": "Klient čeká ve fázi {phase} déle než povolený čas",
      "stepBlocked": "Krok {phase} je zablokovaný, chybí povinný výstup",
      "stripeConnect": "Doplň klientovi Stripe connect odkaz",
      "callLink": "Připrav stálý odkaz pro fázi {phase}",
      "profileResearch": "Výzkum profilu",
      "automationRunning": "{subject}: výroba právě běží",
      "automationStale": "{subject}: výroba se dlouho neozvala",
      "automationFailed": "{subject}: výroba skončila chybou",
      "researchFailed": "Výzkum profilu skončil chybou",
      "researchStale": "Výzkum profilu se dlouho neozval",
      "researchRunning": "Výzkum profilu právě běží",
      "betaFeedback": "Podněty z testování čekají na tvoje rozhodnutí ({count})",
      "videoMissing": "Klientovi chybí video: {phase}",
      "appPrefillLate": "Vázne předvyplnění: {phase}",
      "production": {
        "ready": "{phase}: tým připraví materiál",
        "draft": "{phase}: tým dokončí rozpracovaný materiál",
        "missing": "{phase}: čeká na materiál {prerequisite}",
        "approval": "{phase}: čeká na schválení a zpřístupnění materiálu {prerequisite}",
        "working": "{phase}: čeká na dokončení výroby {prerequisite}",
        "failed": "{phase}: blokuje jej selhaná výroba {prerequisite}"
      }
    },
    "material": {
      "strategy": "Prodejní strategie",
      "plan": "Prodejní strategie",
      "salespage": "Prodejní stránka",
      "emails": "E-maily",
      "webinar": "Webinář",
      "avatar": "AI avatar"
    },
    "phase": {
      "home": "Založení",
      "onboarding_call": "Úvodní video",
      "q1": "Dotazník k Buddymu",
      "knowhow": "Know-how",
      "training": "Trénink",
      "beta": "Beta",
      "marketing_call": "Marketingové video",
      "q2": "Prodejní dotazník",
      "sales": "Prodejní materiály",
      "stripe": "Stripe",
      "handover": "Předání",
      "app": "Mobilní aplikace"
    }
  },
  "rail": {
    "mobileTitle": "Tvoje cesta",
    "chapters": {
      "buddy": "Příprava Buddyho",
      "sales": "Příprava prodeje"
    },
    "labels": {
      "onboarding_call": "Úvodní video",
      "profile": "Tvůj profil",
      "apple": "První kroky k aplikaci",
      "q1": "Dotazník k přípravě Buddyho",
      "knowhow": "Know-how",
      "training": "Trénink",
      "beta": "Beta testování",
      "feedback": "Zpětná vazba",
      "marketing_call": "Marketingové video",
      "q2": "Dotazník k prodeji",
      "strategy": "Návrh prodejní strategie",
      "salespage": "Prodejní stránka",
      "payments": "Napojení plateb",
      "app_questionnaire": "Dotazník k appce",
      "emails": "E-mail marketing",
      "webinar": "Struktura webináře",
      "stripe": "Propojení se Stripem",
      "handover": "Předání",
      "salespage_publish": "Publikace prodejní stránky",
      "app_release": "Vydání appky"
    },
    "steps": {
      "onboarding_call": "Přehraj si úvodní video",
      "profile": "Upřesni nám, kdo jsi a čím se zabýváš",
      "apple": "Založ si Apple developerský účet",
      "q1": "Dotazník k přípravě Buddyho",
      "knowhow": "Know-how",
      "training": "Trénink",
      "beta": "Beta testování",
      "feedback": "Zpětná vazba",
      "marketing_call": "Marketingové video",
      "q2": "Dotazník k prodeji",
      "strategy": "Návrh prodejní strategie",
      "salespage": "Prodejní stránka",
      "payments": "Napojení plateb",
      "app_questionnaire": "Dotazník k appce",
      "emails": "E-mail marketing",
      "webinar": "Struktura webináře",
      "stripe": "Propojení se Stripem",
      "handover": "Předání",
      "salespage_publish": "Publikace prodejní stránky",
      "app_release": "Vydání appky"
    },
    "completion": {
      "onboarding_call": "Hotovo, když dokoukáš úvodní video k místu, kde se otevírá další krok.",
      "profile": "Hotovo, když profil zkontroluješ a potvrdíš tlačítkem pod ním.",
      "apple": "Hotovo, když potvrdíš, že máš Apple developerský účet založený.",
      "q1": "Hotovo, když odešleš dotazník a systém uloží všechny odpovědi.",
      "knowhow": "Hotovo, když odešleš připravené know-how k tréninku.",
      "training": "Hotovo, když tým ověří trénink a zpřístupní zkušební verzi.",
      "beta": "Hotovo, když si poprvé zkopíruješ odkaz pro testery.",
      "feedback": "Hotovo, když ti předáme správcovství instance.",
      "marketing_call": "Hotovo, když dokoukáš prodejní video k místu, kde se otevírá další krok.",
      "q2": "Hotovo, když odešleš prodejní dotazník a systém uloží odpovědi.",
      "strategy": "Hotovo, když odsouhlasíš prodejní strategii.",
      "salespage": "Hotovo, když stránku odsouhlasíš, doplníš odkazy na objednávku a stránku si stáhneš nebo publikuješ.",
      "payments": "Hotovo, když tým nastaví platby a ověří je testovacím nákupem.",
      "emails": "Hotovo, když tým zveřejní hotové e-maily.",
      "webinar": "Hotovo, když tým zveřejní hotovou strukturu webináře.",
      "stripe": "Hotovo, když systém ověří, že můžeš přijímat platby.",
      "app_questionnaire": "Hotovo, když odešleš všechny údaje k mobilní aplikaci.",
      "salespage_publish": "Hotovo, když je prodejní stránka publikovaná.",
      "handover": "Hotovo, když nám pošleš Telegram ID a potvrdíš, že se ti Owner Dashboard otevřel.",
      "app_release": "Hotovo, když jsou odkazy na aplikaci dostupné v obou obchodech."
    },
    "unlock": {
      "onboarding_call": "Otevře se po přihlášení do Launchpadu.",
      "profile": "Otevře se, až si pustíš úvodní video. Pak ho zkontroluješ ty.",
      "apple": "Otevře se na začátku přípravy aplikace. Založení účtu je na tobě.",
      "q1": "Otevře se, až si pustíš úvodní video a potvrdíš profil. Pak odpovídáš ty.",
      "knowhow": "Otevře se po odeslání dotazníku k Buddymu. Podklady pak doplníš ty a tým.",
      "training": "Otevře se po odeslání know-how. Další krok připraví tým.",
      "beta": "Otevře se po dokončení tréninku. Buddyho pak vyzkoušíš ty.",
      "feedback": "Otevře se po převzetí bota a prvním testování. Podněty doplníš ty.",
      "marketing_call": "Otevře se po beta testování.",
      "q2": "Otevře se, až si pustíš marketingové video. Pak odpovídáš ty.",
      "stepLockedLead": "Tenhle krok se otevře, až budeš mít hotový ten před ním. Nic se nerozbilo, jen na něj ještě nejsi.",
      "strategy": "Otevře se po odeslání prodejního dotazníku. Návrh připraví tým.",
      "salespage": "Otevře se po schválení strategie. Stránku připraví tým.",
      "payments": "Otevře se po schválení prodejní stránky. Platby nastaví tým.",
      "app_questionnaire": "Otevře se po schválení prodejní stránky. Údaje pak doplníš ty.",
      "emails": "Otevře se po schválení strategie. E-maily připraví tým.",
      "webinar": "Otevře se po schválení strategie. Strukturu připraví tým.",
      "stripe": "Otevře se během přípravy prodeje. Propojení potom dokončíš ty.",
      "handover": "Otevře se po schválení všech prodejních podkladů. Oba kroky předání pak dokončíš ty.",
      "salespage_publish": "Otevře se po schválení stránky a doplnění odkazů na objednávku. Způsob zveřejnění vybereš ty.",
      "app_release": "Otevře se po odeslání aplikace do obchodů. Výsledek potvrdí tým."
    },
    "unlockPreparing": {
      "knowhow": "Tým teď připravuje složku na know-how a dokument na odkazy. Jakmile budou hotové, krok se ti otevře a podklady doplníš."
    },
    "lockedPreview": {
      "onboarding_call": {
        "1": "Úvodní video, které tě provede celou cestou",
        "2": "Přehrávač, kde se krok odemkne po zhlédnutí videa",
        "3": "Návaznost na tvůj profil hned po videu",
        "owner": "Ty",
        "when": "Hned po prvním přihlášení"
      },
      "profile": {
        "1": "Mapa toho, co jsme o tobě našli ve veřejných zdrojích",
        "2": "Mikrofon na doplnění a opravy vlastními slovy",
        "3": "Potvrzení profilu, ze kterého vychází celý Buddy",
        "owner": "Ty a tým BuddyPro",
        "when": "Po úvodním videu"
      },
      "apple": {
        "1": "Průvodce založením Apple developerského účtu",
        "2": "Co si připravit a čemu se při registraci vyhnout",
        "3": "Potvrzení účtu, na které navazuje příprava aplikace",
        "owner": "Ty",
        "when": "Na začátku přípravy aplikace"
      },
      "q1": {
        "1": "Otázky k tomu, jak má Buddy mluvit a komu odpovídá",
        "2": "Diktování odpovědí hlasem místo psaní",
        "3": "Průběžné ukládání, dotazník můžeš rozdělit na víckrát",
        "owner": "Ty",
        "when": "Po úvodním videu a potvrzení profilu"
      },
      "knowhow": {
        "1": "Složka na Google Disku, kam nahraješ svoje podklady",
        "2": "Dokument na odkazy na videa, podcasty a články",
        "3": "Odeslání podkladů k tréninku Buddyho",
        "owner": "Složku připraví tým BuddyPro, obsah doplníš ty",
        "when": "Po odeslání dotazníku k Buddymu"
      },
      "training": {
        "1": "Zpráva o tom, že se Buddy právě učí z tvých podkladů",
        "2": "Kdy ho čekat: 2 až 3 pracovní dny",
        "3": "E-mail ve chvíli, kdy je Buddy hotový",
        "owner": "Tým BuddyPro",
        "when": "Po odeslání know-how"
      },
      "beta": {
        "1": "Odkaz na tvého Buddyho, se kterým si můžeš povídat",
        "2": "Převod Telegram bota na tvůj vlastní účet",
        "3": "Pozvánky pro testery a schránka na podněty",
        "owner": "Ty, převod dokončí tým BuddyPro",
        "when": "Po dokončení tréninku"
      },
      "feedback": {
        "1": "Formulář na podněty k Buddyho odpovědím",
        "2": "Rozlišení, jestli podnět píšeš ty, nebo tester",
        "3": "Přehled už odeslaných podnětů",
        "owner": "Ty",
        "when": "Po převzetí bota a prvním testování"
      },
      "marketing_call": {
        "1": "Marketingové video o tom, jak se Buddy prodává",
        "2": "Přehrávač, kde se krok odemkne po zhlédnutí videa",
        "3": "Návaznost na dotazník k prodeji",
        "owner": "Ty",
        "when": "Po beta testování"
      },
      "q2": {
        "1": "Otázky k nabídce, cenám a tvým zákazníkům",
        "2": "Diktování odpovědí hlasem a nahrávání podkladů",
        "3": "Průběžné ukládání, dotazník můžeš rozdělit na víckrát",
        "owner": "Ty",
        "when": "Po marketingovém videu"
      },
      "strategy": {
        "1": "Návrh kampaně a hlavní prodejní argumenty",
        "2": "Doporučené ceny, tarify a jejich logika",
        "3": "Místa pro připomínky a závěrečné schválení",
        "owner": "Tvůj parťák",
        "when": "Po odeslání prodejního dotazníku"
      },
      "salespage": {
        "1": "Skutečný první náhled hotové prodejní stránky",
        "2": "Kontrola obsahu, vzhledu a mobilní verze",
        "3": "Připomínky a schválení přímo nad stránkou",
        "owner": "Tvůj parťák a realizační tým",
        "when": "Po schválení prodejní strategie"
      },
      "payments": {
        "1": "Propojení tvého Stripe s Buddym",
        "2": "Tarify a odkaz na předplatné podle schválené strategie",
        "3": "Objednávkové odkazy v prodejní stránce a ověřovací nákup",
        "owner": "Tvůj parťák a tým",
        "when": "Po schválení prodejní stránky"
      },
      "emails": {
        "1": "Celá e-mailová série v pořadí k odeslání",
        "2": "Předměty, těla e-mailů a výzvy k akci",
        "3": "Kopírování jednotlivých e-mailů i celé série",
        "owner": "Tvůj parťák a copy tým",
        "when": "Po schválení prodejní strategie"
      },
      "webinar": {
        "1": "Osnova a pořadí jednotlivých částí",
        "2": "Hlavní myšlenky a přechody mezi bloky",
        "3": "Prodejní závěr a navazující výzva k akci",
        "owner": "Tvůj parťák a obsahový tým",
        "when": "Po schválení prodejní strategie"
      },
      "stripe": {
        "1": "Odkaz na propojení tvého Stripe účtu",
        "2": "Ověření, že platby opravdu chodí k tobě",
        "3": "Kontakt na parťáka, když se něco zasekne",
        "owner": "Ty a tvůj parťák",
        "when": "Během přípravy prodeje"
      },
      "app_questionnaire": {
        "1": "Údaje o aplikaci pro App Store a Google Play",
        "2": "Nahrání ikony, screenshotů a popisů",
        "3": "Odeslání podkladů k vydání aplikace",
        "owner": "Ty",
        "when": "Po potvrzení Apple účtu"
      },
      "salespage_publish": {
        "1": "Stažení hotové prodejní stránky",
        "2": "Publikace stránky na pár kliknutí",
        "3": "Návod na připojení vlastní subdomény",
        "owner": "Ty",
        "when": "Po schválení stránky a doplnění odkazů na objednávku"
      },
      "handover": {
        "1": "Převedení role majitele celé instance",
        "2": "Owner Dashboard a přístupy k němu",
        "3": "Licenční klíč a připojení tvojí instance",
        "owner": "Ty a tvůj parťák",
        "when": "Po schválení všech prodejních podkladů"
      },
      "app_release": {
        "1": "Stav aplikace v App Storu a Google Play",
        "2": "Odkazy na tvoji aplikaci, jakmile je venku",
        "3": "Co dělat, když obchod vrátí připomínky",
        "owner": "Tým BuddyPro",
        "when": "Po odeslání aplikace do obchodů"
      }
    },
    "notInJourney": "Tenhle krok není součástí tvojí cesty. Nic ti neuteklo a nic si nemusíš odemykat.",
    "lockedNext": {
      "lead": "Teď je na řadě",
      "action": "Přejít na tenhle krok"
    },
    "status": {
      "locked": "Zamčeno",
      "blocked": "Zablokované",
      "on_deck": "Na řadě",
      "review": "Ke kontrole",
      "waiting_apple": "Čeká na Apple",
      "working": "Pracujeme",
      "done": "Hotovo",
      "open": "Otevřeno",
      "testing": "Testuješ",
      "feedback": "Sbíráš podněty",
      "client": "Na tobě",
      "done_ahead": "Hotové napřed"
    },
    "substeps": {
      "done": "hotovo {done} ze {total}"
    },
    "groupBuddy": "Příprava Buddyho",
    "groupSales": "Příprava prodeje",
    "groupSalesLocked": "Otevře se po vytrénování Buddyho",
    "groupApp": "Mobilní aplikace",
    "appStepApple": "Apple Developer účet",
    "appStepWizard": "Dotazník k appce",
    "appStepPublish": "Vydání v obchodech",
    "appProgress": "{done} z {total} kroků"
  },
  "staffOverride": {
    "kindLabel": {
      "profile": "profil",
      "apple": "Apple účet",
      "q1_submit": "zadání pro Buddyho",
      "q2_submit": "prodejní zadání",
      "knowhow_submit": "odeslání know-how k tréninku",
      "video_onboarding": "úvodní video",
      "video_marketing": "marketingové video",
      "strategy": "prodejní strategie",
      "salespage": "prodejní stránka",
      "emails": "prodejní e-maily",
      "webinar": "webinář"
    },
    "locked": {
      "bot_transfer": "Předání Telegram bota vrátit nejde: bot už změnil majitele přímo v Telegramu a náš systém ho neumí vzít zpět.",
      "publication": "Publikaci prodejní stránky vrátit nejde: web běží na klientově vlastním účtu.",
      "stripe": "Napojení plateb vrátit nejde: jde o klientův Stripe účet a skutečné peníze.",
      "handover_close": "Dokončené předání se nevrací: je to uzavřený obchodní krok. Vrátit jdou jen otevřené brány před ním.",
      "app_release": "Zveřejněnou aplikaci vrátit nejde: je venku v App Store."
    },
    "nothing": {
      "training": "Tady není co vracet klientovi: trénink Buddyho potvrzuje parťák, ne klient.",
      "beta": "Tady není co vracet klientovi: v beta testování klient nic nepotvrzuje, jen zkouší a posílá podněty.",
      "feedback": "Tady není co vracet klientovi: zpětná vazba zůstává otevřená, klient tu nic nepotvrzuje."
    },
    "noReopen": {
      "video": "Video krok nemá klientské schválení, které by šlo vrátit. Klient ho uzavírá zhlédnutím videa; můžeš ho ale schválit za klienta."
      ,"q1TrainingStarted": "Dotazník k Buddymu vrátit nejde: trénink už běží nebo je hotový. Opravu domluv s adminem, přes tenhle krok cesta zpátky nevede.",
      "q2MaterialExists": "Prodejní dotazník vrátit nejde: podle něj už vznikl první materiál. Změny patří do připomínek u materiálu nebo do podkladů pro Alexe.",
      "q2BuildRunning": "Prodejní dotazník vrátit nejde, dokud běží výroba materiálu. Zkus to znovu, až výroba skončí."
    }
  },
  "partnerBriefs": {
    "title": "Podklady pro generování",
    "hint": "Co sem napíšeš, bere Alex jako závazné zadání při výrobě prodejních materiálů. Klient tyhle poznámky nevidí.",
    "loadFailed": "Podklady se teď nepodařilo načíst.",
    "save": "Uložit",
    "emptyNote": "Zatím tu nic není",
    "savedNote": "Uloženo.",
    "saveFailed": "Poznámku se nepodařilo uložit. Zkus to prosím znovu.",
    "unsaved": "Neuložené změny",
    "lastSaved": "Poslední úprava: {name}, {date}.",
    "scope": {
      "global": "Obecná poznámka ke klientovi",
      "strategy": "Poznámka k prodejní strategii",
      "salespage": "Poznámka k prodejní stránce",
      "emails": "Poznámka k e-mail marketingu",
      "webinar": "Poznámka ke struktuře webináře"
    },
    "scopeHint": {
      "global": "Platí pro všechny čtyři materiály: strategii, prodejní stránku, e-maily i webinář.",
      "strategy": "Použije se jen při výrobě návrhu prodejní strategie.",
      "salespage": "Použije se jen při výrobě prodejní stránky.",
      "emails": "Použije se jen při výrobě e-mailové kampaně.",
      "webinar": "Použije se jen při výrobě struktury webináře."
    },
    "placeholder": {
      "global": "Co o klientovi víš navíc: doplňující informace, tvůj názor, výpisky nebo přepis hovoru, o kterém Alex neví.",
      "strategy": "Na co si dát pozor u strategie: cena, pozice, velká myšlenka, čemu se vyhnout.",
      "salespage": "Co má stránka umět: důkazy, námitky, tón, co klient odmítá.",
      "emails": "Jak klient píše svému seznamu, co už poslal, čeho se držet.",
      "webinar": "Jak chce klient vysílat, co na webináři musí zaznít, co vynechat."
    },
    "regenerate": {
      "title": "Přegenerovat od základu",
      "hint": "Pro případ, kdy materiál nesedí jako celek a nestačí ho doladit připomínkami. Alex ho vyrobí znovu od nuly a vezme přitom podklady výše i tvůj důvod.",
      "button": "Přegenerovat od základu",
      "notYet": "Materiál zatím neexistuje. Podklady výše se použijí hned při prvním generování.",
      "confirm": "Vyrobit znovu od nuly: {material} ({client})?",
      "confirmButton": "Ano, přegenerovat",
      "reasonLabel": "Proč to chceš jinak",
      "reasonPlaceholder": "Napiš, co je špatně a jak to má vypadat. Text jde Alexovi jako zadání.",
      "reasonRequired": "Napiš prosím důvod, aspoň pár slov.",
      "runningTitle": "Přegenerování běží",
      "runningBody": "Alex vyrábí novou verzi od základu. Až bude hotová, dáme vědět.",
      "blockedBuild": "Na tomhle materiálu právě běží výroba. Počkej, až doběhne.",
      "blockedEdit": "Na tomhle materiálu běží úprava podle připomínek. Počkej, až doběhne.",
      "consequenceFresh": "Alex začne s prázdným stolem. Vznikne nová verze, ne úprava té současné.",
      "consequencePublished": "Klient dál vidí zveřejněnou verzi. Novou uvidí, až ji zveřejníš.",
      "consequenceApproved": "Schválení současné verze platí dál pro ni. Novou verzi bude klient schvalovat znovu.",
      "consequenceNotes": "Otevřené připomínky k současné verzi se uzavřou ({count}). Zůstanou v historii materiálu.",
      "error": {
        "generic": "Přegenerování se teď nepodařilo spustit. Zkus to prosím znovu.",
        "nothing_to_regenerate": "Není co přegenerovat: materiál zatím neexistuje.",
        "build_running": "Na tomhle materiálu právě běží výroba. Počkej, až doběhne.",
        "edit_in_progress": "Na tomhle materiálu běží úprava podle připomínek. Počkej, až doběhne.",
        "regeneration_in_progress": "Přegenerování už běží.",
        "prerequisite_missing": "Nejdřív musí být schválený materiál, ze kterého tenhle vychází.",
        "reason_required": "Napiš prosím důvod, aspoň pár slov.",
        "state_conflict": "Materiál teď přegenerovat nejde. Zkontroluj stav kroku.",
        "storage_unavailable": "Výrobní linka teď není dostupná. Zkus to prosím za chvíli.",
        "forbidden": "Na tuhle akci nemáš oprávnění."
      }
    }
  }
}
